export const en = {
  app: {
    home: 'Home',
    playerScout: 'Player Scout',
    playerComparison: 'Player Comparison',
    playerRecruitment: 'Radar',
    collections: 'Collections',
    favoritePlayers: 'Favorite Players',
    teamAnalytics: 'Team Analytics',
    gameAnalysis: 'Game Analysis',
    validateEvents: 'Validate Events',
    seasonStats: 'Season Stats',
    leagueTable: 'League Table',
    scoresAndFixtures: 'Scores & Fixtures',
    notifications: 'Notifications',
    administration: 'Administration',
    inbox: 'Inbox',
    teamStats: 'Team Stats',
    blog: 'Blog',
    leagues: 'Leagues',
    squadBuilder: 'Squad Builder',
    playerAlerts: 'Player Alerts',
    searchAlerts: 'Search Alerts',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
  },
  playerRecruitment: {
    title: 'Player Sheet',
    subtitle: "Go deeper into the player's characteristics and statistics",
    league: 'League',
    selectedSeason: 'Selected Season',
    year: 'Year',
    radar: 'Radar',
    positions: 'Positions',
    numberOfPlayers: 'Number of players',
    template: 'Template',
    compareWith: 'Compare with',
    previousPerformance: 'Previous Performance',
    xGames: '{0} games',
    average: 'Average',
    leagueAverage: 'League Average',
    selectSeason: 'Select a season',
    positionsPlayed: 'Positions Played',
    minMax: 'Min & Max',
    top5Leagues: 'Top 5 Leagues',
    infoMessage: 'Check just one season to enable Season Min & Max',
    infoMessage2: 'Select the same season for both players',
    infoMessage3: 'This option is only available from matchday 6',
    dataPer90MinText: 'Data per 90 minutes',
    adjustToPossessionText: '* Adjusted to possession',
    text: 'Text',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: "No games found between selected dates",
    radarTemplates: {
      Goalkeeper: 'Goalkeeper',
      GoalkeeperCustom: 'Goalkeeper Custom',
      GoalkeeperCustom1: 'Goalkeeper Custom 1',
      GoalkeeperCustom2: 'Goalkeeper Custom 2',
      GoalkeeperCustom3: 'Goalkeeper Custom 3',
      GoalkeeperCustom4: 'Goalkeeper Custom 4',
      GoalkeeperCustom5: 'Goalkeeper Custom 5',
      GoalkeeperCustom6: 'Goalkeeper Custom 6',
      Defender: 'Defender',
      DefenderCustom: 'Defender Custom',
      DefenderCustom1: 'Defender Custom 1',
      DefenderCustom2: 'Defender Custom 2',
      DefenderCustom3: 'Defender Custom 3',
      DefenderCustom4: 'Defender Custom 4',
      DefenderCustom5: 'Defender Custom 5',
      DefenderCustom6: 'Defender Custom 6',
      FullBack: 'FullBack',
      FullBackCustom: 'FullBack Custom',
      FullBackCustom1: 'FullBack Custom 1',
      FullBackCustom2: 'FullBack Custom 2',
      FullBackCustom3: 'FullBack Custom 3',
      FullBackCustom4: 'FullBack Custom 4',
      FullBackCustom5: 'FullBack Custom 5',
      FullBackCustom6: 'FullBack Custom 6',
      FullBackPredictive: 'FullBack',
      Midfielder: 'Midfielder',
      MidfielderCustom: 'Midfielder Custom',
      MidfielderCustom1: 'Midfielder Custom 1',
      MidfielderCustom2: 'Midfielder Custom 2',
      MidfielderCustom3: 'Midfielder Custom 3',
      MidfielderCustom4: 'Midfielder Custom 4',
      MidfielderCustom5: 'Midfielder Custom 5',
      MidfielderCustom6: 'Midfielder Custom 6',
      MidfielderPredictive: 'Midfielder',
      MidfielderDefensive: 'Midfielder Defensive',
      MidfielderOffensive: 'Midfielder Offensive',
      AttackingMidfielder: 'Attacking Midfielder',
      MidfielderWing: 'Midfielder Wing',
      Winger: 'Winger',
      WingerCustom: 'Winger Custom',
      WingerCustom1: 'Winger Custom 1',
      WingerCustom2: 'Winger Custom 2',
      WingerCustom3: 'Winger Custom 3',
      WingerCustom4: 'Winger Custom 4',
      WingerCustom5: 'Winger Custom 5',
      WingerCustom6: 'Winger Custom 6',
      WingerOffensive: 'Winger Offensive',
      Forward: 'Forward',
      ForwardCustom: 'Forward Custom',
      ForwardCustom1: 'Forward Custom 1',
      ForwardCustom2: 'Forward Custom 2',
      ForwardCustom3: 'Forward Custom 3',
      ForwardCustom4: 'Forward Custom 4',
      ForwardCustom5: 'Forward Custom 5',
      ForwardCustom6: 'Forward Custom 6',
      ForwardPredictive: 'Forward',
      WingBack: 'WingBack',
      WingBackCustom: 'WingBack Custom',
      WingBackCustom1: 'WingBack Custom 1',
      WingBackCustom2: 'WingBack Custom 2',
      WingBackCustom3: 'WingBack Custom 3',
      WingBackCustom4: 'WingBack Custom 4',
      WingBackCustom5: 'WingBack Custom 5',
      WingBackCustom6: 'WingBack Custom 6',
      WingBackMedia: 'WingBack (SocialMedia)',
      FullBackMedia: 'FullBack (SocialMedia)',
      MidfielderMedia: 'Midfielder (SocialMedia)',
      WingerMedia: 'Winger (SocialMedia)',
      ForwardMedia: 'Forward (SocialMedia)',
      PhysicalWingBack: 'Physical WingBack',
      PhysicalForward: 'Physical Forward',
      PhysicalWinger: 'Physical Winger',
      PhysicalMidfielder: 'Physical Midfielder',
      PhysicalFullBack: 'Physical FullBack',
      PhysicalDefender: 'Physical Defender',
      PhysicalWingBackLMO: 'Physical WingBack',
      PhysicalForwardLMO: 'Physical Forward',
      PhysicalWingerLMO: 'Physical Winger',
      PhysicalMidfielderLMO: 'Physical Midfielder',
      PhysicalFullBackLMO: 'Physical FullBack',
      PhysicalDefenderLMO: 'Physical Defender',
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Goalkeeper',
      Defender: 'Defender',
      FullBack: 'FullBack',
      FullBackPredictive: 'FullBack',
      Midfielder: 'Midfielder',
      MidfielderPredictive: 'Midfielder',
      MidfielderDefensive: 'Midfielder Defensive',
      MidfielderOffensive: 'Midfielder Offensive',
      AttackingMidfielder: 'Attacking Midfielder',
      MidfielderWing: 'Midfielder Wing',
      Winger: 'Winger',
      WingerOffensive: 'Winger Offensive',
      Forward: 'Forward',
      ForwardPredictive: 'Forward',
      WingBack: 'WingBack',
      WingBackMedia: 'WingBack (SocialMedia)',
      FullBackMedia: 'FullBack (SocialMedia)',
      MidfielderMedia: 'Midfielder (SocialMedia)',
      WingerMedia: 'Winger (SocialMedia)',
      ForwardMedia: 'Forward (SocialMedia)',
      PhysicalWingBack: 'Physical WingBack',
      PhysicalForward: 'Physical Forward',
      PhysicalWinger: 'Physical Winger',
      PhysicalMidfielder: 'Physical Midfielder',
      PhysicalFullBack: 'Physical FullBack',
      PhysicalDefender: 'Physical Defender',
      PhysicalWingBackLMO: 'Physical WingBack',
      PhysicalForwardLMO: 'Physical Forward',
      PhysicalWingerLMO: 'Physical Winger',
      PhysicalMidfielderLMO: 'Physical Midfielder',
      PhysicalFullBackLMO: 'Physical FullBack',
      PhysicalDefenderLMO: 'Physical Defender',
    },
    radarDescription: {
      basicStatistics: {
        title: 'BASIC STATISTICS',
        minutes: 'minutes',
        goals: 'goals',
        assists: 'assists',
        redCards: 'red cards',
        yellowCards: 'yellow cards',
        games: 'games',
        goalsReceived: 'non penalty goals received',
        xGFaced: 'xG faced',
      },
      // Inside, Ids of Profiles
      profiles: {
        // GoalKeeperBallPlaying
        3: {
          1: 'Skilled goalkeeper with the ball at the feet, effective in both short and long passes.',
          // 2
          // 3
          // 4
          // 5
          // 6
          // 7
        },
        // DefenderBallWinning
        5: {
          1: 'Defender characterized by going well in one-on-one and performing a large number of tackles and interceptions.',
          // 2
          // 3
          // 4
          // 5
          // 6
          // 7
        },
        // DefenderBallPlaying
        6: {
          1: 'Defense with great contribution to the generation of chances and a good vision of the game.',
        },
        // FullBackMix
        7: {
          1: 'Player with a balanced performance between the offensive game (great contribution in "xG Buildup") and the defensive (high volume of recoveries).',
        },
        // FullBackDefensive
        8: {
          1: 'Solid in defensive one-on-ones and a high volume of recoveries, both for tackles and interceptions.',
        },
        // FullBackOffensive
        9: {
          1: 'Player with great offensive contribution generating dangerous actions and creating chances.',
        },
        // MidfielderBoxToBox
        10: {
          1: 'Complete player capable of covering a lot of space, being able to contribute in recoveries as well as having a relevant percentage of "xG Buildup" with respect to the total of what the team creates.',
        },
        // MidfielderBallWinning
        11: {
          1: 'Midfielder with high defensive performance and great effectiveness in the pass despite limited influence on the attack.',
        },
        // MidfielderHolding
        12: {
          1: 'Complete midfielder with high contribution creating chances and a good aerial efficiency, as well as a lot of interceptions and tackles.',
        },
        // WingerClassic
        15: {
          1: 'Winger with skill in one-on-one and good level of completed crosses, generating more expected assists than shots.',
        },
        // WingerWide
        16: {
          1: 'Player with large volume of through balls and ball progressions, also generating chances and with more influence with possession in the middle than one winger.',
        },
        // WingerInside
        17: {
          1: 'Player with good dribbling skills, frequently cutting inside to generate more shots (xG) than key passes (xA).',
        },
        // ForwardPressing
        18: {
          1: 'Forward who does a great job without the ball, showing good decision-making on when to end the game with a shot or when to pass.',
        },
        // ForwardMobile
        22: {
          1: 'Forward with great mobility to receive through balls, drop to the wing and high level of chances created. High percentage of touches outside the box in relation to the total number of touches per game.',
        },
      },
      description: 'DESCRIPTION',
      // Words
      conjuction: ' and ',
      // ¡¡¡¡ Please, don't remove conjuction2 !!!!
      conjuction2: ' and ',
      over: 'over',
      under: 'under',
      respectively: ', respectively',
      // Categories and quintiles description
      Defending1: {
        1: 'Defensive performance is among the worst in the top 5 leagues',
      },
      Defending2: {
        1: 'The player does not play well defensively since performance is below average',
      },
      Defending3: {
        1: 'The player performs at a medium level, a little over_under_average the average',
      },
      Defending4: {
        1: 'Outstanding work on defensive tasks with above average performance',
      },
      Defending5: {
        1: 'Outstanding in defensive tasks, with a performance similar to that of the best player_positions of the top 5 leagues',
      },
      Saving1: {
        1: 'Goalkeeper with a very low performance, with many difficulties to block the ball',
      },
      Saving2: {
        1: 'Does not show a good performance as a goalkeeper since the level is below average',
      },
      Saving3: {
        1: 'Goalkeeper with acceptable performance, is in the average of the 5 best leagues, having to improve metric_name',
      },
      Saving4: {
        1: 'Goalkeeper with a good level above the average of the 5 best leagues, standing out especially in metric_name',
      },
      Saving5: {
        1: 'Saving is a very complete player, with metrics that place this profile within the Top 20% comparing with the goalkeepers of the top 5 leagues in Europe.',
      },
      Passing1: {
        1: 'With the ball the level is among the worst players',
      },
      Passing2: {
        1: 'As far as passes are concerned, the performance is below average',
      },
      Passing3: {
        1: 'Passing level is acceptable, slightly over_under_average the average',
      },
      Passing4: {
        1: 'Very good level passing the ball, well above average',
      },
      Passing5: {
        1: 'Great effectiveness passing the ball with a performance higher than most players',
      },
      Aerial1: {
        1: 'Very weak player in the aerial game, among the worst in the position in this aspect',
      },
      Aerial2: {
        1: 'As for winning aerial balls, the player does not perform well, below average',
      },
      Aerial3: {
        1: 'Acceptable level in the aerial game, a little over_under_average the average',
      },
      Aerial4: {
        1: 'Great performance in the game from above, with high effectiveness in this regard',
      },
      Aerial5: {
        1: 'Metrics in the aerial game place this profile within the best',
      },
      Shooting1: {
        1: 'Very poor statistics in front of goal, of the worst players in this regard',
      },
      Shooting2: {
        1: 'Very upgradeable shooting level, below average',
      },
      Shooting3: {
        1: 'Acceptable performance in offensive work, slightly over_under_average the average',
      },
      Shooting4: {
        1: 'Performs very well in the box, with a performance above 60% of players',
      },
      Shooting5: {
        1: 'Great skills in offensive tasks, with a spectacular performance, placing this player among the best in this regard',
      },
      Association1: {
        1: 'Performance associating with the ball is very low, among the worst of the top 5 leagues',
      },
      Association2: {
        1: 'There is a lot to improve with the ball at the feet since the performance is below the average in this aspect',
      },
      Association3: {
        1: 'Associates well with the ball, slightly over_under_average the average',
      },
      Association4: {
        1: 'Associates very well with the ball presenting a very remarkable level',
      },
      Association5: {
        1: 'Extraordinary associative ability with the ball at the feet, among the best players',
      },
      BallHandling1: {
        1: 'Terrible ball handling performance, among the worst compared to the 5 top leagues',
      },
      BallHandling2: {
        1: 'As for ball handling, the levels are below average',
      },
      BallHandling3: {
        1: 'Acceptable level handling the ball, slightly over_under_average the average',
      },
      BallHandling4: {
        1: 'High level in terms of ball handling, with figures close to the best in this aspect',
      },
      BallHandling5: {
        1: 'Exceptional ball handling ability, among the best in the 5 top leagues',
      },
      Crosses1: {
        1: 'Low performance crossing the ball into the box. Among the worst players in crossing metrics',
      },
      Crosses2: {
        1: 'Below average performance creating danger with crosses',
      },
      Crosses3: {
        1: 'Acceptable level sending crosses into the box, a bit over_under_average',
      },
      Crosses4: {
        1: 'Good stats crossing the ball, quite above average',
      },
      Crosses5: {
        1: 'Very high performance crossing the ball into the box, specifically, among the top 20% of the most effective profiles in this category',
      },
      Carries1: {
        1: 'Among the 20% of players with the worst numbers in terms of carries',
      },
      Carries2: {
        1: 'Ball driving performance is far from the average for players in this position',
      },
      Carries3: {
        1: 'Close to average performance, slightly over_under_average, in terms of carrying the ball',
      },
      Carries4: {
        1: 'Outstanding player with very good depth and carries numbers',
      },
      Carries5: {
        1: 'Very talented carrying the ball, with a high performance in the metrics of the Carries category',
      },
      Turnovers1: {
        1: 'Performance is very negative with a high volume of turnovers that make it easier for opponents to produce danger. Among the worst in this metric',
      },
      Turnovers2: {
        1: 'The player benefits opponents with numerous dangerous turnovers; a lot of improvement is needed to reduce them',
      },
      Turnovers3: {
        1: 'This player is slightly over_under_average in terms of turnovers, so there is still room for improvement in performance',
      },
      Turnovers4: {
        1: 'Remarkable performance in turnovers, above the 60% of players who lose the fewest balls',
      },
      Turnovers5: {
        1: 'It is worth noting the few turnovers, which place this player within the best players in possession for the team',
      },
      SequenceInvolvement1: {
        1: 'In terms of ball possession, the numbers speak badly of this player, who very rarely finishes actions with a shot',
      },
      SequenceInvolvement2: {
        1: 'Finishing of possessions is quite improvable; they are hardly ever finished with a shot, and that places the performance well below the average',
      },
      SequenceInvolvement3: {
        1: 'Acceptable level when it comes to finishing possessions in front of goal, with a percentile a little over_under_average of the average, having a great possibility of improvement',
      },
      SequenceInvolvement4: {
        1: "Good ability to finish the team's possessions with shots, some of them ending in goals, thus having a remarkable performance in this category",
      },
      SequenceInvolvement5: {
        1: "Among the best when it comes to finishing the team's possessions, consistently ending them with shots that generate danger",
      },
      OutPlay1: {
        1: 'We can identify that the player has minimal impact when it comes to disrupting defensive structures',
      },
      OutPlay2: {
        1: 'Contribution to progression and breaking up defences falls below positional standards',
      },
      OutPlay3: {
        1: 'Capable of generating advantages occasionally, performing around the average for this position',
      },
      OutPlay4: {
        1: 'Frequently contributes to breaking defensive lines and creating imbalances',
      },
      OutPlay5: {
        1: 'Placed among the top performers in the position at eliminating rivals and generating progressions',
      },
      LineBreakingPasses1: {
        1: 'Rarely attempts or completes passes that break defensive lines, with a super scarce contribution in those actions',
      },
      LineBreakingPasses2: {
        1: 'Struggles to consistently find teammates between lines or behind pressure, with a contribution that puts this player below the standards for this position',
      },
      LineBreakingPasses3: {
        1: 'The player provides occasional line-breaking passes, being placed around the average for this position in these terms',
      },
      LineBreakingPasses4: {
        1: 'It can be identified that the player frequently breaks lines with passing and helps unbalance rival blocks',
      },
      LineBreakingPasses5: {
        1: 'Among the most effective passers in the league at breaking lines and unlocking pressure; this is one of the main strengths in the game',
      },
      PassUnderPressure1: {
        1: 'It can be seen that composure and effectiveness decrease when opponents close down',
      },
      PassUnderPressure2: {
        1: 'The player finds trouble maintaining passing accuracy in high-pressure situations',
      },
      PassUnderPressure3: {
        1: 'The player is placed around the average in terms of passing under pressure; pressure is handled reasonably well, though without consistently clean execution',
      },
      PassUnderPressure4: {
        1: 'There is frequent success at finding teammates despite being under pressure, performing above the average in that kind of passes',
      },
      PassUnderPressure5: {
        1: 'Outstanding composure and accuracy when passing under intense pressure, placing the performance among the best in the position in this aspect',
      },
      BallReceived1: {
        1: 'Receives very few passes in advanced areas; not a player who operates between the lines regularly',
      },
      BallReceived2: {
        1: 'Collects some unmarked receptions in the opposition half, but without much consistency',
      },
      BallReceived3: {
        1: 'Records a medium volume of unopposed receptions in attacking zones',
      },
      BallReceived4: {
        1: 'Frequently receives between the lines and in areas free from pressure',
      },
      BallReceived5: {
        1: 'Accumulates many receptions between the lines, free from defenders and in likely key zones',
      },
      OnBallPressure1: {
        1: 'Rarely presses and almost never does so near the ball carrier. Not an intense player',
      },
      OnBallPressure2: {
        1: 'Engages in some strong pressures, but not often. Overall intensity is rather low',
      },
      OnBallPressure3: {
        1: 'Records a medium volume of pressures close to the opponent in possession',
      },
      OnBallPressure4: {
        1: 'Disciplined presser who regularly gets close to the ball carrier',
      },
      OnBallPressure5: {
        1: 'Very intense without the ball, highly disciplined and works hard to press the opponent',
      },
      SpatialCoverage1: {
        1: 'The player shows a very limited contribution to space occupation and control, with minimal involvement in the team’s formation and tactical structure. Spatial coverage is poor both in and out of possession, reflecting little influence on collective organization and compactness',
      },
      SpatialCoverage2: {
        1: 'The player provides below-average spatial coverage, showing some participation in occupying the field but with gaps in positional continuity and cohesion with the rest of the team. Influence on the tactical structure is intermittent and less consistent than that of higher-ranked players',
      },
      SpatialCoverage3: {
        1: 'The player displays average spatial coverage, contributing steadily to space occupation and control. Positioning is generally correct and functional, participating in the team’s tactical structure with a moderate impact in both offensive and defensive phases',
      },
      SpatialCoverage4: {
        1: 'The player offers above-average spatial coverage, showing high involvement in field occupation and the team’s positional structure. The ability to maintain shape and adapt to transitions contributes significantly to compactness and control of key spaces',
      },
      SpatialCoverage5: {
        1: 'The player reaches an excellent level of spatial coverage, optimizing positioning to decisively influence the team’s formation and tactical structure. Game understanding and synchronization with the rest of the block allow maximization of the occupation of strategic spaces, both in attack and defense',
      },
      OffBallPressure1: {
        1: 'The player applies very limited defensive pressure without the ball, rarely engaging opponents to disrupt their actions or force mistakes. Contribution to pressing and defensive structure is minimal',
      },
      OffBallPressure2: {
        1: 'The player provides below-average off-ball defensive pressure, occasionally engaging opponents but with inconsistent timing or positioning. Efforts have a limited impact on regaining possession or disturbing the opposition’s build-up',
      },
      OffBallPressure3: {
        1: 'The player displays an average level of off-ball pressure, contributing steadily to the team’s defensive efforts. Positioning and timing are generally effective, applying adequate pressure to slow down or limit the opposition’s options',
      },
      OffBallPressure4: {
        1: 'The player offers above-average off-ball defensive pressure, frequently disrupting opponents’ actions and reducing their time and space. Efforts are well-timed and coordinated, helping the team maintain a strong defensive structure',
      },
      OffBallPressure5: {
        1: 'The player excels at applying off-ball defensive pressure, consistently harassing opponents, forcing turnovers, and limiting passing lanes. Intensity, positioning, and anticipation significantly enhance the team’s defensive effectiveness',
      },
      Distance1: {
        1: 'The player covers significantly less ground than average (movement on the pitch is very limited)',
      },
      Distance2: {
        1: 'The distance covered per match is below what’s commonly seen in top-level football (not as active as the average)',
      },
      Distance3: {
        1: 'The player covers a reasonable amount of ground, with numbers around the league average (physical involvement is balanced)',
      },
      Distance4: {
        1: 'The player consistently covers high distances, with figures that reflect strong endurance (showing solid physical output)',
      },
      Distance5: {
        1: 'Physical volume is outstanding, among the most active in the top 5 leagues in terms of ground covered',
      },
      Sprint1: {
        1: 'Makes very few high-speed runs compared to the average (the game involves minimal sprinting effort across matches)',
      },
      Sprint2: {
        1: 'Sprint frequency is lower than the average for the position (limited explosiveness in terms of high-speed movements)',
      },
      Sprint3: {
        1: 'Delivers a moderate number of sprints per game, within expected average (values around the average league)',
      },
      Sprint4: {
        1: 'Stands out for the frequency of sprints, well above average. Shows consistent explosiveness, contributing high-speed runs throughout the match',
      },
      Sprint5: {
        1: 'Placed in the top 20% of players with the highest volume of sprints per 90 minutes. Top physical performance in terms of repeated high-speed efforts',
      },
      Acceleration1: {
        1: 'Ability to change pace is clearly below average, with very few explosive accelerations during the match',
      },
      Acceleration2: {
        1: 'Acceleration output is below average compared to similar players because there is limited frequency of short-distance bursts',
      },
      Acceleration3: {
        1: 'Registers a fair number of accelerations, close to league average. Changes of pace do not stand out, but the figures are correct within this metric',
      },
      Acceleration4: {
        1: 'Demonstrates a strong ability to accelerate quickly and repeatedly, with an acceleration rate clearly above average and frequent short bursts',
      },
      Acceleration5: {
        1: 'Among the top 20% of the most explosive players in terms of repeated accelerations, maintaining well above average numbers in quick starts and changes of pace',
      },
      Speed1: {
        1: 'Likely a physically slow player or one who conserves high-intensity efforts during games',
      },
      Speed2: {
        1: 'Records top speeds slightly below the competitive average',
      },
      Speed3: {
        1: 'Maintains average top speed values throughout the match',
      },
      Speed4: {
        1: 'Often reaches high speeds, suggesting a fast and powerful profile',
      },
      Speed5: {
        1: 'Reaches very high top speeds. Likely a difference-maker in terms of pace',
      },
      LineBreakingCarries1: {
        1: 'Rarely breaks lines through carries. Lacks initiative when it comes to advancing with the ball',
      },
      LineBreakingCarries2: {
        1: 'Completes some carries that break lines, but without much regularity',
      },
      LineBreakingCarries3: {
        1: 'Averages a moderate number of successful line-breaking carries',
      },
      LineBreakingCarries4: {
        1: 'Contributes to build-up by frequently carrying past lines and supporting progression',
      },
      LineBreakingCarries5: {
        1: 'A true specialist in carrying. Consistently breaks lines with the ball and at high volume',
      },
      LineBreakingActions1: {
        1: 'Registers very few line-breaking actions (passes and carries). Rarely takes risks',
      },
      LineBreakingActions2: {
        1: 'Produces some progressive actions (passes and carries), but rarely. Tends to play more horizontally',
      },
      LineBreakingActions3: {
        1: 'Combines passes and carries that break lines regularly. Contributes to progression',
      },
      LineBreakingActions4: {
        1: 'Technically skilled and intelligent to produce many actions (passes and carries) that break opposition lines',
      },
      LineBreakingActions5: {
        1: 'A true progression specialist. Has major impact in the team, constantly breaking lines with the ball via passes and carries',
      },
      OffBallRuns1: {
        1: 'The player makes very few purposeful movements without the ball, offering limited support to the attacking phase. Off-ball runs rarely contribute to creating space, disrupting defensive lines, or improving team coordination in possession',
      },
      OffBallRuns2: {
        1: 'The player provides below-average off-ball movement, occasionally supporting the attack but lacking consistency in timing, direction, or tactical intention. Runs have a limited impact on opening spaces or enhancing attacking structure',
      },
      OffBallRuns3: {
        1: 'The player displays an average level of purposeful off-ball runs, contributing steadily to the attacking phase. Movements are generally well-timed and functional, creating space and supporting team play with moderate impact',
      },
      OffBallRuns4: {
        1: 'The player shows above-average off-ball activity, frequently making purposeful runs that disrupt defensive structures, create passing options, and open attacking spaces. Movement patterns contribute significantly to team coordination in possession',
      },
      OffBallRuns5: {
        1: 'The player excels in purposeful off-ball movements, consistently anticipating play and making intelligent runs that maximize attacking opportunities. Timing, positioning, and spatial awareness create constant threats and enhance team fluidity in possession',
      },
      // Highlight metrics description
      OverMaxValue: {
        1: 'There is an extreme ability in over_max_metric_name, with a performance above the maximum value, which places this player in that aspect in the top 10% of the 5 top leagues',
      },
      OverAverageSeason: {
        1: 'Regarding performance in over_average_metric_name, the level is above the league average league_name (over_average_metric_value vs average_metric_value)',
        2: 'Comparing the numbers with those of the league_name league in over_average_metric_name, performance is above average (over_average_metric_value vs average_metric_value)',
      },
      UnderMinValue: {
        1: 'As for under_min_metric_name, it should greatly improve its performance since it places it in the lowest percent_metric_name of the top 5 leagues',
      },
      Over70Percent: {
        1: ', especially standing out in over_70_metric_name with over_70_metric_value per 90 minutes, respectively',
        2: ', above 70% in over_70_metric_name with over_70_metric_value per 90 minutes, respectively',
        3: ', performing a more than remarkable job in over_70_metric_name with over_70_metric_value per 90 minutes, respectively',
      },
      Under30Percent: {
        1: ', having to work harder in under_30_metric_name because with under_30_metric_value per 90 minutes, respectively, the performance is low',
        2: ', having to improve remarkably in under_30_metric_name since with under_30_metric_value per 90 minutes, respectively, the performance is below expected',
        3: ', as for under_30_metric_name with under_30_metric_value per 90 minutes respectively, there is a need to try harder to get better numbers',
      },
      OverAverageSeasonMoreThanOne: {
        1: 'It is good to highlight the performance exceeding the league average league_name in ',
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value on average)',
      },
      Over70PercentIndividualPressure: {
        1: ', making a very good individual pressure for retrieving the ball',
        2: ', high pressure on the opponent to fetch the ball back',
      },
      Under30PercentIndividualPressure: {
        1: ', having to intensify pressure more to recover the ball',
        2: ', having to put more effort in terms of pressuring the rival is concerned',
      },
    },
    himSelf: 'self',
    ownSeason: 'Own Season',
    minMaxTooltip: 'Fit minimun and maximun values of radar',
  },
  login: {
    login: 'Login',
    latestBlogPosts: 'Latest Blog Posts',
    signIn: 'Sign In',
    username: 'Username',
    password: 'Password',
    passwordForgotten: 'Password Forgotten',
    signUp: 'Sign Up',
    enter: 'Enter',
    forceTitle: 'Account in use',
    forceMessage:
      'The account is already connected in other device. Do you want kick it out and connect it in this device?',
    forgotMyPassword: 'Forgot my password',
    firstLogin: 'First Login',
    firstLoginMessage:
      'For security reasons you have to set a new password in your first login. In addition to a preferred language to view the app',
    firstLoginOverview:
      'Here is an overview of your account, the leagues and products you have access to.',
    passwordConfirmation: 'Password Confirmation',
    forgotPasswordMessage:
      'Type your email, if there an valid account associated to the email you will recieve in your inbox the next steps to reset your password',
    resetPassword: 'Reset Password',
    resetPasswordLinkInvalid:
      'This link is invalid or has expired. Request a new password reset from the login page.',
    skipSettings: 'Skip settings',
    contact: 'Contact',
    cookiesText:
      'This site uses Google cookies to provide its services and to analyze your traffic to ensure quality of service, generate usage statistics and detect and address abuses.',
    contactUs: 'Contact Us',
    newsTitle: 'New: Physical Scores!',
    newsText: "We've added two new physical performance Scores alongside our original eventing-data Score: <b>Endurance Score</b> and <b>Speed & Power Score</b>.<br> Endurance highlights players who cover ground consistently and sustain high workloads, while Speed & Power focuses on peak speed, sprints, and explosive accelerations.",
  },
  settings: {
    pageSubtitle: 'Set up your application experience',
    language: 'Language',
    availableLeagues: 'Leagues Available',
    availableSeasons: 'Seasons Available',
    availableProducts: 'Products Available',
    organization: 'Company',
    changePassword: 'Change Password',
    seasonTemplates: 'Season Templates',
    seasonTemplatesSubtitle:
      'Create your own season templates that will be later available to select in Player Ranking and Player Scout',
    templateName: 'Template Name',
    selectTemplate: 'Select existing template to edit',
    radarDefault: 'Default Radar',
    default: 'Default',
    tabs: {
      options: 'Options',
      templates: 'Templates',
      availableLeagues: 'Available Leagues',
      contactData: 'GBE Contact Data',
    },
    contactData: {
      userDetails: 'User Details',
      firstName: 'First Name',
      lastName: 'Last Name',
      contactDetails: 'Contact Details for GBE',
      name: 'Name',
      phone: 'Phone',
      mobile: 'Mobile',
      email: 'Email',
      representativeDetails: 'Representative Details for GBE',
    },
    currency: 'Currency',
    fieldPreferences: 'Field Preferences',
    visualizationsPreferences: 'Visualizations Preferences',
    fieldColor: 'Field Color',
    fieldColors: {
      green: 'Green',
      blue: 'Blue',
      white: 'White',
      black: 'Black',
      grey: 'Grey',
    },
    defaultPlayerVisualization: 'Default Player Visualization',
    appPreferences: 'Application Preferences',
    darkMode: 'Dark Mode',
    showTour: 'Show Guided Tour',
    customStats: 'Custom Stats',
    radarTemplates: 'Radar Templates',
    radarTemplatesSubtitle:
      'Create your own metric templates that will be later available to select in Radars and Ranking',
    radarCategories: {
      Custom1: 'Custom 1',
      Custom2: 'Custom 2',
      Custom3: 'Custom 3',
      Custom4: 'Custom 4',
      Custom5: 'Custom 5',
      Custom6: 'Custom 6',
      Physical: 'Physical',
      CustomPhysical1: 'Custom Physical 1',
      CustomPhysical2: 'Custom Physical 2',
      CustomPhysical3: 'Custom Physical 3',
      CustomPhysical4: 'Custom Physical 4',
      CustomPhysical5: 'Custom Physical 5',
      CustomPhysical6: 'Custom Physical 6',
    },
    templateRemoveTitle: 'Remove Template',
    templateRemoveMsg: 'Do you want to remove this template?',
    templateEditTitle: 'Save Template',
    templateEditMsg:
      'There is an unsaved template, do you want to save it before loading another template?',
    category: 'Category',
    playerRadar: 'Player Radar',
    teamRadar: 'Team Radar',
    statsAlert: 'Insert at least one stat to save',
    recommended: 'Recommended',
    warning:
      'There are positions that have reached the maximum number of radars allowed. Please delete or edit any template',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spanish',
      numeric: 'Numeric',
    },
    showMediaMode: 'Show Media Mode',
    statTemplates: 'Stat Templates',
    statTemplatesSubtitle:
      'Create your own stats template by choosing from several metrics',
    ratingFormat: {
      ratingFormat: 'Rating Format',
      numbers: 'Numbers',
      letters: 'Letters A-F',
    }
  },
  playerDetail: {
    passport: 'Passport',
    secondPassport: 'Second Passport',
    age: 'Age',
    dateOfBirth: 'Date of Birth',
    height: 'Height',
    weight: 'Weight',
    wage: 'Wage',
    history: 'History',
    positions: 'Positions',
    injuries: 'Injuries',
    transfers: 'Transfers',
    nationalTeam: 'National Team',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    contractEnd: 'Contract End',
    yearsOld: ' years old',
    playerAvailability: 'Availability',
    playerUsage: 'Minutes Played',
    usage: 'Usage',
    addToCollection: 'Add to collection',
    performance: 'Performance',
    info: 'Info',
    career: 'Career',
    playerStyle: 'Player Style',
    radar: 'Radar',
    finishingMap: 'Finishing Map',
    threatMap: 'Threat Map',
    keyPassMap: 'Key Pass Map',
    turnoversMap: 'Turnovers and Recoveries',
    beeswarm: 'Ranking',
    allGames: 'All Games',
    eventsMap: 'Events Map',
    lbpMap: 'Line Breaking Passes',
    obpMap: 'On Ball Pressure',
    pupMap: 'Passes Under Pressure',
    obrMap: 'Ball Receipts',
    fullName: 'Full Name',
    academy: 'Academy',
    name: 'Name',
    lastName: 'Last Name',
    playerAvailabilityLong: '% of the season without injuries or suspensions',
    playerUsageLong: 'Minutes Played',
    playerAvailability1: 'games without injuries or suspensions',
    playerAvailability2: 'games this season',
    playerUsage1: 'minutes played',
    playerUsage2: 'total team minutes',
    notMinutesThisSeason: 'Has not played minutes this season',
    seasonPlaceholder: 'There is no active season',
    inactivePlayer: 'Inactive Player',
    inactivePlayerMessage:
      'If you need more information, you can ask for a report',
    goRequest: 'Go To Request',
    warningMinutes:
      'Caution: Less than 450 minutes played, analysis may not be representative',
    scoreWarningMinutes: 'Players with at least 450 total minutes played',
    pdScoreWarningMinutes:
      'Players with at least 450 total minutes played (minimum 60 minutes per game)',
    warningSeasonGames:
      "Season has less than 5 games played, so Min & Max are 'Top 5 Leagues'",
    warningStatsRemoved:
      'Some stats are not shown because they are not available for the selected season',
    warningBeeswarm:
      'Player not shown because there is no data for this stat in the selected season',
    warningPlayersZeroValue: 'Not showing {x} players with 0 ',
    onlyPlayersThatFit: 'Only Players that fit in Radar Template',
    gamesPlayedNotEnough: 'Options disabled due to not enough games played',
    gbe: 'GBE',
    analysis: 'Analysis',
    documents: 'Documents',
    rankDefensive: 'Defensive',
    rankBallHandling: 'Ball Handling',
    rankGoal: 'Goal Contribution',
    rankXt: 'Threat',
    rankIndex: 'Index',
    visitHistory: 'Visit History',
    placer: 'Pitch',
    touchesMap: 'Touches map',
    heatMap: 'Heat Map',
    ageProfile: 'Age Profile',
    strongFoot: 'Strong foot',
    player: 'Player',
    outOf: 'out of',
    in: 'in',
    radius: 'Radius',
    blur: 'Blur',
    careerTable: {
      nationalTeamCareer: 'National Team Career',
      nationalTeamCompetitions: 'National Team Competitions',
    },
    physicalProgression: 'Physical Progression',
    gpi: 'Global Player Index',
    gpiDescription: 'The Global Player Index (GPI) is a standardized player rating system that evaluates footballers based on their team strength, opponent strength, match performances, and availability. Inspired by the Elo rating system, it ensures that player ratings reflect actual competitive environments rather than arbitrary baselines.',
    warningGPI:
      'Available only to players active in ELO leagues in the past 30 days',
    diffGPI: 'Variation from last game',
    rankingInTheWorld: '#{0} in the world',
    rankingInTheLeague: '#{0} in {1}',
    max: 'Max',
    gpiChart:
      "Chart based on the Global Player Index value of the last {0} games",
    percentileRange: "Percentiles {0} to {1}",
    months: 'months',
    month: 'month',
    contractExpOver4Years: 'Contract expire in',
    contractExpSoon: 'Contract will expire soon',
    contractFinalYear: 'Final year of the contract',
    freeAgent: 'Free agent',
    playerProfiles: {
      24: {
        label: 'Sweeper',
        abbreviation: 'LIB',
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR',
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN',
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI',
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON',
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT',
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB',
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR',
      },
      32: {
        label: 'Attacking Full-back',
        abbreviation: 'DPR',
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT',
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY',
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF',
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN',
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC',
      },
      38: {
        label: 'Deep-lying playmaker',
        abbreviation: 'REG',
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS',
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG',
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B',
      },
      42: {
        label: 'Attacking Playmaker',
        abbreviation: 'ROF',
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT',
      },
      44: {
        label: 'Box-to-box',
        abbreviation: 'CAB',
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE',
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES',
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING',
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE',
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR',
      },
      50: {
        label: 'Target',
        abbreviation: 'REF',
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO',
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP',
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN',
      }
    }
  },
  finishingMap: {
    typesOfShot: 'Types of Shot',
    shotStrategy: 'Strategy',
    strategiesCount: '{count} strategies',
    areas: 'Areas',
    bodyPart: 'Body Part',
    more: 'more',
    selectAll: 'Select All',
    minutes: 'Minutes',
    circles: 'Circles',
    boxes: 'Box Heat Map',
    lines: 'Lines',
    games: 'Games',
    perShot: 'per Shot',
    goal: 'Goal',
    missedShot: 'Missed Shot',
    savedShot: 'Saved Shot',
    shotOnPost: 'Shot on Post',
    missedChance: 'Missed Chance',
    openPlay: 'Open Play',
    regularPlay: 'Regular Play',
    fastBreak: 'Fast Break',
    individualPlay: 'Individual Play',
    setPiece: 'Set Piece',
    fromCorner: 'From Corner',
    freeKick: 'Free Kick',
    indirectFreeKick: 'Indirect Free Kick',
    throwInSetPiece: 'Throw In Set Piece',
    inBox: 'In Box',
    goalArea: 'Six-Yard Box',
    boxLeft: 'Box Left',
    boxCenter: 'Box Center',
    boxRight: 'Box Right',
    outOfBox: 'Out of Box',
    outBoxDeepLeft: 'Out of Box Deep Left',
    outBoxDeepRight: 'Out of Box Deep Right',
    outBoxLeft: 'Out of Box Left',
    outBoxCentreLeft: 'Out of Box Centre Left',
    outBoxCentre: 'Out of Box Centre',
    outBoxCentreRight: 'Out of Box Centre Right',
    outBoxRight: 'Out of Box Right',
    left35: '+35 Left',
    centreLeft35: '+35 Centre Left',
    centre35: '+35 Centre',
    centreRight35: '+35 Centre Right',
    right35: '+35 Right',
    head: 'Head',
    rightFooted: 'Right Footed',
    leftFooted: 'Left Footed',
    otherBodyPart: 'Other Body Part',
    chart: {
      shots: 'Shots',
      xGPerShot: 'xG per Shot',
      exceptionTextPenaltyGoals: '* Penalty Shots = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Penalty Shots = 0.765 xGOT',
      exceptionTextOwnGoals: '* Own Goals not taken into account',
      og: 'OG',
      penaltiesExcluded: 'Penalty Goals Excluded',
      ownGoalsExcluded: 'Own Goals Excluded',
      sumOfxG: 'Sum of xG',
      exceptionShotsOutOfRange: '* Not showing shots out of range',
    },
    inGoal: 'In Goal',
    outOfGoal: 'Out of Goal',
    highLeft: 'High Left',
    highCenter: 'High Center',
    highRight: 'High Right',
    lowLeft: 'Low Left',
    lowCenter: 'Low Center',
    lowRight: 'Low Right',
    outHighLeft: 'Out High Left',
    high: 'Out High Center',
    outHighRight: 'Out High Right',
    closeHighLeft: 'Close High Left',
    closeHigh: 'Close High Center',
    closeHighRight: 'Close High Right',
    closeLeft: 'Close Low Left',
    closeRight: 'Close Low Right',
    finishingTable: 'Finishing Table',
    onGoal: 'On Goal',
    distributionFilters: 'Distribution Filters',
    penalty: 'Penalty',
    penaltyShootout: 'Penalty Shootout',
    onlyPercentage: 'Show Percentage',
    showAll: 'Show All',
    chanceMissed: 'Chance Missed',
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Key Passes',
      xAPerPass: 'xA per Pass',
      xAOpenPlay: 'xA Open Play',
      xASetPiece: 'xA Set Piece',
    },
  },
  beeswarm: {
    template: 'Template',
    templates: {
      Goalkeeper: 'Goalkeeper',
      Defender: 'Defender',
      'Full-Back': 'Full-Back',
      FullBack: 'Full-Back',
      'Wing-Back': 'Wing-Back',
      WingBack: 'Wing-Back',
      Midfielder: 'Midfielder',
      AttackingMidfielder: 'Attacking-Midfielder',
      Winger: 'Winger',
      Forward: 'Forward',
      Physical: 'Physical',
    },
    compareWith: 'Compare to',
    highlightPlayersOf: 'Highlight Players of',
    highlightPlayers: 'Highlight Players',
    per90: 'Data per 90 minutes',
    highlightTeams: 'Highlight Teams',
    filterTeams: 'Filter Teams',
    warningZeros: 'Only for non reverse stats',
  },
  collections: {
    newCollection: 'New collection',
    editCollection: 'Edit collection',
    name: 'Name',
    visibility: 'Visibility',
    privacity: {
      publicTitle: 'Public',
      publicDescription: 'Visible for you and your club',
      privateTitle: 'Private',
      privateDescription: 'Only visible for you',
      supervisedTitle: 'Supervised',
      supervisedDescription: 'Only visible for you and your supervisor',
    },
    addSuccess: 'Added successfully',
    createAddSuccess: 'Created and added successfully',
    editSuccess: 'Updated successfully',
    deleteSuccess: 'Deleted successfully',
    title: 'Collections of players',
    publics: 'Publics',
    privates: 'Privates',
    supervised: 'Supervised',
    totalMarketValue: 'Total market value',
    avgMarketValue: 'Average market value',
    avgAge: 'Average age',
    searchBarPlaceholder: 'To add to the colecction, search and choose players',
    deleteCollection: 'Delete collection',
    deleteCollectionMessage: 'Collection will be removed, are you sure?',
    removePlayer: 'Remove player',
    removePlayerMessage:
      'Player will be removed from collection, are you sure?',
    subtitle: 'Organize your scouting',
    notExitingTemplate: 'There are still no templates',
  },
  searchbar: {
    placeholder: 'Type to search (e.g. `david arsenal´)',
    players: 'Players',
    teams: 'Teams',
    games: 'Games',
    leagues: 'Leagues',
    explore: 'Explore more results',
    placeholderNoResults: 'No results for template',
    teamPlaceholder: 'To compare a team, search and select it',
  },
  favorites: {
    showOnly: 'Show only',
    selfFavorites: 'My favorites',
    clubFavorites: 'Club favorites',
    contractExpiration: 'Contract expiration',
    groupBy: 'Group by',
    noGrouped: 'None',
    maxSelection: 'Only can select',
    selectAtleastOne: 'At least select one',
    comparePlayers: 'Compare players',
    selectedPlayers: 'players selected',
    subtitle: 'Manage your favorites',
    generateXlsx: 'Generate XLSX',
    generating: 'Generating...',
    subscribed: 'Subscribed',
    subscribedTooltip:
      'Subscribe to recieve a mail when a game have been played',
    deleteSelected: 'Delete selected',
  },
  expiration: {
    summer: 'Summer',
    winter: 'Winter',
  },
  positions: {
    noposition: 'No Position',
    goalkeeper: 'Goalkeeper',
    goalkeepers: 'Goalkeepers',
    defender: 'Defender',
    defenders: 'Defenders',
    defenses: 'Defenders',
    fullback: 'FullBack',
    fullbacks: 'FullBacks',
    midfielder: 'Midfielder',
    midfielders: 'Midfielders',
    winger: 'Winger',
    wingers: 'Wingers',
    forward: 'Forward',
    forwards: 'Forwards',
    wingback: 'WingBack',
    wingbacks: 'WingBacks',
  },
  dPos: {
    // Dallas Positions
    1: { name: 'Goalkeeper', alias: '' },
    2: { name: 'Right Full Back', alias: 'RFB' },
    3: { name: 'Right Center Back', alias: 'RCB' },
    4: { name: 'Left Center Back', alias: 'LCB' },
    5: { name: 'Left Full Back', alias: 'LFB' },
    6: { name: 'Defensive Midfielder', alias: 'DM' },
    7: { name: 'Right Winger', alias: 'RW' },
    8: { name: 'Center Midfielder', alias: 'CM' },
    9: { name: 'Striker', alias: 'ST' },
    10: { name: 'Attacking Midfielder', alias: 'AM' },
    11: { name: 'Left Winger', alias: 'LW' },
  },
  charts: {
    seasonsCompareSelectLabel: 'Compare with',
    lastSeasonSelectText: 'Last Season',
    lastAndCurrentSeasonSelectText: 'Last + Current Season',
    currentSeasonSelectText: 'Current Season',
    lastNgamesSelectText: 'Last {x} games',
    npgVsXGTitle: 'Non-Penalty Goals VS xG',
    totalXGLabel: 'Total xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Total Non-Penalty Goals',
    xGAgainstvsNPGAgainstTitle: 'xG Against VS Non-Penalty Goals Against',
    totalXGAgainstLabel: 'Total xG Against',
    xGAgainstLabel: 'xG Against',
    totalNPGAgainstLabel: 'Total Non-Penalty Goals Against',
    xGvsxGAgainstTitle: 'xG VS xG Against',
    pointsVsXPointsTitle: 'Points VS Expected Points',
    xTTitle: 'Game Flow',
    totalXPoints: 'Total xPoints',
    totalPoints: 'Total Points',
    requestedReports: 'Reports Requested',
    playersScouted: 'Players Scouted',
    performanceVSAverageChart: 'Performance VS Average',
    perPositions: 'Per Positions',
    perLeagues: 'Per Leagues',
    perMonths: 'Per Months',
    perClients: 'Per Clients',
    ofPreposition: 'of',
    idJChartTitle: 'Game Initiative',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Offensive Game Volume',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: 'Offensive Game Precision',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: 'Offensive Game Progression',
    proJOChartLabel: 'Index OGPro',
    chart: 'Chart',
    table: 'Table',
    showLeaguesWithAtLeast: 'Show leagues with at least',
    playersScoutedSuffix: 'players scouted',
  },
  table: {
    history: {
      season: 'Season',
      team: 'Team',
      position: 'Position',
      side: 'Side',
      games: 'Games',
      minutes: 'Mins',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Games Missed',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Season',
      team: 'Team',
      injury: 'Injury',
      dateFrom: 'Start Date',
      dateTo: 'End Date',
      daysLost: 'Days Lost',
      gamesLost: 'Games Lost',
      allInjuries: 'All Injuries',
    },
    transfers: {
      season: 'Season',
      date: 'Date',
      teamFrom: 'Team From',
      teamTo: 'Team To',
      marketValue: 'Market Value',
      fee: 'Fee',
      type: 'Type',
    },
    caps: {
      team: 'Team',
      debut: 'Debut',
      games: 'Games',
      goals: 'Goals',
      coachDuringDebut: 'Coach During Debut',
      debutAge: 'Debut Age',
    },
    roster: {
      country: 'Country',
      player: 'Player',
      positions: 'Positions',
      minutes: 'Minutes',
      games: 'Games',
      goals: 'Goals',
      assists: 'Assists',
      cards: 'Cards',
      gamesExplicit: 'Games Played',
    },
    league: {
      title: 'League Sheet',
      subtitle: "Go deeper into the league's ranking and statistics",
      team: 'Team',
      games: 'GP',
      gamesExplicit: 'Games Played',
      gamesRanking: 'GP',
      gamesRankingExplicit: 'Games Played',
      points: 'Pts',
      pointsExplicit: 'Points',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Expected Points',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Non-Penalty Goals',
      xG: 'xG',
      xGExplicit: 'Expected Goals',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Non-Penalty Goals Against',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Expected Goals Against',
      xGAgainstDiff: 'xGA Diff',
      xGAgainstDiffExplicit: 'Expected Goals Against Difference',
      form: 'Form',
      sos: 'SoS',
      sosExplicit: 'Strength of Schedule',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Home Field Advantage',
      difficultyAboveAvg: 'Difficulty above average',
      differentGames: '* Different Number of Games Played',
      berth: 'Berth',
    },
    usersOfClient: {
      userName: 'Name',
      userRole: 'User',
      devRole: 'Dev',
      adminRole: 'Admin',
      servicesRole: 'Services',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elevens',
      similarityRole: 'Similarity',
      gameAnalysisRole: 'Game Analysis',
      clientStatsRole: 'Client Stats',
      created: 'Created',
      type: 'Type',
      logins: 'Logins',
      lastLogin: 'Last Login',
      trialDate: 'Trial Date',
    },
    clientLeagues: {
      league: 'League',
      area: 'Area',
      tier: 'Tier',
      seasons: 'Seasons',
      currentMatchDay: 'Match day',
      regular: 'Regular',
      youthLeague: 'Youth',
      clientActive: 'Active',
      visibleLeagues: 'Visible Leagues',
      male: 'Men\'s league',
      female: 'Women\'s league',
    },
    connections: {
      title: 'Common Combinations',
      playerFrom: 'From Player',
      playerTo: 'To Player',
      passes: 'Passes',
      passesTooltip: 'Total Number of Successful Passes',
      passesFinalThird: 'PF ⅓',
      passesFinalThirdTooltip: 'Passes Final Third',
    },
    playerPassMapData: {
      title: 'Passing Stats',
      player: 'Player',
      passes: 'Passes',
      passesPct: '% Passes',
      xA: 'xA',
      xG: 'xG',
      xT: 'xThreat',
      playerTooltip: 'Name of Player',
      passesTooltip: 'Total Number of Passes',
      passesPctTooltip: '% Successful Passes',
      xATooltip: 'Expected Assists',
      xGTooltip: 'Expected Goals',
      xTTooltip: 'Expected Threat',
    },
    playerAllGames: {
      gameDate: 'Date',
      game: 'Game',
      team: 'Team',
      positionsPlayed: 'Positions',
      minsPlayed: 'Minutes',
      gameActions: 'Actions',
      gameDateTooltip: 'Date Game',
      gameTooltip: 'Game',
      positionsPlayedTooltip: 'Positions Played',
      minsPlayedTooltip: 'Minutes Played',
      gameActionsTooltip: 'Goals, Assists, Cards',
      from: 'Start',
      to: 'End',
      goalText: 'Goal at',
      assistText: 'Assist at',
      penaltyText: 'Penalty at',
      ownGoalText: 'Own Goal at',
      yellowCardText: 'Yellow Card at',
      secondYellowCardText: 'Second Yellow Card at',
      redCardText: 'Red card at',
      substitutionIN: 'In at',
      substitutionOUT: 'Out at',
      suspendedText: 'Suspension',
    },
    gameFlow: {
      phase: 'Phase ',
      mins: 'Minutes',
      team: 'Team',
      period: 'Period',
      possession: '%Poss.',
      possessionTooltip: '% Possession',
      xT: 'xThreat',
      xTTooltip: 'Expected Threat',
      pft: 'PF ⅓',
      pftTooltip: 'Passes Final Third',
      xG: 'xG',
      xGTooltip: 'Expected Goals',
    },
  },
  game: {
    title: 'Game Sheet',
    subtitle: "Go deeper into the game's characteristics and statistics",
    header: {
      gameDetails: 'Details',
      gameStats: 'Stats',
      gameFinishingMap: 'Finishing Map',
      gameKeyPassMap: 'Key Pass Map',
      gamePassMap: 'Pass Map',
      gameThreat: 'Game Threat',
      gameFlow: 'Game Flow',
      gameAnalysis: 'Game Analysis',
      gamePhysicalStats: 'Physical Stats',
      possessions: 'Possessions',
      bench: 'Bench',
      video: 'Video highlights',
      preGame: 'Pre-match',
      postGame: 'Post-match',
      areaCoverage: 'Area coverage'
    },
    status: {
      scheduled: 'Scheduled',
      postponed: 'Postponed',
      cancelled: 'Cancelled',
      inPlay: 'Live',
      finished: 'Finished',
      awarded: 'Awarded',
      dataAvailable: 'Data will be available in the next hours'
    },
    avgScoreTooltip: 'Average score per minutes',
    passMap: {
      typeOfPlay: 'Type of play:',
      passes: 'Passes:',
      team: 'Team',
      minutes: 'Minutes:',
      minuteRange: 'Minute range',
      select: 'Select',
      all: 'All',
      attacking: 'Attacking',
      defending: 'Defending',
      forwards: 'Forward',
      backwards: 'Backwards',
      sideways: 'Sideways',
      longBall: 'Long Ball',
      successfullPasses: 'Successfull Passes',
      homeTeam: 'Home',
      awayTeam: 'Away',
      passingMatrix: 'Passing Matrix',
      passer: 'Passer',
      receiver: 'Receiver',
      passOutcome: 'Pass Outcome',
      passDirection: 'Pass Direction',
      half: 'Half',
      offensive: 'Offensive',
      defensive: 'Defensive',
      passingConnections: 'Passing Connections',
      pitchView: 'Map',
      passSingular: 'Pass',
      passPlural: 'Passes',
      playerLocation: 'Player Location',
      passLegend: 'Average Touch Position',
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: 'Possession',
      expectedPoints: 'Expected Points',
      directness: 'Directness',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Set Piece',
      xA: 'xA',
      xASetPiece: 'xA Set Piece',
      xT: 'xT',
      xTSetPiece: 'xT Set Piece',
      touchesInOppBox: 'Touches in Opponent Box',
      passesFinalThird: 'Passes Final Third',
      interceptions: 'Interceptions',
      recoveries: 'Recoveries',
      recoveriesRate: 'Recovery Rate',
      turnoversRate: 'Turnover Rate',
      recoveriesOppHalf: 'Recoveries Opponent Half',
      tackles: 'Tackles',
      tacklesWasDribbled: '1vs1 Defensive Win %',
      fouls: 'Fouls',
      yellowCards: 'Yellow Cards',
      redCards: 'Red Cards',
      passes: 'Passes',
      passing: 'Passing %',
      crosses: 'Crosses',
      crossing: 'Crossing %',
      shots: 'Shots',
      shotsOnTarget: 'Shots on Target',
      ppdaExplicit: 'Conceded Passes per Defensive Action',
      xgExplicit: 'Expected Goals',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Competition Avg.',
      winChanceTooltip: 'Win probability based on xG generated and conceded',
      drawChance: 'Draw',
      xgAgainst: 'xG Against',
      averagePossession: 'Possession',
      averageShots: 'Shots',
      averagexG: 'Expected Goals',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
    },
    detail: {
      halfTime: 'Half Time',
      overTime: 'Over Time',
      showStats: 'Show Stats',
      hideStats: 'Hide Stats',
      bench: 'Bench',
      showShotOptions: 'Show Shot Options',
      hideShotOptions: 'Hide Shot Options',
      showPassOptions: 'Show Pass Options',
      hidePassOptions: 'Hide Pass Options',
      endGame: 'Full Time',
      penalties: 'Penalties',
    },
    timeline: {
      gameTimeline: 'Game Timeline',
      events: {
        goal: 'Goal',
        goal_ownGoal: 'Own Goal',
        goal_penalty: 'Penalty Kick Goal',
        card: 'Card',
        card_yellowCard: 'Yellow Card',
        card_secondYellowCard: 'Second Yellow Card',
        card_redCard: 'Red Card',
        formationChange: 'Formation Change',
        substitution: 'Substitution',
        saveShot: 'Saved Shot',
        saveShot_penalty: 'Saved Penalty Kick',
        missedShot: 'Missed Shot',
        missedShot_penalty: 'Missed Penalty Kick',
        shotOnPost: 'Shot on Post',
        shotOnPost_penalty: 'Shot on Post Penalty Kick',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist',
      },
    },
    gameFlow: {
      goalOf: 'Goal of ',
      redCardTo: 'Red Card to ',
      missedPenalty: 'Missed penalty',
    },
    gameThreat: {
      typeOfPlay: 'Type of Action',
      regularPlay: 'Regular Play',
      setPiece: 'Set Piece',
      setPiecePlay: 'Set Piece',
      throwInSetPiecePlay: 'Throw In Play',
      throwInPlay: 'Throw In Play',
      gkThrow: 'Goalkeeper Throw',
      gkKick: 'Goalkeeper Kick',
      kickOff: 'Kick Off',
      actionEnding: 'Action Ending',
      pass: 'Pass',
      shot: 'Shot',
      foul: 'Foul',
      other: 'Other',
      threat: 'Threat',
      legendSumOfXT: 'Sum of xT',
      legendPass: 'Pass',
      legendShot: 'Shot',
      legendCarryAndAction: 'Carry and Action',
      legendCarryAndPass: 'Carry and Pass',
      legendOnlyShowing: 'Only showing individual actions with xT > ',
      legendOnlyShowingPart1: 'Only showing individual',
      legendOnlyShowingPart2: 'actions with xT > ',
      legendOnlyShowingSetPiece: 'Only showing Set Piece actions with xT > ',
      legendOnlyShowingOpenPlay: 'Only showing Open Play actions with xT > ',
      legendPlays: 'Actions',
      legendPerPlay: 'per Action',
      legendCarry: 'Carry',
      penaltyPlay: 'Penalty',
      freeKickTakenPlay: 'Free Kick Play',
      cornerTakenPlay: 'Corner Play',
      fromCornerPlay: 'Corner Play',
      keeperThrowPlay: 'Keeper Throw Play',
      fastBreakPlay: 'Fast Break Play',
      indirectPlay: 'Indirect Play',
      minutes: 'Minutes',
      games: 'Games',
      xT: 'xT',
      xTPer90: "xT per 90'",
    },
    preGameAnalysis: {
      showExpectations: 'Show Expectations',
      hideExpectations: 'Hide Expectations',
      goalsPeriods: 'Goals Periods',
      synergyIndex: 'Synergy Index',
      synergyIndexSubtitle: 'Overall strength of the passer-finisher connection'
    },
    gameAnalysis: {
      next: 'Next',
      previous: 'Previous',
      phaseLabel: 'Phase',
      phasesLabel: 'Phases',
      dot: '. ',
      comma: ', ',
      from: 'From',
      to: 'To',
      and: ' and ',
      steps: {
        finishingMapFullGame: 'Finishing Map',
        keyPassMapFullGame: 'Key Pass Map',
        gameFlow: 'Game Flow',
        finishingMapPerPhases: 'Finishing Map per Phases',
        keyPassMapPerPhases: 'Key Pass Map per Phases',
        passMapPerPhases: 'Pass Map per Phases',
      },
      step1: {
        table: {
          draw: 'Draw',
          win: 'Win',
          lose: 'Lose',
          possession: 'Possession',
          xP: 'Expected Points',
          directness: 'Directness',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Open Play',
          xGSetPiece: 'xG Set Piece',
          xA: 'xA',
          xAOpenPlay: 'xA Open Play',
        },
        text: {
          firstParagraph: {
            1: 'The map on the right displays the expected goals generated by home_team_name and away_team_name. The refilled circles are the shots that ended in goal. The size of the circles depends on the xG value of each shot. ',
          },
          lastParagraph: {
            1: 'The probability percentage of a result and the number of expected points are calculated through shot simulation (100,000 simulations of the shots are carried out and the possibility of results and of getting points is evaluated in a predictive way). ',
          },
          targetHighTeamXG: {
            1: 'target_team_name, as well as rival_team_name, managed to create a high volume of expected goals',
          },
          targetHighTeamOpenPlayXG: {
            1: ', with most of the target_team_name chances coming from open plays',
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: ', but performed better at generating open play chances',
          },
          targetHighTeamSetPieceXG: {
            1: ', with most of the target_team_name chances coming from set pieces',
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: ', but performed better at generating chances from set pieces',
          },
          targetHighTeamCornerXG: {
            1: ', with most of the chances coming from corner kicks',
          },
          targetLowTeamGoalConversion: {
            1: ', although the chances conversion was below expected',
          },
          dot: {
            1: '. ',
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name created a high volume of expected goals in both open plays and set pieces',
          },
          targetHighTeamGoalConversion: {
            1: ' also having a high goal conversion ratio. ',
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', not being able to score any of the chances created',
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' but created danger to score more goals',
          },
          targetHighTeamXGvsGameRival: {
            1: 'In this game, target_team_name generated more danger than rival_team_name',
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' and could have scored more goals. ',
          },
          targetHighTeamXGZeroGoals: {
            1: ' but was not able to score any goals out of the chances created. ',
          },
          targetHighTeamXGGoalDiff: {
            1: ' matching a winning chance of team_winning_chance according to our post-game simulation. ',
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' Most of the target_team_name chances came from open plays. ',
          },
          startTargetHighTeamSetPieceXG: {
            1: ' Most of the target_team_name chances were originiated by set piece plays. ',
          },
          startTargetHighTeamCornerXG: {
            1: ' Most of the chances came from corner kicks. ',
          },
          targetSimilarTeamXG: {
            1: 'In this game, both teams generated a similar amount of danger to the opponent in terms of xG, ',
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'but target_team_name performed better at finalizing chances. ',
          },
          targetLowTeamXGGoalDiff: {
            1: 'Regardless the result, target_team_name did not generate much danger to the opponent in terms of Expected Goals. ',
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name did not generate enough danger to the opponent in terms of Expected Goals to win the game',
          },
          rivalHighTeamXG: {
            1: 'and allowed rival_team_name to generate too much danger. ',
          },
          rivalHighTeamXGGoalDiff: {
            1: ' With this creation, this is a game that target_team_name would only win team_winning_chance of the times according to our post-game simulation. ',
          },
          targetHighTeamOpenPlayXG: {
            1: 'In this game, most of target_team_name chances came from open plays',
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'In this game, most of target_team_name chances were originiated by open plays (unlike rival_team_name)',
          },
          targetHighTeamSetPieceXG: {
            1: 'In this game, most of target_team_name chances came from set piece plays',
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'In this game, most of target_team_name chances were originiated by set piece plays (unlike rival_team_name)',
          },
          targetHighTeamCornerXG: {
            1: 'In this game, most of target_team_name chances came from corner kicks',
          },
          targetHighTeamGoalConversion2: {
            1: ' having a high goal conversion ratio',
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', not being able to score any of the chances created',
          },
          targetLowTeamGoalConversion: {
            1: ' but the goal conversion was low',
          },
          winningChance: {
            1: 'Given the number of shots and xG of both teams, target_team_name should have won this game team_winning_chance of the times. ',
          },
          highPlayerXGManyShots: {
            1: 'It is interesting to note that player_name generated xg_value xG in shots_value shots',
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' needing xg_value xG to score a goal. ',
          },
          highPlayerXGOneGoal: {
            1: ' to score the goal. ',
          },
          highPlayerXGAnyGoal: {
            1: ', although this did not result in any goal. ',
          },
          highPlayerXGNotManyShots: {
            1: 'It is worth mentioning that player_name generated xg_value xG in a few shots',
          },
          highManyPlayerXG: {
            1: 'It is interesting to note that player_name and player_name2 generated xg_value and xg_value2 <b>xG</b> respectively. ',
          },
          highTeamXGPerShot: {
            1: 'Regarding the selection of shots taken by target_team_name, they were very good in terms of probability of becoming a goal, with an average xG per shot of xg_per_shot_value. ',
          },
          highTeamXGPerShotVSGameRival: {
            1: 'The selection of shots of target_team_name was much better than rival_team_name, having an average of xg_per_shot_value xG per shot. ',
          },
          xGTimesNotAfter70xG: {
            1: 'Despite the high xG generated, target_team_name had problems to create danger at the end of the game. ',
          },
          xGTimesBefore25xG: {
            1: 'target_team_name created a lot of danger especially at the beginning of both halves. ',
          },
          xGTimesAfter25xG: {
            1: 'target_team_name created a lot of danger especially at the end of both halves. ',
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name created most of the danger at the beginning of the first half. ',
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name created most of the danger at the end of the first half. ',
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name created most of the danger at the beginning of the second half. ',
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name created most of the danger at the end of the second half. ',
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name started the game very solid with chances that generated xg_value expected goals. ',
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name finished the first half of the game with chances that generated xg_value expected goals. ',
          },
          xGTimesBefore70xG: {
            1: 'target_team_name came off the half-time break with chances that generated xg_value expected goals. ',
          },
          xGTimesAfter70xG: {
            1: 'target_team_name finished the second half with chances that generated xg_value expected goals. ',
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the end of the second half. ',
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the beginning of the second half. ',
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the end of the first half. ',
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name created a lot of danger at the beginning of the first half. ',
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name generated most of its danger in the first half while rival_team_name did the same in the second half. ',
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name generated most of its danger in the second half while rival_team_name did the same in the first half. ',
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the first half. ',
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the second half. ',
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name managed to create most of the danger in the first half. ',
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name managed to create most of the danger during the second half. ',
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name allowed most of the danger in terms of Expected Goals in the first half. ',
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name allowed most of the danger in terms of Expected Goals during the second half. ',
          },
          highInBoxXG: {
            1: 'The shot map displays how most of the danger came from shots inside the box. ',
          },
          highOutOfBoxXG: {
            1: 'It can be observed in the shot map that, in this game, target_team_name generated a lot of danger from outside the box. ',
          },
          highInBoxXGRival: {
            1: 'We want to point out that, most of the danger conceded by target_team_name came from shots inside the box. ',
          },
          highInBoxXGRival2: {
            1: ' It is also interesting to highlight that most of the danger conceded by target_team_name came from shots inside the box. ',
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name performed well avoiding danger inside the box. ',
          },
          highTeamChancesHighPPDARival: {
            1: 'The lack of pressure of target_team_name, allowing ppda_value Passes per Defensive Action, was one of the keys for rival_team_name to create a high number of chances. ',
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name only allowed ppda_value Passes per Defensive Action being this one of the keys to victory. ',
          },
          lowPPDA: {
            1: 'target_team_name did a great job at interrupting the plays of rival_team_name allowing only an average of ppda_value Passes per Defensive Action. ',
          },
          highPossession: {
            1: 'target_team_name had the control of the ball with a possession_value of possession',
          },
          highPPDARival: {
            1: ' as well as a fluid distribution of the ball',
          },
          chancesCreated: {
            1: ', which allowed them to have a high number of open play chances (chances_value). ',
          },
          chancesCreatedRival: {
            1: ', although rival_team_name was able to create a high number of open play chances (chances_value). ',
          },
          xGPerShotRival: {
            1: ', although rival_team_name was able to create more dangerous chances with a xg_per_shot_value xG per Shot. ',
          },
          winGame: {
            1: ' being one of the keys to win the game. ',
          },
          notEnoughWinGame: {
            1: ' not being enough to win the game. ',
          },
          goalsFromErrorsFirstGoal: {
            1: 'The first goal came from a mistake of player_error_name seized by player_name',
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'The first and only goal came from a mistake of player_error_name seized by player_name',
          },
          lastPhaseOfGame: {
            1: ' at the last phase of the game. ',
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'The final goal to win the game came from a mistake of player_error_name that led to the goal of player_name. ',
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'The final goal to tie the game came from a mistake of player_error_name that led to the goal of player_name. ',
          },
          goalsFromErrorsGoalToTie: {
            1: 'An error from player_error_name led to a chance to tie the game for target_team_name. ',
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name took the lead taking advantage of an error from player_error_name',
          },
          xGChance: {
            1: ' with a chance of xg_value xG. ',
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'The final goal of rival_team_name to win the game came from a mistake of player_error_name that led to the goal of player_name. ',
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'An error from player_error_name led to a chance to tie the game for rival_team_name. ',
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name took the lead taking advantage of an error from player_error_name',
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name happened to score the only big chance that created during the game, that is the goal of player_name that we see in the xG map with an xG of xg_value. ',
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name happened to score all the big chances that created during the game',
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name had the only great chance of target_team_name to score with an xG of xg_value. ',
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name  was not able to score any of the chances_value chances above 40% of likelihood to become a goal. ',
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name had a great chance of xg_value xG to get ahead in the score. ',
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value chances with xG above 40% to get ahead in the score. ',
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value chances with high xG to get ahead in the score. ',
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name had a chance to get ahead in the score of xg_value xG that hit the post. ',
          },
          beforeEndOfGame: {
            1: 'Before the end of the game, ',
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name had a chance of xg_value xG to win the match. ',
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value chances with an xG above 40% to win the match. ',
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value chances with high xG to win the match. ',
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name had a great chance of xg_value xG to get ahead in the score. ',
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value chances with xG above 40% to get ahead in the score. ',
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value chances with high xG to get ahead in the score. ',
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name had a chance to get ahead in the score of xg_value xG that hit the post. ',
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name had a chance of xg_value xG to tie the game with no luck. ',
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name had chances_value chances to tie the game with a probability to score higher than 30%. ',
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name had a chance of xg_value xG to tie the game that ended hitting the post. ',
          },
        },
      },
      step2: {
        table: {
          draw: 'Draw',
          win: 'Win',
          possession: 'Possession',
          xP: 'Expected Points',
          directness: 'Directness',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Open Play',
          xASetPiece: 'xA Set Piece',
          chancesCreated: 'Chances Created',
          shotsOnTarget: 'Shots on Target',
        },
        text: {
          firstParagraph: {
            1: "This image shows the expected assists of <b style='color:home_color'>home_team_name</b> and <b>away_team_name</b>.",
          },
          xAPerKeyPass: {
            1: ' xA per Key Pass. ',
          },
          keyPassesGeneratedFrom: {
            1: ', especially key passes generated from ',
          },
          highTeamXAvsXG: {
            1: 'As the xA map shows, most of the danger created by target_team_name comes from combination plays rather than individual actions',
          },
          openPlay: {
            1: 'open plays',
          },
          setPiece: {
            1: 'set piece plays',
          },
          cornerKicks: {
            1: 'corner kicks',
          },
          combinationPlays: {
            1: 'combination plays',
          },
          dot: {
            1: '. ',
          },
          comma: {
            1: ', ',
          },
          averageTeamXAvsXG: {
            1: 'In this game, target_team_name generated danger from both combination plays',
          },
          individualActions: {
            1: ' and individual actions. ',
          },
          dangerFromIndividualActions: {
            1: 'In this game, most of the danger generated by target_team_name came from individual actions.',
          },
          highTeamXAvsXGRival: {
            1: ' The chances that target_team_name allowed during the game were coming from combination plays as the xA map displays.',
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name was strong at key passes coming from ',
          },
          manyPlayerKeyPasses: {
            1: 'It is interesting to note that player_name created xa_value xA in key_passes key passes',
          },
          playerAssists: {
            1: ' needing xa_per_assist xA per assist.',
          },
          giveAssist: {
            1: ' to give the assist.',
          },
          noAssists: {
            1: ', although none of these passes ended up in an assist.',
          },
          highXANotManyShots: {
            1: 'It is interesting to note that player_name created xa_value xA in a few passes',
          },
          manyPlayersHighXA: {
            1: 'It is interesting to note that player_name and player_name2 generated xa_value and xa_value2 xA respectively.',
          },
          xATimes: {
            1: 'target_team_name generated most of its danger in the first half while rival_team_name did the same in the ',
          },
          firstHalf: {
            1: ' first half. ',
          },
          secondHalf: {
            1: ' second half. ',
          },
          left: {
            1: 'left side ',
          },
          center: {
            1: 'center ',
          },
          right: {
            1: 'right side ',
          },
          xAFirstHalfFirstHalfRival: {
            1: 'It is a game where most of the danger in terms of Expected Goals was generated during the ',
          },
          xAFirstHalf: {
            1: 'target_team_name managed to create most of the danger in the ',
          },
          xATimesXARival: {
            1: 'target_team_name allowed too much danger in terms of Expected Goals in the ',
          },
          xASides: {
            1: ' Most of the danger of target_team_name was produced from the side_name (xa_value <b>xA</b>)',
          },
          xASidesRival: {
            1: 'while rival_team_name generated the majority of it from the side_name (xa_value <b>xA</b>)',
          },
          dangerCreationRival: {
            1: 'The creation of danger of rival_team_name came, especially, from the side_name (xa_value <b>xA</b>). ',
          },
          speciallyEffective: {
            1: 'target_team_name was especially effective at ',
          },
          xAPerChanceCreated: {
            1: ' with an average of xa_value',
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name was especially effective at ',
          },
        },
      },
      step3: {
        text: {
          chance: ' chance',
          chances: ' chances',
          goal: ' goal',
          goals: ' goals',
          home: 'home',
          away: 'away',
          last: 'last',
          first: 'first',
          goalScorer: 'goalscorer',
          goalScorers: 'goalscorers',
          lastPhase: 'Last phase of the match, ',
          phase: {
            1: 'In this phase_position phase of the game, ',
            // 2: "",
          },
          moreXT: {
            1: "<b style='color:more_color'>more_xt_team_name</b> generated more Expected Threat (<b style='color:more_color'>more_xt_team_value xT</b>) than <b style='color:less_color'>less_xt_team_name</b> (<b style='color:less_color'>less_xt_team_value xT</b>)",
            // 2: "",
          },
          sameTeamMoreMinutes: {
            1: "and did it for more minutes in this period (<b style='color:more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes mins.</b> of the opponent)",
            // 2: "",
          },
          rivalTeamMoreMinutes: {
            1: "however, it was the opponent who generated danger for longer (<b style='color:more_color'>more_time_xt_minutes mins.</b> vs <b style='color:less_color'>less_time_xt_minutes mins.</b> of the opponent) in this period of the game",
            // 2: "",
          },
          maxXTValue: {
            1: "<b style='color:max_color'>max_xt_team_name</b> was the team that created the most danger (<b style='color:max_color'>max_xt_team_value xT</b>) at <b style='color:max_color'>max_xt_team_minute'</b>",
            // 2: "",
          },
          maxXTValueRival: {
            1: ", while the <b style='color:max_rival_color'>max_xt_rival_team_name</b> generated their most danger (<b style='color:max_rival_color'>max_xt_rival_team_value xT</b>) at <b style='color:max_rival_color'>max_xt_rival_team_minute'</b>",
          },
          bothTeamsScoreButDraw: {
            1: "Both teams have managed to beat the opposing goalkeeper in <b>number_of_goals_each_team</b> each one. The home team through <b style='color:#3366FF'>home_player_name_goals</b> and the away team through <b>away_player_name_goals</b>",
            // 2: "",
          },
          oneTeamTakesTheLead: {
            1: "In terms of goals, <b style='color:replace_color'>goal_scored_team_name</b> outperformed the opponent by <b style='color:replace_color'>difference_number_of_goals</b> of difference as they beat their goalkeeper with <b style='color:replace_color'>home_player_name_goals</b> as goal_scorer_word",
            // 2: "",
          },
        },
      },
      step4: {
        table: {
          team: 'Team',
          period: 'Period',
          possession: 'Poss.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Team',
            period: 'Period',
            possession: 'Possession',
            ppda: 'Conceded Passes per Defensive Action',
            xGOpenPlay: 'xG Open Play',
          },
        },
        text: {
          clearly: 'clearly',
          very: 'very ',
          haveGotText1: 'only got',
          haveGotText2: 'should have gotten more than',
          gaveUpPoss: 'gave up the possession',
          lostPoss: 'lost the possession of the ball',
          too: 'too ',
          possession: {
            1: "During this phase of the game <b style='color:team_color'>team_name</b> clearly_text controlled the possession of the ball",
          },
          equalPossession: {
            1: "In this phase of the match, no one dominated the other as the ball handling was quite balanced, although looking at the numbers, <b style='color:team_color'>team_name</b> slightly outplayed their opponents with a <b style='color:team_color'>possession_value%</b> of possession",
          },
          lowPossessionHighPPDA: {
            1: ". <b style='color:target_team_color'>target_team_name</b> with a bad ball pressure allowed <b style='color:rival_team_color'>rival_team_name</b> to give <b style='color:target_team_color'>ppda_value Passes per Defensive Action</b>",
          },
          lowPossessionLowPPDA: {
            1: ", but <b style='color:target_team_color'>target_team_name</b> did good at pressing the ball when rival_team_name had the possession, with a <b>PPDA</b> of <b>ppda_value</b>",
          },
          highPossessionLowPPDA: {
            1: ' and was able to play due to a very_textlow pressing intensity from rival_team_name',
          },
          highPossessionHighPPDA: {
            1: ' although the pressing intensity of rival_team_name was very_texthigh',
          },
          highPossessionHighPFT: {
            1: "<b style='color:target_team_color'>target_team_name</b> seized a high possession giving <b>pft_value</b> <b>Passes in the Final Third</b> of the pitch. ",
          },
          highPossessionMidLowPFT: {
            1: "Regardless of the high possession, <b style='color:target_team_color'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes in the Final Third</b>. ",
          },
          lowPossessionHighPFT: {
            1: "Although <b style='color:target_team_color'>target_team_name</b> possession_text during this phase, it was able to give <b>pft_value</b> <b>Passes in the Final Third</b>. ",
          },
          midPossessionHighPFT: {
            1: "A quite even possession during this phase didn't stop <b style='color:target_team_color'>target_team_name</b> from giving <b>pft_value</b> <b>Passes in the Final Third</b>. ",
          },
          highPFTHighTouchesIOB: {
            1: " Apart from controlling the game in the final third, <b style='color:target_team_color'>target_team_name</b> also had a lot of presence in the opponent box. ",
          },
          highPFTLowTouchesIOB: {
            1: "<b style='color:target_team_color'>target_team_name</b> did control the ball in the final third, but could not get many balls into the opponent box",
          },
          highPFTMidTouchesIOB: {
            1: "Given the number of <b>Passes in the Final Third</b>, <b style='color:target_team_color'>target_team_name</b> should have created more danger in the opponent box",
          },
          lowPFTHighTouchesIOB: {
            1: "Although <b style='color:target_team_color'>target_team_name</b> did not complete many passes in the final third, it was able to reach the opponent box many times. ",
          },
          midPFTHighTouchesIOB: {
            1: "Given the number of passes completed in the final third, <b style='color:target_team_color'>target_team_name</b> achieved to reach the opponent box many times. ",
          },
          maxDirectness: {
            1: "It is worth to point out that this is the phase of the game when <b style='color:max_dir_color'>target_team_name</b> played more offensively with a <b>Directness</b> of <b>directness_value</b>. ",
          },
          maxXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> was able to generate more xG than in other phases of the game ",
          },
          highXGFifthQuintile: {
            1: " <b style='color:target_team_color'>target_team_name</b> managed to generate a high volume of Expected Goals",
          },
          highXG: {
            1: 'generated a good volume of Expected Goals',
          },
          highXGLowPossession: {
            1: ' in spite of not having the control of the ball',
          },
          highXGLowShots: {
            1: ' only in a few shots, having a <b>xG per Shot</b> of <b>xg_per_shot_value</b>',
          },
          highXGLowXGPerShot: {
            1: ' though the xG per Shot was too_textlow. ',
          },
          lowXGZeroXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> was not able to generate any danger to the opponent",
          },
          lowXGMinXG: {
            1: "In terms of generation of Expected Goals, this was a poor stage for <b style='color:target_team_color'>target_team_name</b>",
          },
          lowXGFirstQuintileXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> generated a very low volume of Expected Goals",
          },
          lowXGSecondQuintileXG: {
            1: "<b style='color:target_team_color'>target_team_name</b> was not able to generate a good volume of Expected Goals",
          },
          lowXGHighPossession: {
            1: ' even though they had the control of the ball. ',
          },
          lowXGHighShots: {
            1: ' in spite of shooting many times',
          },
          lowXGHighPFT: {
            1: ' in spite of completing <b>pft_value</b> <b>Passes in the Final Third</b> of the pitch. ',
          },
          midXGQuintileMinXG: {
            1: "Although the generation of xG wasn't bad, this was the weakest phase of the game for <b style='color:target_team_color'>target_team_name</b> in that regard",
          },
          midXGQuintileMaxXG: {
            1: "This was the phase during which <b style='color:target_team_color'>target_team_name</b> was able to generate the highest <b>xG (xg_value)</b>",
          },
        },
      },
      step5: {
        table: {
          team: 'Team',
          period: 'Period',
          possession: 'Poss.',
          directness: 'Dir.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Team',
            period: 'Period',
            possession: 'Possession',
            directness: 'Directness',
            passesFinalThird: 'Passes Final Third',
          },
        },
        text: {
          last: 'last',
          goal: 'goal',
          goals: 'goals',
          chance: 'chance',
          chances: 'chances',
          first: 'first',
          homeTeam: 'home team',
          awayTeam: 'away team',
          home: 'home',
          away: 'away',
          clearly: 'clearly',
          slightly: 'slightly',
          firstOrLastPhase: {
            1: 'In this phase_position phase of the game, ',
            2: 'On the phase_position period of the match, ',
          },
          phase: {
            1: 'During this period of the match, ',
            // 2: "",
          },
          bothZeroGoalsScored: {
            1: 'without either team being able to change the scoreboard.',
          },
          equalGoalsScored: {
            1: 'getting to score <b>number_goals</b>',
          },
          differentGoalsScored: {
            1: 'getting to score <b>number_goals</b>',
          },
          equalPossesion: {
            1: 'both teams had the ball exactly <b>poss_value%</b> of the time',
          },
          morePossesion: {
            1: "<b style='color:more_color'>more_poss_team_name</b> had the ball for more minutes (<b style='color:more_color'>more_poss_team_value%</b> of the time) than their opponent <b style='color:less_color'>less_poss_team_name</b> (<b style='color:less_color'>less_poss_team_value%</b> of the time)",
          },
          equalDirectness: {
            1: 'both teams played the game with the same directness (<b>directness_value</b> each one)',
          },
          // Same team with more possession and more directness than his rival
          moreDirectnessSameTeam: {
            1: "they also were more vertical than their opponents, playing the game with a directness of <b style='color:more_color'>more_dir_team_value</b> vs <b style='color:less_color'>less_dir_team_value</b>",
          },
          // One team with more possession and one with more directness
          moreDirectnessDifferentTeam: {
            1: "however, it was the home_away team who played with more directness (<b style='color:more_color'>more_dir_team_value</b>) than the opponent (<b style='color:less_color'>less_dir_team_value</b>)",
          },
          equalChancesCreated: {
            1: 'Both teams created the same number of chances, exactly <b>chances_created_value</b> chance_text.',
          },
          moreChancesCreated: {
            1: "<b style='color:less_color'>less_cc_team_name</b> created only <b style='color:less_color'>less_cc_team_value less_chance_text</b> and was adverb_text outperformed by the opponent (<b style='color:more_color'>more_cc_team_value more_chance_text created</b>). ",
          },
          equalXA: {
            1: 'Both teams had equal opportunities, as reflected in the <b>xa_value of Expected Assists</b>, ',
          },
          moreXA: {
            1: "The home_away team generated <b>diff_xa_team_value Expected Assists</b> (<b style='color:more_color'>more_xa_team_value</b> versus <b style='color:less_color'>less_xa_team_value</b>) more than the opponent, ",
          },
          xAOpenPlay: {
            1: "creating, respectively, <b style='color:more_color'>more_xa_op_value</b> and <b style='color:less_color'>less_xa_op_value xA Open Play</b>.",
          },
        },
      },
      step6: {
        text: {
          eachOne: ' each one ',
          respectively: ', respectively',
          with: " (with <b style='color:replace_color'>other_player_name</b>)",
          playerWas: 'player was',
          playerWere: 'players were',
          firstPhase: {
            1: 'In this first part of the match, the most important player_text ',
            2: 'As for the first part of the game, who stood out was ',
          },
          otherPhase: {
            1: "Between <b style='color:replace_color'>min_from'</b> and <b style='color:replace_color'>min_to'</b> should be mentioned ",
          },
          lastPhase: {
            1: 'In the last part of the game, mention to ',
            2: 'As for the last phase of the match, ',
          },
          playerMaxSuccessfullPasses: {
            1: "<b style='color:replace_color'>player_name</b> as they performed the highest number of successful passes for their team, exactly <b style='color:replace_color'>successfull_passes_value passes</b> ",
          },
          playerMaxTotalPasses: {
            1: 'which becomes even more valuable when the figures show that they also were',
          },
          playerMaxTotalPasses2: {
            1: "with_text the player with the most attempted passes (<b style='color:replace_color'>total_passes_value passes</b>). ",
          },
          // Just one player with max successfull passes
          playerNotMaxTotalPasses: {
            1: "although this player did not attempt the most passes (<b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>total_passes_value passes</b>). ",
          },
          // More than one player with max successfull passes
          playersMaxSuccessfullPassesTotalPasses: {
            1: "trying during this period <b style='color:replace_color'>total_passes_value passes</b> each one. ",
          },
          playerMaxPctPasses: {
            1: "In terms of <b style='color:replace_color'>% Passes Completed</b>, <b style='color:replace_color'>player_name</b> has a high <b style='color:replace_color'>max_pct_passes_value%</b>. ",
            2: "In reference to pass success rate, it is worth mentioning <b style='color:replace_color'>player_name</b> with a <b style='color:replace_color'>max_pct_passes_value%</b> pass success rate</b>. ",
          },
          playerSumTotalXG: {
            1: "In this time window, the team generated a total of <b style='color:replace_color'>sum_xg_value xG</b>, ",
            2: "During this period, <b style='color:replace_color'>team_name</b> created a <b style='color:replace_color'>xG</b> of <b style='color:replace_color'>sum_xg_value</b>, ",
          },
          ZeroSumXG: {
            1: "Despite making a total of <b style='color:replace_color'>all_team_total_passes</b> between the whole team, it was in vain as they failed to create a single chance. ",
            2: "The <b style='color:replace_color'>all_team_total_passes</b> made in this period did not generate a single scoring chance. ",
          },
          playerMaxXGMaxXADiffPlayer: {
            1: "with <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>player_xa_name</b> with <b style='color:replace_color'>xa_value xA</b> being the most dangerous players in terms of creating chances. ",
          },
          playerMaxXGMaxXASamePlayer: {
            1: "being <b style='color:replace_color'>player_name</b> with <b style='color:replace_color'>xg_value xG</b> and <b style='color:replace_color'>xa_value xA</b> the originator of most of their team's chances. ",
          },
          playersMaxXGMaxXA: {
            1: "thanks among others to <b style='color:replace_color'>players_name</b> who triggered <b style='color:replace_color'>xa_value xA</b> each with their key passes. ",
          },
          // Just one player with max xG
          playerMaxXGZeroXA: {
            1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> who had the full weight of the chances, having to create them on their own as they did not receive any key passes. ",
          },
          // More than one player with max xG
          playersMaxXGZeroXA: {
            1: "being <b style='color:replace_color'>player_xg_name</b> with <b style='color:replace_color'>xg_value xG</b> who had the chances, having to create them on their own as they did not receive any key passes. ",
          },
          oneMaxConnections: {
            1: "The pair that made the most passes between them during this stretch of the match was <b style='color:replace_color'>couple_name</b>, with a total of <b style='color:replace_color'>connections_value passes</b>. ",
            2: "The duo formed by <b style='color:replace_color'>couple_name</b> exchanged <b style='color:replace_color'>connections_value</b> times the ball. ",
            3: "The <b style='color:replace_color'>couple_name</b> duo were the ones who passed the ball the most in this stretch of the match, doing so even on <b style='color:replace_color'>connections_value</b> chances. ",
          },
          twoMaxConnections: {
            1: "The two pairs formed by <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> were the most repeated connections for this period, passing the ball to each other <b style='color:replace_color'>connections_value</b> times. ",
          },
          moreThanTwoMaxConnections: {
            1: "The pairs of players, such as <b style='color:replace_color'>couple_name</b>, made <b style='color:replace_color'>connections_value passes</b> to each other. ",
          },
          oneMinConnections: {
            1: "On the other hand, it was <b style='color:replace_color'>couple_name</b> who passed the ball to each other the least, only <b style='color:replace_color'>connections_value passes</b>. ",
            2: "At the other extreme, the tandem composed by <b style='color:replace_color'>couple_name</b> only connected <b style='color:replace_color'>connections_value</b> times. ",
          },
          twoMinConnections: {
            1: "On the other hand, <b style='color:replace_color'>couple_name</b> and <b style='color:replace_color'>couple_name2</b> barely exchanged passes between them (<b style='color:replace_color'>connections_value passes</b>). ",
          },
          moreThanTwoMinConnections: {
            1: "Several combinations did not connect enough, such as the <b style='color:replace_color'>couple_name</b> duo, which with <b style='color:replace_color'>connections_value passes</b> are among the least common combinations. ",
          },
        },
      },
      step7: {
        ballPossession: 'Ball Possession',
        gamePossessionDist: 'Ball Possession Distribution'
      }
    },
    gamePossessionMap: {
      of: 'of',
      to: 'to',
      and: 'and',
      endsWith: 'Ends with',
      time: 'Time',
      touches: 'Touches',
      passes: 'Passes',
      threat: 'Threat',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minutes',
      duration: 'Duration',
      endsGoal: 'Ends Goal',
      endsInBox: 'Ends in Box',
      with: 'with',
      withShot: 'With Shot',
      withCross: 'With Cross',
      possession: 'Possession',
      events: 'Events',
      filters: 'Filters',
      filtersWarning: 'Threat only applies to possessions without shots',
      sumWarning:
        "The filter applies to the sum of xG of all shots in the sequence, that's why can be greater than 1",
      show: 'Show',
      sequenceNumbers: 'Sequence Number',
      jerseyNumbers: 'Jersey',
      pass: 'Pass',
      carryAndPass: 'Carry & Pass',
      carryAndAction: 'Carry & Action',
      carryAndShot: 'Carry & Shot',
      shotFailed: 'Failed Shot',
      goal: 'Goal',
      savedShot: 'Saved Shot',
      missedShot: 'Missed Shot',
      shotOnPost: 'Shot on Post',
      headerGoal: 'Header Goal',
      headerFailed: 'Header Failed',
      failed: 'failed',
    },
    report: {
      title: 'Game Report',
      pDReportTitle: 'Game Physical Data Report',
      maps: 'Maps',
      xGRace: 'xG Race',
      lineups: 'Lineups',
      button: 'Generate a full PDF report of the game',
      mobileButton: 'PDF report',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      most: 'Most',
      topXPlayers: 'Top {x} Players',
    },
  },
  general: {
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    reset: 'Reset',
    go: "Go",
    formErrors: {
      required: 'Field is required',
      passwordMatch: 'Password doesnt match',
      minLength: 'Minimum length',
      maxLength: 'Maximum length',
      emailValid: 'E-mail must be valid',
      youthAge: 'Age must be between 10 and 23',
      seasonYear: 'Year must be between 2016 and 2050',
      integer: 'Decimal numbers are not allowed',
    },
    confirmationTitle: 'Are you sure?',
    confirmationMessage: 'Please confirm if you want to perform the action',
    yes: 'Yes',
    no: 'No',
    1: 'One',
    2: 'Two',
    3: 'Three',
    4: 'Four',
    5: 'Five',
    search: 'Search',
    clearFilters: 'Clear filters',
    minimum: 'Minimum',
    maximum: 'Maximum',
    minimumPercent: '(%)Minimum Percent',
    period: 'Period',
    exclude: 'Exclude',
    team: 'Team',
    currentTeam: 'Current Team',
    clear: 'Clear',
    all: 'All',
    ground1: 'All',
    ground2: 'Home',
    ground3: 'Away',
    filter: 'Filter',
    noData: 'No results found',
    noDataGivenFilters: 'No results found with given filters',
    similarityMinutesWarning: 'No data due to less than 450 minutes played',
    templateOnlyEditable: 'Template only editable by ',
    close: 'Close',
    load: 'Load',
    filters: 'Filters',
    players: 'players',
    teams: 'teams',
    compare: 'Compare',
    seeMore: 'See more',
    seeLess: 'See less',
    request: 'Request',
    notes: 'Notes',
    closeSession: 'Exit',
    settings: 'Settings',
    player: 'Player',
    state: 'State',
    updated: 'Updated',
    file: 'File',
    uploadFile: 'Upload file',
    reports: 'Reports',
    download: 'Download',
    new: 'New',
    comparison: 'Comparison',
    scout: 'Scout',
    favorites: 'Favorites',
    moreOptions: 'More options',
    lessOptions: 'Less options',
    today: 'Today',
    home: 'Home',
    away: 'Away',
    until: 'until',
    firstHalf: 'First Half',
    secondHalf: 'Second Half',
    firstPeriodOT: 'First H. OT',
    secondPeriodOT: 'Second H. OT',
    postponed: 'Postponed',
    stats: 'Stats',
    yesterday: 'Yesterday',
    last: 'Last',
    startDate: 'Start Date',
    active: 'Active',
    playerLimit: 'Players Limit',
    type: 'Type',
    successMessage: 'The operation has been a success',
    failMessage: 'The operation has failed',
    by: 'By',
    checkYourInbox: 'Check your inbox',
    faq: 'Glossary',
    globalSearch: 'Global Search',
    gamesLost: 'Games Lost',
    outOf: 'out of',
    avgSeason: 'Season Avg.',
    leftDays: 'remaining days',
    notifyError: 'Notify Error',
    notify: 'Notify',
    comments: 'Comments',
    searches: 'Searches',
    now: 'Now',
    twoHoursAgo: 'Two hours ago',
    incomings: 'Arrivals',
    departures: 'Departures',
    transferLoans: 'Loans',
    transfers: 'Transfers',
    movements: 'Movements',
    incomes: 'Incomes',
    expenditures: 'Expenditures',
    action: 'Action',
    target: 'Target',
    uses: 'Uses',
    users: 'Users',
    since: 'since',
    mediaMode: 'Media Mode',
    white: 'White',
    enabled: 'Enabled',
    disabled: 'Disabled',
    left: 'Left',
    right: 'Right',
    both: 'Both',
    'left-both': 'Left Both',
    'right-both': 'Right Both',
    'left foot': 'Left',
    'right foot': 'Right',
    8: 'Left',
    9: 'Both',
    10: 'Right',
    files: 'Files',
    confirm: 'Confirm',
    currentStep: 'Current Step',
    phases: 'Phases',
    entries: 'Entries',
    none: 'None',
    times: 'times',
    darkMode: 'Dark Mode',
    client: 'Client',
    visits: 'Visits',
    lastVisit: 'Last Visit',
    strong: 'Strong',
    medium: 'Medium',
    weak: 'Weak',
    goal: 'Goal',
    list: 'List',
    map: 'Map',
    copiedToClipboard: 'Copied to clipboard',
    division: 'Division',
    many: 'Many',
    few: 'Few',
    median: 'Median',
    topRight: 'Top Right',
    topLeft: 'Top Left',
    bottomRight: 'Bottom Right',
    bottomLeft: 'Bottom Left',
    library: 'Library',
    mediaLibrary: 'Media Library',
    for: 'For',
    stat: 'Stat',
    position: 'Position',
    order: 'Order',
    add: 'Add',
    visualization: 'Visualization',
    orientation: 'Orientation',
    basic: 'Basic',
    selectAll: 'Select All',
    unselectAll: 'Unselect All',
    distribution: 'Distribution',
    end: 'End',
    accuracy: 'accuracy',
    opponent: 'Opponent',
    ownTeam: 'Own Team',
    center: 'Center',
    line: 'Line',
    live: 'Live',
    unavailable: 'unavailable',
    calendar: 'Calendar',
    activeLeague: 'League in Progress',
    similarity: 'Similarity',
    emptyForSelectAll: 'Empty select all',
    size: 'Size',
    selectPlayersRestriction: 'Select between 1 and {x} players',
    group: 'Group',
    alerts: 'Alerts',
    shortcuts: 'Shortcuts',
    share: 'Share',
    dataAvailable: 'Data will be available soon',
    someStatsAvailableSoon: 'Some stats will be available soon',
    monthGamesWarning: 'Games of selected month will be available soon',
    metrics: 'Metrics',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: 'Never',
    unlimited: 'Unlimited',
    user: 'User',
    warning: 'Warning',
    requests: 'Requests',
    contactSales: 'Contact Sales',
    comingSoon: 'Coming Soon!',
    firstPost: '1st Post',
    secondPost: '2nd Post',
    dZone: 'D Zone',
    penaltySpot: 'Penalty Spot',
    secondPlay: '2nd Play',
    otherZone: 'Other Zone',
    baseline: 'Baseline',
    youth: 'Youth',
    male: 'Male',
    direct: 'Direct',
    indirect: 'Indirect',
    processing: 'Processing',
    addNew: 'Add New',
    createdBy: 'Created by',
    downloading: 'Downloading',
    displayType: 'Display Type',
    alreadyExists: 'already exists',
    aggregation: 'Aggregation',
    unavailableLeagues:
      'You do not have access to any of the leagues in which the player has played',
    meters: 'Meters',
    quantity: 'Quantity',
    allTime: 'All Times',
    games: 'Games',
    unit: 'Unit',
    categories: 'Categories',
    maintenanceWarning: 'Maintenance in progress',
    maintenanceMessage:
      "We're making some updates. Changes you make right now won't be saved. Thanks for your patience!",
    seeAll: 'See All',
    from: 'From',
    to: 'to',
    showFilters: 'Show filters',
    hideFilters: 'Hide filters',
    horizontal: 'Horizontal',
    vertical: 'Vertical',
    expectations: 'Expectations',
    sideBySide: "Side by side",
    teamValue: "Team value",
    goalProbability: 'Goal Probability',
    assistProbability: 'Assist Probability',
    attackingDirection: 'Attacking Direction',
    fieldLayout: 'Field Layout',
    searchPlaceholder: 'Type {x} letters at least to search',
  },
  playerScout: {
    dlabDatabase: 'Driblab Database',
    warningRegularSeason: 'Showing only last regular season played',
    league: 'League',
    top5: 'Top 5',
    topCountries: 'Countries',
    tier: 'Tier',
    division1: 'First Division',
    division2: 'Second Division',
    division3: 'Third Division',
    division4: 'Fourth Division',
    division5: 'Fifth Division',
    division6: 'Sixth Division',
    summary: 'Summary',
    offensive: 'Off',
    defensive: 'Def',
    gk: 'GK',
    all: 'All',
    physical: 'Phys',
    arrigo: 'Arrigo',
    yearTooltip: 'Only one year allowed',
    expectedThreat: 'xThreat',
    expectedThreatTooltip: 'Threat added to all possessions',
    expectedThreatOP: 'xThreat OP',
    expectedThreatOPTooltip: 'Threat added to Open Play possessions',
    expectedThreatInTeam: 'xThreat in Team %',
    expectedThreatInTeamTooltip: 'Pct. of Threat added by player to the team',
    ballProgression: 'Ball Progression',
    ballProgressionTooltip: 'Progressions of +10 meters',
    deepProgression: 'Deep Progressions',
    deepProgressionTooltip: 'Ball Progressions to Last Fifth',
    ballRetention: '% Ball Retention',
    ballRetentionTooltip:
      'Percentage of Actions where Ball was Successfully Retained',
    ballRetentionOppHalf: '% Ball Retention OH',
    ballRetentionOppHalfExplicit:
      "Percentage of the time you have possession of the ball and don't end up losing it in the opponent half",
    finishing: 'Finishing',
    finishingTooltip: 'Pct. of Shots Ending in a Goal',
    scoringContribution: 'Scoring Contribution',
    scoringContributionTooltip: 'Assists + Goals',
    xgPerShot: 'xG per Shot',
    xgPerGoal: 'xG per Goal',
    headerPerCross: 'Header per Cross',
    completedCrosses: 'Completed Crosses',
    crossingPct: '% Crossing',
    crossingEfficiency: 'Crossing Efficiency',
    crossingEfficiencyTooltip:
      'Crossing Efficiency (Measures Quality and Quantity)',
    longBalls: 'Long Balls',
    longPassing: '% Long Ball',
    dribblingPct: '% Dribbling',
    throughBalls: 'Through Balls',
    oppBoxTouches: 'Opp. Box Touches',
    oppBoxTouchesTooltip: 'Touches in Opponent Box',
    openPlayKeyPasses: 'OP Key Passes',
    openPlayKeyPassesTooltip: 'Open Play Passes ending in Shot',
    xGBuildup: 'xG Buildup',
    xGBuildupTooltip:
      'xG of sequences ending in shot where the player was involved (excluding xG of shot and key pass)',
    Assists: 'Assists',
    passPercentage: '% Passing',
    passPerLongBall: 'Pass per LB',
    passPerLongBallExplicit: 'Pass per Long Ball',
    nonPenaltyGoals: 'Non-Penalty Goals',
    xG: 'xG',
    xGExplicit: 'Expected Goals',
    shots: 'Shots',
    xGShot: 'xG per Shot',
    xGChain: 'xG Chain',
    xGChainTooltip:
      'xG of sequences ending in shot where the player was involved',
    chancesCreated: 'Passes followed by a Shot',
    chances: 'Chances',
    dribbles: 'Dribbles',
    dribblesSuccessfull: 'Dribbles Succesfull',
    touches: 'Touches in Opponent Box',
    xA: 'xA',
    xAExplicit: 'Expected Assists',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Expected Assists Open Play',
    passesOpponentBox: 'Passes in Opponent Box',
    passesOB: 'Passes in OB',
    passesFinalThirdTooltip: 'Passes Final Third',
    passesSuccessful: 'Passes Succ.',
    passesSuccessfulTooltip: 'Passes Successful',
    ballProgressionPassing: 'BP by Passing',
    ballProgressionPassingTooltip: 'Ball Progression by Passing',
    ballProgressionDribbling: 'BP by Carrying',
    ballProgressionDribblingTooltip: 'Ball Progression by Carrying',
    passesTotal: 'Passes',
    passesTotalTooltip: 'Total of Passes Attempted',
    shortPassesSuccessful: 'Succ. SP',
    shortPassesSuccessfulTooltip: 'Number of Short Passes Completed',
    shortPassesTotal: 'Total SP',
    shortPassesTotalTooltip: 'Number of Short Passes Attempted',
    tackles: 'Tackles *',
    adjustedTackles: 'Tackles adjusted to Possession',
    interceptions: 'Interceptions *',
    adjustedInterceptions: 'Interceptions adjusted to Possession',
    aerials: 'Aerial Duels',
    aerialsPercent: '% Aerials',
    aerialEfficiency: 'Aerial Eff.',
    aerialEfficiencyTooltip:
      'Aerial Efficiency (Measures Quality and Quantity)',
    twd: 'TwD',
    tacklesWasDribbled: '1vs1 Defensive Win %',
    fouls: 'Fouls',
    indPressure: 'Individual Pressure',
    pressure: 'Pressure',
    dispossessed: 'Dispossessed',
    recoveries: 'Recoveries',
    primary: 'Primary',
    secondary: 'Secondary',
    tertiary: 'Tertiary',
    position: 'Position',
    nationality: 'Nationality',
    height: 'Height (cm)',
    minHeight: 'Min. Height',
    maxHeight: 'Max. Height',
    age: 'Age',
    minAge: 'Min. Age',
    maxAge: 'Max. Age',
    games: 'Games',
    minGames: 'Min. Games',
    maxGames: 'Max. Games',
    minutes: 'Minutes',
    minMinutes: 'Min. Minutes',
    maxMinutes: 'Max. Minutes',
    minPercentMinutes: 'Min. Percent Minutes',
    dates: 'Dates',
    marketValue: '(€) Market Value',
    teams: 'Teams',
    contractEnd: 'Contract End',
    minValue: 'Min. Value',
    maxValue: 'Max. Value',
    excludeTeams: 'Exclude Teams',
    recentSearches: 'Recent searches',
    saveSearch: 'Save search',
    loadSearch: 'Load search',
    loadCollection: 'Load Collection',
    collection: 'Collection',
    search: 'Search',
    searchesList: 'Search lists',
    mySearches: 'My searches',
    mySearchesDescription: 'That ones you saved previously',
    recentSearchesDescription: 'Last 10 searches you did',
    searchToLoad: 'Search to load',
    recentSearch: 'Recent search',
    saveSearchSuccess: 'Search saved successfully',
    removeSearch: 'Delete search',
    removeSearchMessage: 'Are you sure you want to delete the search?',
    updateSearch: 'Update search',
    updateSearchMessage: 'Are you sure you want to update the search?',
    deleteSearchSuccess: 'Search has been deleted',
    playersFound: 'players found',
    addToCollection: 'Add to collection',
    npg: 'NPG',
    goals: 'Goals',
    value: 'Value',
    nationalTeams: 'National Teams',
    gbeScore: 'GBE',
    dlIndex: 'Score',
    minGbe: 'Min. GBE',
    goalsConceded: 'Goals Conceded',
    npgConceded: 'NPG Conceded',
    npgConcededTooltip: 'Non-Penalty Goals Conceded',
    xGOTConceded: 'xG On Target Conceded',
    xGOTConcededTooltip: 'xG of Shots Received on Target',
    goalsPrevented: 'Goals Prevented',
    xGFacedPerShotOnTarget: 'xGOT per Shot',
    xGFacedPerShotOnTargetTooltip: 'xG on Target per Shot conceded',
    xGSavedPerxGFacedOnTarget: 'xG Saving',
    xGSavedPerxGFacedOnTargetTooltip:
      'Percentage of Saving taking xG into account',
    savesPct: '% Saving',
    savesOutOfBoxPct: '% Saving Out of Box',
    savesInBoxPct: '% Saving In Box',
    xGFacedPerGoal: 'xG Faced per Goal',
    xGFacedPerGoalTooltip: 'xG Needed to Score a Goal',
    catchingPct: '% Catching',
    catchingTooltip: 'Pct. of Saves Caught',
    passingOwnHalfPct: '% Passing Own Half',
    passingOwnHalfPctTooltip: 'Percentage of Successful Passes in Own Half',
    passingOppHalfPct: '% Passing Opp. Half',
    passingOppHalfPctTooltip:
      'Percentage of Successful Passes in Opponent Half',
    passingContribution: '% Passing Cont.',
    passingContributionTooltip:
      'Contribution of Threat by Passing the Ball - Above Average',
    shotsPerGoal: 'Shots per Goal',
    passesFinalThird: 'Passes Final ⅓',
    passingFinalThird: '% Passing Final ⅓',
    claimAccuracy: 'Claim Accuracy',
    claimAccuracyTooltip: 'Balls Claimed above Average',
    highTurnovers: 'High Turnovers',
    highTurnoversTooltip: 'Turnovers closer than 40 meters to goal',
    shotEndingHighTurnovers: 'Shot Ending HT',
    shotEndingHighTurnoversTooltip: 'Shot Ending High Turnovers',
    goalEndingHighTurnovers: 'Goal Ending HT',
    goalEndingHighTurnoversTooltip: 'Goal Ending High Turnovers',
    avgCarriesProgress: 'Average Progress',
    avgCarriesProgressTooltip:
      'Average distance moving the ball vertically (meters)',
    carriesChance: 'Chance Ending',
    carriesChanceTooltip: 'Carries followed by a Key Pass',
    carriesAssist: 'Assist Ending',
    carriesAssistTooltip: 'Carries followed by an Assist',
    carriesShot: 'Shot Ending',
    carriesShotTooltip: 'Carries followed by a Shot',
    carriesGoal: 'Goal Ending',
    carriesGoalTooltip: 'Carries followed by a Goal',
    shotEndingSequence: 'Shot Ending',
    shotEndingSequenceTooltip:
      'Number of Sequences ending in a Shot where the player was involved',
    goalEndingSequence: 'Goal Ending',
    goalEndingSequenceTooltip:
      'Number of Sequences ending in a Goal where the player was involved',
    gbeScoreTooltip: "FA Football's Governing Body Endorsement",
    goalsPreventedTooltip:
      'Non-Penalty Goals saved by Goalkeeper (xG Faced - NPG Conceded)',
    freePlayers: 'Free Players',
    index: 'Index',
    playerName: 'Name',
    teamName: 'Team',
    secondPos: 'Second Pos.',
    side: 'Side',
    onlyOnLoan: 'Only on loan',
    dob: 'Birth',
    countryName: 'Country',
    secondCountryName: 'Second Country',
    seasonYear: 'Season',
    assists: 'Assists',
    placeholder: 'You can start adding some league filters',
    placeholder2: 'Click search button to show results',
    passesPct: '% Passes',
    passingPct: '% Passes',
    oppBoxPasses: 'Passes in Opp. Box',
    adjustedClearances: 'Adjusted Clearances',
    aerialsPct: '% Aerials',
    leagueCountryCode: 'League Country Code',
    shooting: '% Shots on Target',
    xtPassing: 'xT Passing',
    xtPassingTooltip: 'Threat added by passing',
    xtDribbling: 'xT Carries',
    xtDribblingTooltip: 'Threat added by carrying',
    foot: 'Strong Foot',
    aggressiveActions: 'Aggressive Actions',
    aggressiveActionsTooltip:
      'Number of tackles attempted in the next two seconds after losing the possession',
    tacklesAttempted: 'Total Tackles Attempted',
    highDefensiveActionPct: '% HD Actions',
    highDefensiveActionPctTooltip:
      'Percentage of Defensive Actions made 40 meters close to the opponent goal',
    individualPressureOppHalf: 'Pressure Opp. Half',
    individualPressureOppHalfTooltip:
      'Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half',
    xGBuildUp5Pass: 'xG Buildup 5p',
    xGBuildUp5PassTooltip:
      'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
    chancesCreatedOpenPlay: 'Chances Created OP',
    chancesCreatedOpenPlayTooltip:
      'Number of passes leading to a shot during open play',
    fmf: {
      Defender: 'Defender',
      aerial: 'Aerial',
      goodDefender: 'Good Defender',
      goodPresence: 'Good Presence',
      playmaking: 'Playmaking',
      Fullback: 'Fullback',
      defensiveness: 'Defensiveness',
      offensiveness: 'Offensiveness',
      fast: 'Fast',
      Forward: 'Forward',
      goalChances: 'Goal Chances',
      goodDecissions: 'Good Decissions',
      individualTechnique: 'Individual Technique',
      Goalkeeper: 'Goalkeeper',
      footWork: 'Footwork',
      leadership: 'Leadership',
      Midfielder: 'Defensive Midfielder',
      balance: 'Balance',
      ballRetention: '% Ball Retention',
      offensivePasses: 'Offensive Passes',
      recoveries: 'Recoveries',
      shotToGoal: 'Shot to Goal',
      'Attacking-Midfielder': 'Attacking Midfielder',
      defensiveGame: 'Defensive Game',
      offensiveGame: 'Offensive Game',
      Winger: 'Winger',
      crossing: 'Crossing',
      deepProgressions: 'Deep Progressions',
      defendingEffort: 'Defending Effort',
      facing: 'Facing',
    },
    yellowCards: "Yellow Cards",
    redCards: "Red Cards",
    alert: "Alert",
    yearOfBirth: "Year of Birth",
    minYearOfBirth: "Min. Year of Birth",
    maxYearOfBirth: "Max. Year of Birth",
    women: "Women",
    continental: "Continental",
    countryCup: "Country Cup",
    statsName: "Stat name",
    abbreviation: "Abbreviation",
    starts: "Starts",
    abbr:{
      position: "POS",
      secondPos:"SP",
      seasonYear: "SY",
      marketValue: "MV(€)",
      contractEnd: "CE",
      height: "H(cm)",
      side: "SD",
      strongFoot:"SF",
      games: "G"
    },
    gamesWith60PlusMinsTooltip: 'Minimum number of games played with more than 60 minutes',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
  },
  playerComparison: {
    upTo5Players: 'Compare up to 5 players',
    requestReport: 'Request report',
    searchBarPlaceholder: 'Search player or team',
    allStats: 'All Stats',
    placeholder: 'You can start adding some players',
  },
  reports: {
    detailedInsights: 'Get Detailed Insights',
    features: 'Features of the report',
    performance: 'Performance',
    evolution: 'Evolution',
    compareWithMyTeam: 'Compare with my team',
    similarPlayers: 'Similar Players',
    potentialTeams: 'Potential Teams',
    requestSuccess: 'Request sent successfully',
    requestAt: 'Requested',
    reportConversation: 'Report Conversation',
    writeYourMessage: 'Write your message...',
    you: 'You',
  },
  state: {
    requested: 'Requested',
    inProgress: 'In progress',
    delivered: 'Delivered',
  },
  langs: {
    es: 'Spanish',
    en: 'English',
    fr: 'French',
    de: 'German',
    it: 'Italian',
    pt: 'Portuguese',
    tr: 'Turkish',
    jp: 'Japanese',
    cn: 'Chinese',
    sa: 'Arabic',
    nl: 'Dutch',
    pl: 'Polish',
    sv: 'Swedish',
    cs: 'Czech',
    ko: 'Korean',
    hu: 'Hungarian',
    ru: 'Russian',
  },
  langsArea: {
    europe: 'Europe',
    asia: 'Asia',
    arabic: 'Arabic',
  },
  inbox: {
    subtitle: 'Stay updated',
    new_injury_alert: 'New Injury Alert',
    new_contract_alert: 'New Contract Alert',
    new_team_alert: 'New Signing Alert',
    new_marketValue_alert: 'New Market Value Alert',
    new_game_alert: 'New Game Played Alert',
    receive_mail: 'Receive Mail',
    receive_mail_subtitle: 'Receive Daily Mail with players that meet filters',
    receive_notifications: 'Notifications',
    receive_notifications_subtitle:
      'Receive Notifications in the app with players that meet filters',
    changedTo: 'Changed to',
    alerts: 'Alerts',
    includedIn: 'Included in',
    noContract: 'No Contract',
    newMessages: 'New Messages',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder:
        'The user will receive the reply along with the status update',
    },
  },
  gameAnalysis: {
    subtitle: 'Get insights from the latests matches',
    subtitle2: 'Showing Games in next seven days',
    subtitle3:
      'Get insights from the latests matches and explore the next ones',
    seeDetail: 'See details',
  },
  statsNaming: {
    Possession: 'Possession',
    TimePossession: 'Time Possession',
    PassesPerShots: 'Passes per Shot',
    PPDA: 'PPDA',
    ExpectedPoints: 'Expected Points',
    Points: 'Points',
    Directness: 'Directness',
    PassesPerLongBall: 'Passes per Long Ball',
    CrossingPerXG: 'Crosses per xG',
    PenaltySavedPenaltyFaced: 'Penalty Saved/Penalty Faced',
    Goals: 'Goals',
    PenaltyShots: 'Penalty Shots',
    PenaltyGoals: 'Penalty Goals',
    NonPenaltyGoals: 'Non-Penalty Goals',
    NPGOpenPlay: 'NPG Open Play',
    NPGSetPiece: 'NPG Set Piece',
    Shooting: 'Shooting',
    Finishing: 'Finishing',
    xGEfficiency: 'xG Efficiency',
    HeaderPerShot: 'Header per Shot',
    HeaderPerCross: 'Header per Cross',
    HeadedGoals: 'Headed Goals',
    HeadedShots: 'Headed Shots',
    HeadedXG: 'Headed xG',
    HeadedSetPieceTooltip: 'Showing only players who have headers from set pieces',
    GoalsConceded: 'Goals Conceded',
    SavesInBox: 'Saves In Box',
    SavesOutBox: 'Saves Out of Box',
    Assists: 'Assists',
    ThroughBalls: 'Through Balls',
    CrossEfficiency: 'Cross Efficiency',
    ScoringContribution: 'Scoring Contribution',
    xAssistsOpenPlay: 'xAssists Open Play',
    xAssistsSetPiece: 'xAssists Set Piece',
    xAssistsOpenPlayInTeam: 'xAssists Open Play in Team',
    xAssistsSetPieceInTeam: 'xAssists Set Piece in Team',
    xGBuildupFinalThird: 'xG Build Up Final ⅓',
    xGChainFinalThird: 'xG Chain Final ⅓',
    BallProgressionPassing: 'Ball Prog. by Passing',
    BallProgressionDribbling: 'Ball Prog. by Carrying',
    TacklesWasDribbled: '1vs1 Defensive Win %',
    TacklesSuccessful: 'Successful Tackles',
    Interceptions: 'Interceptions',
    Clearances: 'Clearances',
    Fouls: 'Fouls',
    Recoveries: 'Recoveries',
    Shots: 'Shots',
    ShotsPerGoal: 'Shots per Goal',
    ShortPassesSuccessful: 'Successful Short Passes',
    PassingSuccessForwardPct: '% Passing Success Forward',
    PassingSuccessBackwardPct: '% Passing Success Backward',
    PassingForwardBackwardPct: '% Passing Forward per Backward',
    LongBallPerPassesPct: '% Long Ball per Passes',
    LongBallReceived: 'Long Balls Received',
    LongBallReceivedOppHalf: 'Long Balls received Opp. Half',
    OffensiveActions: 'Offensive Actions',
    DribblesAttempted: 'Dribbles Attempted',
    SuccessfulDribblesPct: '% Successful Dribbles',
    OffensiveTouchesOutBoxPct: '% Offensive Touches Out of Box',
    BallRetention: '% Ball Retention',
    PassingPct: '% Passing',
    PassingOwnHalfPct: '% Passing Own Half',
    PassingOppHalfPct: '% Passing Opp. Half',
    PassingFinalThird: 'Passes Final ⅓',
    PassesFinalThirdTotal: 'Total Passes Final ⅓',
    PassingFinalThirdPct: '% Passing Final ⅓',
    LongBallSuccessful: 'Completed Long Balls',
    LongBallPct: '% Long Balls',
    LongBallTotal: 'Total Long Balls',
    SavesPct: '% Saves',
    SavesInBoxPct: '% Saves in Box',
    SavesOutOfBoxPct: '% Saves Out of Box',
    xGSavedPerXGFacedOnTarget: 'xG Saved/xG Faced on Target',
    xGFacedOnTargetPerGoalReceived: 'xG Faced per Goal',
    xGFacedOnTargetEfficiency: 'Goals Prevented',
    xGFacedOnTarget: 'xG Faced on Target',
    IndividualPressure: 'Individual Pressure',
    AerialEfficiency: 'Aerial Efficiency',
    AerialWins: 'Aerial Wins',
    AerialWinsPct: '% Aerial Wins',
    xG: 'Expected Goals',
    xGDiff: 'xG Difference',
    xGOpenPlay: 'xG Open Play',
    xGSetPiece: 'xG Set Piece',
    xGPerShot: 'xG per Shot',
    ChancesCreated: 'Chances Created',
    CompletedCrosses: 'Completed Crosses',
    Crossing: '% Crossing',
    OpenPlayKeyPasses: 'Open Play Key Passes',
    OpenPlayKeyPassesInTeam: '% Open Play Key Passes in Team',
    OpenPlayPassesIntoOpponentBox: 'Total OP Passes into Box',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'OP Passes into Box',
    xAssists: 'Expected Assists',
    xGChain: 'xG Chain',
    xGBuildup: 'xG Build Up',
    xGBuildupInTeam: 'xG Build Up in Team',
    BallProgression: 'Ball Progression',
    SuccessfulDribbles: 'Successful Dribbles',
    Dispossessed: 'Dispossessed',
    TouchesInOpponentBox: 'Touches In Opponent Box',
    xGSavedPerShot: 'xG Saved per Shot',
    BallRetentionOppHalf: '% Ball Retention in Opp. Half',
    DeepProgression: 'Deep Progression',
    DeepProgressionFinalThird: 'Deep Progression into Final ⅓',
    FoulsTaken: 'Fouls Received',
    PenaltiesTaken: 'Penalties Taken',
    BlockedCrosses: 'Blocked Crosses',
    BlockedShots: 'Blocked Shots',
    Blocks: 'Blocks',
    NonPenaltyGoalsAgainst: 'Non-Penalty Goals Conceded',
    Headers: 'Headers',
    AveragePassDistance: 'Average Pass Distance',
    ProgressiveRuns: 'Progressive Carries',
    xT: 'Expected Threat (xT)',
    xTOpenPlay: 'xT Open Play',
    xTSetPiece: 'xT Set Piece',
    xGOT: 'Expected Goals On Target',
    BadActions: 'Bad Actions',
    BadActionsOwnHalf: 'Bad Actions Own Half',
    AerialsWonOwnBox: 'Aerial Wins Own Box',
    AerialsWonOppBox: 'Aerial Wins Opp Box',
    AerialsTotalOppBox: 'Aerials Total Opp Box',
    AerialsTotalOwnBox: 'Aerials Total Own Box',
    FoulsOwnHalfPct: '% Fouls Own Half',
    RecoveriesOppHalf: 'Recoveries Opp. Half',
    DuelsPct: '% Successful Duels',
    TacklesUnsuccessful: 'Unsuccessful Tackles',
    TacklesWasDribbledFirstThird: '1vs1 Defensive Win % ⅓',
    TacklesWasDribbledSecondThird: '1vs1 Defensive Win % ⅔',
    TacklesWasDribbledFinalThird: '1vs1 Defensive Win % Final ⅓',
    BallProgressionFinalThird: 'Ball Progression Final ⅓',
    DuelsTotal: 'Duels',
    QuickRecoveries: 'Quick Recoveries',
    ShotsPerNPG: 'Shots per NPG',
    ShotsOutBox: 'Shots out of Box',
    GoalsOutBox: 'Goals out of Box',
    ShootingOutBox: '% Shooting out of Box',
    HandPassing: '% Hand Passing',
    Catching: '% Catching',
    Caught: 'Caught Saves',
    ClaimAccuracy: 'Claim Accuracy',
    HighTurnovers: 'High Turnovers',
    ShotEndingHighTurnovers: 'Shot Ending High Turnovers',
    GoalEndingHighTurnovers: 'Goal Ending High Turnovers',
    AverageCarriesProgress: 'Average Carries Progress',
    ChanceEndingCarries: 'Chance Ending Carries',
    AssistEndingCarries: 'Assist Ending Carries',
    ShotEndingCarries: 'Shot Ending Carries',
    GoalEndingCarries: 'Goal Ending Carries',
    ShotEndingSequence: 'Shot Ending Sequence',
    GoalEndingSequence: 'Goal Ending Sequence',
    xGPerNPG: 'xG per NPG',
    AerialWonOffensive: 'Aerial Wins Offensive',
    AerialWonDefensive: 'Aerial Wins Defensive',
    xGAgainst: 'xG Conceded',
    xGDiffAgainst: 'xG Diff Conceded',
    xGPerNPGAgainst: 'xG per NPG Conceded',
    xGSetPieceAgainst: 'xG Set Piece Conceded',
    xGOpenPlayAgainst: 'xG Open Play Conceded',
    xGPerShotAgainst: 'xG per Shot Conceded',
    ShotsAgainst: 'Shots Conceded',
    ShotsOnTargetAgainst: 'Shots on Target Conceded',
    ShotsOnTargetInBoxAgainst: 'Shots on Target in Box Conceded',
    ShotsOnTargetOutBoxAgainst: 'Shots on Target out of Box Conceded',
    RivalPossession: 'Opponent Possession',
    AerialDefensivePct: '% Aerial Defensive',
    HighRecoveries: 'High Recoveries',
    HighDefensiveActions: 'High Defensive Actions',
    HighDefensiveActionPct: '% High Defensive Actions',
    HighDefensiveDistance: 'High Defensive Distance',
    PassesPerPossession: 'Passes per Possession',
    LengthPerPossession: 'Distance per Possession',
    xTNet: 'Net xT',
    AvgCarriesDistance: 'Avg. Carries Distance',
    PassesForwardPct: '% Forward Passes',
    PassesForwardSuccessful: 'Successful Forward Passes',
    PassesForwardTotal: 'Total Forward Passes',
    TacklesAttempted: 'Tackles Attempted',
    DuelsLost: 'Duels Lost',
    Carries: 'Carries',
    CarriesPct: '% Carries',
    Aerials: 'Aerial Duels',
    ProgressivePassesReceivedIntoBox: 'Progressive Passes Receive into Box',
    PassesOppHalf: 'Passes Opp. Half',
    ShotsOnTarget: 'Shots on Target',
    AggressiveActions: 'Aggresive Actions',
    Crosses: 'Crosses',
    xGBuildup5pass: 'xGBuildup 5 passes',
    SpeedSequence: "Sequence's Speed",
    Touches: 'Touches',
    AerialsTotalOppHalf: 'Aerials Total Opp. Half',
    AerialsWonOppHalf: 'Aerials Won Opp. Half',
    AerialsWonOppHalfPct: '% Aerial Wins Opp. Half',
    AerialsPctOppBox: '% Aerial Wins Opp. Box',
    AerialsPctOwnBox: '% Aerial Wins Own Box',
    AerialDefensive: 'Aerials Defensive',
    AerialOffensive: 'Aerials Offensive',
    AerialOffensivePct: '% Aerials Offensive',
    IndividualPressureOppHalf: 'Individual Pressure Opp. Half',
    ChancesCreatedOP: 'Chances Created Open Play',
    TouchesPerShot: 'Touches per Shot',
    PassesFinalThirdTotalPct: '% Passes Final ⅓',
    xACrosses: 'xA from Crosses',
    Passes: 'Passes',
    PassesSuccessful: 'Passes Successful',
    TacklesWasDribbledFouls: '% Ground Duels',
    OffsidesCaught: 'Offsides Caught',
    ProgressivePassesReceivedFinalThird: 'Progressive Passes Received Final ⅓',
    ProgressivePassesReceived: 'Progressive Passes Received',
    Breadth: 'Breadth',
    DuelsDefTotal: 'Defensive Duels',
    DefensiveActions: 'Defensive Actions',
    ProgressivePassesReceivedOppHalf: 'Prog. Passes Received Opp. Half',
    CompletedCrossesOP: 'Completed Crosses Open Play',
    CrossingOP: '% Crossing Open Play',
    CrossesOP: 'Total Crosses Open Play',
    PassingContribution: '% Passing Contribution',
    BallProgressionOppHalfInTeam: '% Ball Progression Opp. Half in Team',
    PassesOPIntoBoxInTeam: '% Passes Open Play into Box in Team',
    TouchesOppBoxInTeam: '% Touches Opp. Box in Team',
    xGOPInTeam: '% xG Open Play in Team',
    DeepPasses: 'Deep Passes Completed',
    DeepPassesTotal: 'Deep Passes',
    DefensiveDuelsPct: '% Defensive Duels',
    DefensiveDistance: 'Defensive Distance',
    QuickRecoveriesPct: '% Quick Recoveries',
    DiffDefensiveDistanceTeam: 'Diff. Defensive Distance Team',
    xTPassing: 'xT Passing',
    xTPassing100Passes: 'xT Passing 100 Passes',
    ProgressivePassesAccurate: 'Progressive Passes',
    PassAbility: 'Pass Ability',
    OPPassesIntoOppBoxPct: '% Open Play Passes into Opp. Box',
    EntriesOppBox: 'Entries Opp. Box',
    Crosses6yardBox: 'Crosses Six-Yard Box',
    Cutbacks: 'Cutbacks',
    xTDribbling: 'xT Dribbling',
    AvgShotDistance: 'Avg Shot Distance',
    xGOnTarget: 'xG on Target',
    FinishingxGOT: 'Finishing xGOT',
    DribblesWonOwnHalf: 'Dribbles Completed Own Half',
    DribblesOwnHalf: 'Dribbles Own Half',
    DribblesOwnHalfPct: '% Dribbles Own Half',
    DribblesWonOppHalf: 'Dribbles Completed Opp Half',
    DribblesOppHalf: 'Dribbles Opp. Half',
    DribblesOppHalfPct: '% Dribbles Opp. Half',
    DribblesWonFinalThird: 'Dribbles Completed Final ⅓',
    DribblesFinalThird: 'Dribbles Final ⅓',
    DribblesFinalThirdPct: '% Dribbles Final ⅓',
    ShotEndingHighRecoveries: 'Shot Ending High Recoveries',
    PassingFinalThirdAgainst: 'Passes Final ⅓ Conceded',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Total OP Passes into Box Conceded',
    EntriesOppBoxAgainst: 'Entries Opp. Box Conceded',
    DeepProgressionAgainst: 'Deep Progression Conceded',
    TouchesInOpponentBoxAgainst: 'Touches In Opp. Box Conceded',
    Score: 'Score',
    scoreDifference: "Score Difference: Shows if this game's performance was above or below the season average",
    PDScore: 'Physical Score',
    SpeedScore: 'Speed Power Score',
    EnduranceScore: 'Endurance Score',
    OrlegiScore: 'Score Orlegi',
    SirScore: 'Sirius Score',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT OP in Team',
    YellowCards: 'Yellow Cards',
    RedCards: 'Red Cards',
    xTOpenPlayAgainst: 'xT Open Play Conceded',
    xTSetPieceAgainst: 'xT Set Piece Conceded',
    NPGOpenPlayAgainst: 'NPG Open Play Conceded',
    NPGSetPieceAgainst: 'NPG Set Piece Conceded',
    PassesOppHalfPerPossession: 'Passes Opp. Half per Possession',
    AverageTimeRecovery: 'Avg Time Recovery',
    ExpectedPassing: '% Expected Passing',
    NumPossession10Passes: 'Possessions 10 Passes',
    PassesReceived: 'Passes Received',
    PassesReceivedFinalThird: 'Passes Received Final ⅓',
    ProgressivePassesTotalPct: '% Progressive Passes',
    ShortPassesPct: '% Short Passes',
    TouchesOppBoxOppTeam: 'Touches Opp Box Opp Team',
    ShotsOnTargetOppTeam: 'Shots On Target Opp Team',
    NPGOppTeam: 'NPG Opp Team',
    ShotsOpenPlay: 'Shots Open Play',
    xGSetPiecePerxG: 'xG Set Piece per xG',
    ShotsOpenPlayAgainst: 'Shots Open Play Against',
    ShotsFromDribble: 'Shots from Dribble',
    GoalsFromDribble: 'Goals from Dribble',
    PassesIntoFinalThird: 'Passes into Final ⅓',
    PassesIntoFinalThirdTotal: 'Total Passes into Final ⅓',
    PassesInsideFinalThird: 'Passes inside Final ⅓',
    PassesInsideFinalThirdTotal: 'Total Passes inside Final ⅓',
    PassesFinalThirdNoArea: 'Passes Final ⅓ (W/O Box)',
    PassesIntoOppBox: 'Passes into Opp Box',
    CarriesFinalThird: 'Carries Final ⅓',
    CarriesInsideFinalThird: 'Carries inside Final ⅓',
    CarriesFinalThirdNoBox: 'Carries Final ⅓ (W/O Box)',
    CarriesIntoOppBox: 'Carries into Opp Box',
    TimePossessionAgainst: 'Time Possession Against',
    TimePossessionTotal: 'Time Possession Total',
    PassesInBox: 'Passes in Box',
    LongThrowInSuccessful: 'Long ThrowIn Successful',
    LongThrowInTotal: 'Long ThrowIn Total',
    LongThrowInPct: '% Long ThrowIn',
    Games: 'Games Played',
    PointsPerGame: 'Points Per Game',
    ExpectedPointsDiff: 'Expected Points Difference',
    PassesTotalOwnHalf: 'Total Passes Own Half',
    PassesOwnHalf: 'Passes Own Half',
    PassesTotalOppHalf: 'Passes Total Opp Half',
    ProgressivePassesTotal: 'Total Progressive Passes',
    DuelsWon: 'Duels Won',
    NonPenaltySaves: 'Non Penalty Saves',
    BadActionsOppHalf: 'Bad Actions Opp Half',
    CarriesSuccessful: 'Carries Successful',
    ShotsOnTargetOutBox: 'Shots on Target out of Box',
    SwitchPlaySuccessful: 'Switch Play Successful',
    SwitchPlayTotal: 'Switch Play Total',
    PassesInsideOppHalf: 'Passes inside Opp Half',
    PassesInsideOppHalfSuccessful: 'Passes inside Opp Half Successful',
    TacklesAttemptedFirstThird: 'Tackles Attempted First ⅓',
    TacklesAttemptedSecondThird: 'Tackles Attempted Second ⅓',
    TacklesFirstThird: 'Tackles Successful First ⅓',
    TacklesSecondThird: 'Tackles Successful Second ⅓',
    FoulsOwnHalf: 'Fouls Own Half',
    TouchesOppHalf: 'Touches Opp Half',
    TacklesAttemptedNotAdjusted: 'Tackles Attempted Not Adjusted',
    TacklesSuccessfulNotAdjusted: 'Tackles Successful Not Adjusted',
    // Physical Stats
    TotalDistance: 'Total Distance',
    DistanceTIP: 'Distance TIP',
    DistanceOTIP: 'Distance OTIP',
    SprintsNumber: 'Sprints Quantity',
    SprintsDistance: 'Sprints Distance',
    WalkingDistance: 'Walking Distance',
    JoggingDistance: 'Jogging Distance',
    RunningDistance: 'Running Distance',
    ExtremeAccelerations: 'Extreme Accelerations',
    NumberOfRuns: 'Runs Quantity',
    HsrNumber: 'HSR Quantity',
    HsrDistance: 'HSR Distance',
    SprintNumberDeclinePct: '% Sprint Quantity Decline',
    SprintDistanceDeclinePct: '% Sprint Distance Decline',
    SprintNumberDecline: 'Sprint Quantity Decline',
    SprintDistanceDecline: 'Sprint Distance Decline',
    HsrDistancePct: '% HSR Distance',
    SprintDistancePct: '% Sprint Distance',
    Accelerations: 'Accelerations',
    ExplosiveDistance: 'Explosive Distance',
    MaxSpeed: 'Max. Speed',
    AvgMaxSpeed: 'Avg. Max. Speed',
    MaxAccelerations: 'Max. Accelerations',
    HsrDistanceIP: 'HSR Distance IP',
    HsrDistanceOOP: 'HSR Distance OOP',
    JoggingDistanceIP: 'Jogging Distance IP',
    JoggingDistanceOOP: 'Jogging Distance OOP',
    RunningDistanceIP: 'Running Distance IP',
    RunningDistanceOOP: 'Running Distance OOP',
    SprintsDistanceIP: 'Sprints Distance IP',
    SprintsDistanceOOP: 'Sprints Distance OOP',
    WalkingDistanceIP: 'Walking Distance IP',
    WalkingDistanceOOP: 'Walking Distance OOP',
    // Arrigo
    BypassedPlayersByPasses: 'Bypassed Players by Passes',
    BypassedDefendersByPasses: 'Bypassed Defenders by Passes',
    PassesBypassingPlayers: 'Passes Bypassing Players',
    PassesBypassingDefenders: 'Passes Bypassing Defenders',
    BypassedPlayersPerPass: 'Bypassed Players per Pass',
    BypassedDefendersPerPass: 'Bypassed Defenders per Pass',
    LineBreakingPasses: 'Line Breaking Passes',
    LineBreakingPassesMD: 'Line Breaking Passes (MD Line)',
    LineBreakingPassesM: 'Line Breaking Passes (M Line)',
    LineBreakingThroughBalls: 'Line Breaking Through Balls',
    LineBreakingPassesPerPass: '% Line Breaking Passes per Pass',
    TotalPassesUnderStrongPressure: 'Total Passes Under Strong Pressure',
    TotalPassesUnderLightPressure: 'Total Passes Under Pressure',
    SuccessfulPassesUnderStrongPressure:
      'Successful Passes Under Strong Pressure',
    SuccessfulPassesUnderLightPressure: 'Successful Passes Under Pressure',
    PassingUnderStrongPressure: '% Passing Under Strong Pressure',
    PassingUnderLightPressure: '% Passing Under Pressure',
    PassReceiptsInSpaceCompleted: 'Pass Receipts in Space Completed',
    PassReceiptsInSpace: 'Pass Receipts in Space',
    PassReceiptsInSpaceCompletedFirstThird:
      'Pass Receipts in Space Completed First ⅓',
    PassReceiptsInSpaceCompletedSecondThird:
      'Pass Receipts in Space Completed Second ⅓',
    PassReceiptsInSpaceCompletedFinalThird:
      'Pass Receipts in Space Completed Final ⅓',
    PassReceiptsInSpaceCompletedOppHalfRight:
      'Pass Receipts in Space Completed Opp Half Right',
    PassReceiptsInSpaceCompletedOppHalfCenter:
      'Pass Receipts in Space Completed Opp Half Center',
    PassReceiptsInSpaceCompletedOppHalfLeft:
      'Pass Receipts in Space Completed Opp Half Left',
    PassReceiptsInSpaceFirstThird: 'Pass Receipts in Space First ⅓',
    PassReceiptsInSpaceSecondThird: 'Pass Receipts in Space Second ⅓',
    PassReceiptsInSpaceFinalThird: 'Pass Receipts in Space Final ⅓',
    PassReceiptsInSpaceOppHalfRight: 'Pass Receipts in Space Opp Half Right',
    PassReceiptsInSpaceOppHalfCenter: 'Pass Receipts in Space Opp Half Center',
    PassReceiptsInSpaceOppHalfLeft: 'Pass Receipts in Space Opp Half Left',
    TotalStrongOnBallPressures: 'Total Strong on Ball Pressures',
    TotalLightOnBallPressures: 'Total on Ball Pressures',
    SuccessfulStrongOnBallPressures: 'Successful Strong on Ball Pressures',
    SuccessfulLightOnBallPressures: 'Successful On Ball Pressures',
    StrongOnBallPressuresPct: '% Strong on Ball Pressures',
    LightOnBallPressuresPct: '% On Ball Pressures',
    TimesBypassedByPasses: 'Times Bypassed by Passes',
    TimesBypassedByCarries: 'Times Bypassed by Carries',
    TimesBypassedByActions: 'Times Bypassed by Actions',
    BypassedPlayersByCarries: 'Bypassed Players by Carries',
    BypassedDefendersByCarries: 'Bypassed Defenders by Carries',
    BypassedPlayersByActions: 'Bypassed Players by Actions',
    BypassedDefendersByActions: 'Bypassed Defenders by Actions',
    CarriesBypassingPlayers: 'Carries Bypassing Players',
    CarriesBypassingDefenders: 'Carries Bypassing Defenders',
    BypassedPlayersPerCarry: 'Bypassed Players per Carry',
    BypassedDefendersPerCarry: 'Bypassed Defenders per Carry',
    LineBreakingCarries: 'Line Breaking Carries',
    LineBreakingCarriesMD: 'Line Breaking Carries MD',
    LineBreakingCarriesM: 'Line Breaking Carries M',
    LineBreakingCarriesD: 'Line Breaking Carries D',
    LineBreakingCarriesPerCarry: '% Line Breaking Carries per Carry',
    LineBreakingActions: 'Line Breaking Actions',
    LineBreakingActionsMD: 'Line Breaking Actions MD',
    LineBreakingActionsM: 'Line Breaking Actions M',
    LineBreakingActionsD: 'Line Breaking Actions D',
    PassesPerLineBreakingPass: 'Passes per Line Breaking Pass',
    CarriesPerLineBreakingCarry: 'Carries per Line Breaking Carry',
    LinesBrokenByPasses: 'Lines Broken by Passes',
    LinesBrokenByCarries: 'Lines Broken by Carries',
    LinesBrokenByActions: 'Lines Broken by Actions',
    LinesBrokenPerPass: 'Lines Broken per Pass',
    LinesBrokenPerCarry: 'Lines Broken per Carry',
    AvgLastDefenderDistanceIP: 'Last Defender Distance IP',
    AvgLastDefenderDistanceOOP: 'Last Defender Distance OOP',
    AvgDefensiveLineDistanceIP: 'Defensive Line Distance IP',
    AvgDefensiveLineDistanceOOP: 'Defensive Line Distance OOP',
    AvgRBDistanceIP: 'Right-Back Distance IP',
    AvgRBDistanceOOP: 'Right-Back Distance OOP',
    AvgLBDistanceIP: 'Left-Back Distance IP',
    AvgLBDistanceOOP: 'Left-Back Distance OOP',
    AvgBlockDistanceIP: 'Block Distance IP',
    AvgBlockDistanceOOP: 'Block Distance OOP',
    AvgBlockAreaIP: 'Block Area IP',
    AvgBlockAreaOOP: 'Block Area OOP',
    AvgDefensiveLineWidthOOP: 'Def. Line Width OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Off. Line Last Third Width IP',
    AvgLByIP: 'Left-Back Position IP',
    AvgRByIP: 'Right-Back Position IP',
    AvgOffensiveLineDistanceIP: 'Offensive Line Distance IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Off. Line Last Third Distance IP',
    AvgOffensiveLineWidthIP: 'Offensive Line Width IP',
    OffBallRuns: 'Total Off-Ball Runs',
    OffBallRunsOverlap: 'Off-Ball Runs Overlap',
    OffBallRunsUnderlap: 'Off-Ball Runs Underlap',
    OffBallRunsRunAhead: 'Off-Ball Runs Ahead',
    OffBallRunsRunBehind: 'Off-Ball Runs Behind',
    OffBallRunsCrossReceiver: 'Off-Ball Runs Cross Receiver',
    OffBallRunsSupport: 'Off-Ball Runs Support',
    OffBallRunsComingShort: 'Off-Ball Runs Coming Short',
    AvgTop5MaxSpeed: 'Avg Top5 MaxSpeed',
    LBPReceived: 'Line Breaking Passes Received',
    LBPMReceived: 'Line Breaking Passes (M Line) Received',
    LBPMDReceived: 'Line Breaking Passes (MD Line) Received',
    ThroughBallReceived: 'Through Balls Received',
    description: {
      Possession: 'Percentage of ball possession of the team',
      TimePossession: 'Time of ball possession of the team',
      PassesPerShots: 'Average number of passes given per shot',
      PPDA:
        'Conceded Passes per Defensive Action. PPDA measures the pressure that the team puts on the opposition players when they are in possession of the ball. The value corresponds with the average number of passes on a row the opponent was able to complete before being interrupted. The higher the value is, the more passes the opponent was allowed to complete',
      Directness:
        'Measures how direct a team is. A high value of directness is related to a higher quantity of forward passes with respect to sideways passes',
      ExpectedPoints:
        'Number of points expected by a team, calculated based on the Expected Goals generated and conceded. This metric allows us to better assess the performance of a team during a game (or a set of games) when compared to the number of points actually achieved',
      PassesPerLongBall:
        'Percentage of successful long passes out of the total number of completed passes',
      CrossingPerXG: 'Percentage of Expected Goals coming from crosses',
      PenaltySavedPenaltyFaced:
        'Percentage of Penalty Shots Saved out of all Penalty Shots Faved',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Total number of shots taken from penalty kicks',
      PenaltyGoals: 'Total number of goals taken from penalty kicks',
      NonPenaltyGoals:
        'Number of goals scored excluding penalty goals',
      NPGOpenPlay:
        'Number of goals scored by open play actions excluding penalty goals',
      NPGSetPiece:
        'Number of goals scored by set piece actions excluding penalty goals',
      Shooting: 'Percentage of shots on target',
      Finishing: 'Percentage of shots ending in a goal',
      xGEfficiency:
        'Quantity of expected goals needed for a player to score a goal',
      HeaderPerShot: 'Number of headers made',
      HeaderPerCross:
        'Percentage of crosses headed by the player out of the total number of crosses completed by the team',
      Assists: 'Number of assists',
      ThroughBalls:
        'Number of balls played through for player making an attacking run to create a change on goal',
      CrossEfficiency:
        'Metric that combines percentage of successful crosses together with the volume of successful crosses made',
      ScoringContribution: 'Number of assists and goals',
      xAssistsOpenPlay:
        'Number of expected assists generated by open play',
      xAssistsSetPiece:
        'Number of expected assists generated by set piece',
      xAssistsOpenPlayInTeam:
        'Number of expected assists generated by open play in team',
      xAssistsSetPieceInTeam:
        'Number of expected assists generated by set piece in team',
      xGChainFinalThird:
        'Quantity of xG a player has taken part in the final third',
      xGBuildupFinalThird:
        'Quantity of xG a player has taken part in the final third (excluding shots and passes leading to a shot)',
      BallProgressionPassing:
        'Number of times the player progresses the ball 10 meters or more by passing the ball',
      BallProgressionDribbling:
        'Number of times the player progresses the ball 10 meters or more by carrying the ball',
      TacklesWasDribbled:
        'Metric that takes into account the percentage of times the player recovers the ball via tackling vs. the times it was passed/run. The higher the indicator the better',
      TacklesSuccessful: 'Number of successful tackles made by the player',
      Interceptions:
        'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances:
        'Number of times the player hits the ball clear of the defensive zone',
      Fouls: 'Number of fouls committed by the player',
      Recoveries:
        'Number of balls recovered by a player',
      Shots: 'Number of total shots made',
      ShotsPerGoal:
        'Shots on target needed to score a non-penalty goal to the Goalkeeper',
      ShortPassesSuccessful:
        'Short passes (under 12 meters) completed',
      PassingSuccessForwardPct:
        'Percentage of successful passes in the forward direction',
      PassingSuccessBackwardPct: 'Percentage of successful passes backwards',
      PassingForwardBackwardPct:
        'Ratio of passes in the forward direction against passes backwards',
      LongBallPerPassesPct:
        'Percentage of long passes completed (>32 meters) out of all passes completed by the player.',
      LongBallReceived: 'Long passes (>32 meters) received by the played',
      LongBallReceivedOppHalf:
        'Long passes (>32 meters) received by the played on the opponent half',
      OffensiveActions: 'Offensive Actions',
      DribblesAttempted: 'Dribbles attempted',
      SuccessfulDribblesPct: 'Successful dribbles/total of dribbling attempts',
      OffensiveTouchesOutBoxPct: '% Offensive Touches Out of Box',
      BallRetention:
        "Percentage of the time you have possession of the ball and don't end up losing it",
      PassingPct:
        'Percentage of passes completed out of all passes given by the player',
      PassingOwnHalfPct:
        'Percentage of passes completed out of all passes given by the player (only passes on the own half)',
      PassingOppHalfPct:
        'Percentage of passes completed out of all passes given by the player (only passes into opponent half)',
      PassingFinalThird:
        'Successful passes, excluding crosses, set pieces, corners and throw-ins, that end in the final third',
      PassesFinalThirdTotal:
        'Total passes attempted, excluding crosses, set pieces, corners and throw-ins, that end in the final third',
      PassingFinalThirdPct:
        'Percentage of passes completed out of all passes given by the player (only passes that end in the final third)',
      LongBallSuccessful: 'Completed passes over 32 meters',
      LongBallPct:
        'Completed passes over 32 meters/ Total passes over 32 attempted',
      LongBallTotal: 'Total number of passes over 32 meters',
      SavesPct: 'Percentage of saves out of the total number of shots conceded',
      SavesInBoxPct: 'Percentage of saved shots shots coming inside the box',
      SavesOutOfBoxPct: 'Percentage of saved shots coming outside the box',
      xGSavedPerXGFacedOnTarget:
        'Coefficient that indicates the percentage of the expected xG that are saved by the Goalkeeper. A value of 1 in this metric would mean that the goalkeeper saves all expected goals of the shots conceded by the team, while a value of 0 would mean that all expected goals generated by the opponent end up in goal',
      xGFacedOnTargetPerGoalReceived:
        'Metric that indicates how many Expected Goals are needed to score a goal to a certain Goalkeeper. A high score in this metric means that to convert a goal to this Goalkeeper it is necessary to create a high number of xG',
      xGFacedOnTargetEfficiency:
        'Number of Non-Penalty Goals prevented by the Goalkeeper. This is the number of Expected Goals On Target received by the Goalkeeper minus the number of (non-penalty) goals conceded. Indicates the number of goals that were not scored by the opponent thanks to the goalkeeper',
      xGFacedOnTarget: 'Total xG (saved and scored) faced by the goalkeeper',
      IndividualPressure:
        'Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent',
      AerialEfficiency:
        'Metric that combines percentage of successful aerial duels together with the volume of aerial duel wins',
      AerialWins: 'Number of aerials that the player wins',
      AerialWinsPct:
        'Number of aerials that the player wins out of the total number of aerial duels where the player was involved',
      xG:
        "Expected Goals generated. This metrics measures a shots's probability of ending in a goal based on different variables (distance, angle, type of play, part of the body, ...) of such action.",
      xGDiff: 'Difference between xG and Goals',
      xGOpenPlay: 'Expected Goals generated by Open Play',
      xGSetPiece: 'Expected Goals generated by Set Piece',
      xGPerShot:
        'Average xG of the shots made by a player. This metric measures the average dangerousness of the shots taken. The higher, the more likely it is that your shots will end up in goal. An xG per high shot means that the player chooses his shots well.',
      ChancesCreated: 'Number of passes leading to a shot',
      CompletedCrosses: 'Number of Crosses Completed',
      Crossing:
        'Percentage of crosses that have been completed out of crosses attempted',
      OpenPlayKeyPasses:
        'Number of passes completed during open play',
      OpenPlayKeyPassesInTeam:
        'Percentage of passes completed during open play in team',
      OpenPlayPassesIntoOpponentBox:
        'Total number of passes attempted into the opponent box during open play',
      OpenPlayPassesIntoOpponentBoxSuccessful:
        'Number of passes completed into the opponent box during open play',
      xAssists:
        'Metric that analyses the quality of the chances created that take place in a match. Each shooting assists has a value based on the probability that the shot ends up being scored. This value is assigned according to the place of the pass, the type (cross throughball set piece…), state of the game etc. Unlike xG, xA is a metric that ideally a player would have higher than his assist numbers since a creator can only control his quality passes (xA), whereas his assist number depend on the finisher',
      xGChain: 'Quantity of xG a player has taken part in',
      xGBuildup:
        'Similar to xG Chain but not taking into account the last 2 players of the sequence (excluding shots and passes leading to a shot)',
      xGBuildupInTeam:
        'Similar to xG Chain but not taking into account the last 2 players of the sequence (excluding shots and passes leading to a shot) in team',
      BallProgression:
        'Number of times the player advances 10 or more meters either by passing, by carrying the ball or a combination of both',
      SuccessfulDribbles:
        'Dribbles successfully completed',
      Dispossessed:
        'Number of times a player is tackled and loses possession of the ball',
      TouchesInOpponentBox:
        'Number of times the possession of the ball is in the opponent box',
      xGSavedPerShot: 'Average probability of goal of conceded shots on target',
      BallRetentionOppHalf:
        "Percentage of the time you have possession of the ball and don't end up losing it in the opponent half",
      DeepProgression:
        'Number of times the last fifth of the pitch is reached by carrying the ball, plus the number of times the possession of the ball is in the last fifth',
      DeepProgressionFinalThird:
        'Number of times the final third of the pitch is reached by carrying the ball, plus the number of times the possession of the ball is in the final third',
      FoulsTaken:
        'Number of times the player was fouled',
      PenaltiesTaken:
        'Number of times the player was fouled in the opponent box',
      BlockedCrosses: 'Crosses blocked',
      BlockedShots: 'Shots blocked',
      NonPenaltyGoalsAgainst:
        'Number of non-penalty goals conceded',
      GoalsConceded: 'Number of goals conceded',
      Headers: 'Number of Shots made with the Head',
      HeadedGoals: 'Number of goals scored with the head',
      SavesInBox: 'Number of saves from shots inside the box',
      SavesOutBox: 'Number of saves from shots outside the box',
      Points: 'Number of points achieved by the team',
      ShotsOnTargetInBoxAgainst: 'Number of shots on target from inside the box conceded',
      ShotsOnTargetOutBoxAgainst: 'Number of shots on target from outside the box conceded',
      AveragePassDistance: 'Average Distance of Passes in meters',
      ProgressiveRuns:
        'Successful carries that bring the possession a 20% closer to the opponent goal',
      xT:
        "Expected Threat (xT) is a metric that measures the threat a player creates to the opponent by carrying or passing the ball to areas where the possession's probability of ending in a goal is higher.",
      xTOpenPlay:
        'Expected Threat generated during open play',
      xTSetPiece:
        'Expected Threat generated by set piece',
      xGOT:
        'Expected Goals On Target. Number of Expected Goals faced by the Goalkeeper. This metric only takes into account shots on target (Shots missed and shots on post are exluded)',
      BadActions:
        'Sum of all bad actions committed (pass unsuccessful, take on unsuccessful, dispossessed, offside pass, ball touch unsuccessful)',
      BadActionsOwnHalf:
        'Sum of all bad actions committed (pass unsuccessful, take on unsuccessful, dispossessed, offside pass, ball touch unsuccessful) in the own half',
      AerialsWonOwnBox: 'Aerial Duel Wins Own Box',
      AerialsWonOppBox: 'Aerials Duel Wins Opp Box',
      AerialsTotalOppBox: 'Aerials Duels Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Duels Total Own Box',
      FoulsOwnHalfPct: 'Percentage of Fouls commited in the own half',
      RecoveriesOppHalf:
        'Number of balls recovered by a player in the opponent half',
      DuelsPct: 'Percentage of Successful Duels',
      TacklesUnsuccessful:
        'Number of times a player fails to win the ball as an opponent successfully dribbles past them',
      TacklesWasDribbledFirstThird:
        'Percentage of times the player recovers the ball when faced in the final third',
      TacklesWasDribbledSecondThird: '1vs1 Defensive Win % ⅔',
      TacklesWasDribbledFinalThird: '1vs1 Defensive Win % Final ⅓',
      BallProgressionFinalThird: 'Ball Progression Final Third',
      DuelsTotal:
        'Total number of Tackles, Aerials, Ball Touches, Dribbles and Fouls committed',
      QuickRecoveries:
        'Recoveries 40 meters or more from the own goal made 8 seconds after losing the possession of the ball',
      ShotsPerNPG: 'Average number of shots to score a Non-Penalty Goal',
      ShotsOutBox: 'Number of Shots from outside the box',
      GoalsOutBox: 'Number of Goals from outside the box',
      ShootingOutBox: 'Percentage of shots on target from outside of Box',
      HandPassing: 'Passing Accuracy with Hands',
      Catching: 'Percentage of Saves in which the Goalkeeper catches the ball',
      Caught: 'Saves where the goalkeeper catches and holds the ball, preventing any second play',
      ClaimAccuracy:
        'Measures how good a Goalkeeper is at catching/blocking aerial balls. A number above 1 indicates that the Goalkeeper catches more aerial balls than expected',
      HighTurnovers: 'Turnovers closer than 40 meters from the own goal',
      ShotEndingHighTurnovers:
        'High turnovers (turnovers closer than 40 meters from the own goal) ending in a shot of the opponent team',
      GoalEndingHighTurnovers:
        'High turnovers (turnovers closer than 40 meters from the own goal) ending in a goal of the opponent team',
      AverageCarriesProgress:
        'Average distance that a player moves the ball vertically per carry (meters)',
      ChanceEndingCarries:
        'Carries of at least 7 meters ending in a pass that is followed by a shot',
      AssistEndingCarries:
        'Carries of at least 7 meters ending in a pass that is followed by a goal',
      ShotEndingCarries: 'Carries of at least 7 meters ending in a shot',
      GoalEndingCarries: 'Carries of at least 7 meters ending in a goal',
      ShotEndingSequence:
        'Number of Sequences ending in a Shot where the player was involved',
      GoalEndingSequence:
        'Number of Sequences ending in a Goal where the player was involved',
      xGPerNPG: 'Expected Goals needed to score a non-penalty goal',
      AerialWonOffensive: 'Offensive Aerial Duel Wins',
      AerialWonDefensive: 'Defensive Aerial Duel Wins',
      xGAgainst: 'Expected Goals Conceded',
      xGDiffAgainst:
        'Difference between Expected Goals Conceded and Goals Conceded',
      xGPerNPGAgainst: 'Expected Goals received per Non-Penalty Goal Conceded',
      xGSetPieceAgainst: 'Expected Goals generated by Set Piece Conceded',
      xGOpenPlayAgainst: 'Expected Goals generated by Open Play Conceded',
      xGPerShotAgainst: 'Expected Goals Received per Shot Conceded',
      ShotsAgainst: 'Number of Shots Conceded',
      ShotsOnTargetAgainst:
        'Number of Shots on Target Conceded',
      RivalPossession: 'Possession of the opponent',
      AerialDefensivePct: 'Percentage of Aerial wins without ball possession',
      HighRecoveries:
        "Recoveries made 40 meters or closer to the opponent's goal",
      HighDefensiveActions:
        'Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline',
      HighDefensiveActionPct:
        'Percentage of Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline',
      HighDefensiveDistance:
        'Average distance from own goal of all Defensive Actions',
      PassesPerPossession: 'Number of Passes per Possession',
      LengthPerPossession: 'Distance per Possession',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Average Carries Distance',
      PassesForwardPct: '% Forward Passes',
      PassesForwardSuccessful: 'Successful Forward Passes',
      PassesForwardTotal: 'Total Forward Passes',
      TacklesAttempted: 'Tackles Attempted',
      DuelsLost: 'Duels Lost',
      Carries: 'Total number of carries of at least 7 meters',
      CarriesPct: '% Carries',
      Aerials: 'Total number of Aerial Duels',
      ProgressivePassesReceivedIntoBox: 'Progressive Passes Receive into Box',
      PassesOppHalf: 'Successful passes ending into the opponent half',
      ShotsOnTarget: 'Shots made on target',
      AggressiveActions:
        'Number of Tackles attempted in the next two seconds after losing the possession',
      Crosses: 'Total Number or Crosses',
      xGBuildup5pass:
        'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
      SpeedSequence:
        'Average Speed (meters covered by time spent) of all possessions of a team',
      Touches:
        'Number of times a player has possession of the ball',
      AerialsTotalOppHalf:
        'Aerial duels total into opponent half',
      AerialsWonOppHalf:
        'Aerial duels successful into opponent half',
      AerialsWonOppHalfPct: 'Percentage of aerial duel wins into opponent half',
      AerialsPctOppBox: 'Percentage of aerial duel wins into opponent box',
      AerialsPctOwnBox: 'Percentage of aerial duel wins into own box',
      AerialDefensive: 'Total number of Aerials when opponent team has possession',
      AerialOffensive:
        'Total number of Aerials when own team has possession',
      AerialOffensivePct:
        'Percentage of Aerial wins when own team has possession',
      IndividualPressureOppHalf:
        'Metric that measures the number of successful efforts (possessions recovered) made by a player when pressing the opponent in the opponent half',
      ChancesCreatedOP:
        'Number of passes leading to a shot during open play',
      TouchesPerShot: 'Number of times players touch the ball per shot',
      PassesFinalThirdTotalPct:
        'Percentage of passes (successful and unsuccessful) into final third',
      xACrosses:
        'Expected assists generated from crosses',
      Passes: 'Total number of passes',
      PassesSuccessful: 'Number of Completed Passes',
      TacklesWasDribbledFouls:
        'Percentage of tackles won with respect to total tackles and fouls committed',
      OffsidesCaught: 'Offsides Caught',
      ProgressivePassesReceivedFinalThird:
        'Progressive Passes Received Final ⅓',
      ProgressivePassesReceived: 'Progressive Passes Received',
      Breadth:
        'Sum of Tackles, Challenges, Interceptions and Fouls Committed, on the sides of the field',
      DuelsDefTotal:
        'Sum of total Tackles, Defensive Aerial Duels and Fouls committed',
      DefensiveActions:
        'Defensive Actions when an opponent tries to dribble (Tackles, Challenges, Interceptions and Fouls)',
      ProgressivePassesReceivedOppHalf: 'Progressive Passes Received Opp. Half',
      CompletedCrossesOP: 'Successful number of crosses during open play',
      CrossingOP:
        'Percentage of crosses completed out of all crosses attempted open play',
      CrossesOP: 'Total number of crosses during open play',
      PassingContribution:
        'Percentage that measures threat of passes taking into account the position of the receiver',
      BallProgressionOppHalfInTeam: '% Ball Progression Opp. Half in Team',
      PassesOPIntoBoxInTeam: '% Passes Open Play into Box in Team',
      TouchesOppBoxInTeam: '% Touches Opp. Box in Team',
      xGOPInTeam: '% xG Open Play in Team',
      DeepPasses:
        'Successful passes from outside a 20-metre radius of the opponent goal that end inside that area',
      DeepPassesTotal: 'Total of passes attempted from outside a 20-metre radius of the opponent goal that end inside that area',
      DefensiveDuelsPct:
        'Percentage of defensive duels won out of total defensive duels',
      DefensiveDistance:
        'Average distance to own goal of defensive duels performed',
      QuickRecoveriesPct:
        'Percentage of quick recoveries to interceptions and attempted tackles',
      DiffDefensiveDistanceTeam:
        "Difference between the player's defensive distance and his team's defensive distance",
      xTPassing: 'Expected threat generated only from passes',
      xTPassing100Passes:
        'Expected threat generated only from passes and per 100 passes',
      ProgressivePassesAccurate:
        'Completed passes of 10 meters or more in the X-axis',
      PassAbility: 'Ratio of completed passes to expected passes (xP)',
      OPPassesIntoOppBoxPct:
        'Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box',
      EntriesOppBox: 'Number of passes and carries into the opponent box',
      Crosses6yardBox: 'Total number of crosses ending in the six-yard box',
      Cutbacks: 'Passing from baseline to back and inside the opponent box',
      xTDribbling: 'Expected threat generated only from dribbles',
      AvgShotDistance: 'Average distance of the total number of shots taken',
      xGOnTarget:
        'Expected goals from shots made on target. Measures the probability of a shot ending in a goal using the end location of the shot',
      FinishingxGOT:
        'Percentage of shots on target ending in a goal above average. This metric measures how much value the striker adds with the quality of his shots',
      DribblesWonOwnHalf: 'Successful dribbles made in own half',
      DribblesOwnHalf: 'Number of attempted dribbles made in own half',
      DribblesOwnHalfPct:
        'Percentage of successful dribbles and attempted dribbles made in own half',
      DribblesWonOppHalf: 'Successful dribbles made in opponent half',
      DribblesOppHalf: 'Number of attempted dribbles made in opponent half',
      DribblesOppHalfPct:
        'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Successful dribbles made in the final third',
      DribblesFinalThird:
        'Number of attempted dribbles made in the final third',
      DribblesFinalThirdPct:
        'Percentage of successful dribbles and attempted dribbles made in the final third',
      ShotEndingHighRecoveries:
        "High recoveries (recoveries made 40 meters or closer to the opponent's goal) ending in a shot",
      PassingFinalThirdAgainst:
        'Successful passes from the opponent to the final third',
      OpenPlayPassesIntoOpponentBoxAgainst:
        'Total number of passes attempted from the opponent into the own box during open play',
      EntriesOppBoxAgainst:
        'Number of passes and carries from the opponent into the own box',
      DeepProgressionAgainst:
        'Number of times the opponent reaches the last fifth of the pitch by carrying the ball, plus the number of times the possession of the ball is in the first fifth',
      TouchesInOpponentBoxAgainst:
        'Number of times the opponent has possession of the ball in our box',
      Score: 'Player performance based on different metrics',
      PDScore:
        'Player physical performance based on different physical metrics',
      SpeedScore: 'Player physical performance based on different speed metrics',
      EnduranceScore: 'Player endurance physical performance based on different metrics',
      OrlegiScore: 'Player performance based on different metrics',
      SirScore: 'Player performance based on different metrics',
      ExcScore: 'Player performance based on different metrics',
      xTOPInTeam: 'Expected threat generated during open play in team',
      YellowCards: 'Yellow cards received',
      RedCards: 'Red cards received',
      xTOpenPlayAgainst: 'Expected Threat conceded during open play',
      xTSetPieceAgainst: 'Expected Threat conceded by set piece',
      NPGOpenPlayAgainst:
        'Number of goals conceded by open play actions excluding penalty goals',
      NPGSetPieceAgainst:
        'Number of goals conceded by set piece actions excluding penalty goals',
      PassesOppHalfPerPossession: 'Passes Opp. Half per Possession',
      AverageTimeRecovery: 'Avg Time Recovery',
      ExpectedPassing: 'Percentage of Passes that should have been completed',
      NumPossession10Passes: 'Possessions generated by 10 or more passes',
      PassesReceived: 'Passes Received',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct:
        'Percentage of progressive passes completed out of the total progressive passes attempted',
      ShortPassesPct: 'Percentage of Short Passes',
      TouchesOppBoxOppTeam:
        'Number of opponent actions conceded inside own box while the player is on the pitch',
      ShotsOnTargetOppTeam:
        'Shots on target conceded while the player is on the pitch',
      NPGOppTeam: 'Non-penalty goals conceded while the player is on the pitch',
      xGSetPiecePerxG:
        'Expected Goals generated by set piece needed to generate one expected goal',
      ShotsOpenPlay: 'Number of shots generated by open play',
      ShotsOpenPlayAgainst: 'Number of shots received by open play',
      ShotsFromDribble: 'Shots made after dribble an opponent',
      GoalsFromDribble: 'Goals made after dribble an opponent',
      PassesIntoFinalThird:
        'Successful passes that start outside and end inside the final third',
      PassesIntoFinalThirdTotal:
        'Total passes attempted that start outside and end inside the final third',
      PassesInsideFinalThird:
        'Successful passes within the final third (start and end in the final third)',
      PassesInsideFinalThirdTotal: 'Total of passes attempted within the final third (start and end in the final third)',
      PassesFinalThirdNoArea: 'Passes Final Third (W/O Box)',
      PassesIntoOppBox: 'Successful passes ending in the opponent box',
      CarriesFinalThird:
        'Carries of at least 7 meters ending in the final third',
      CarriesInsideFinalThird:
        'Carries of at least 7 meters within the final third (start and end in the final third)',
      CarriesFinalThirdNoBox: 'Carries Final Third (W/O Box)',
      CarriesIntoOppBox:
        'Carries of at least 7 meters ending in the opponent box',
      TimePossessionAgainst: 'Time of ball possession of the opponent team',
      TimePossessionTotal: 'Time of ball possession of the both teams',
      PassesInBox: 'Successful passes that start inside of the opponent box',
      LongThrowInSuccessful:
        'Successful long-distance throw from the touchline, designed to launch the ball over 20+ meters',
      LongThrowInTotal:
        'Total long-distance throw from the touchline, designed to launch the ball over 20+ meters',
      LongThrowInPct:
        'Percentage of long throw-ins (20+ meters) that are successful',
      Games: 'Games Played',
      PointsPerGame: 'Points Per Game',
      ExpectedPointsDiff: 'Expected Points Difference',
      PassesTotalOwnHalf: 'Total number of passes ending in own half',
      PassesOwnHalf: 'Number of successful passes ending in own half',
      PassesTotalOppHalf: 'Total number of passes ending into the opponent half',
      ProgressivePassesTotal: 'Total number of passes of 10 meters or more in the X-axis',
      DuelsWon: 'Successful duels (Tackles, Aerials, Ball Touches, Dribbles and Fouls committed)',
      NonPenaltySaves: 'Saves excluding penalty shots',
      BadActionsOppHalf: 'Sum of all bad actions committed (pass unsuccessful, take on unsuccessful, dispossessed, offside pass, ball touch unsuccessful) in the opponent half',
      CarriesSuccessful: 'Number of carries of at least 7 meters ending with a successful event',
      ShotsOnTargetOutBox: 'Shots made on target from outside of box',
      SwitchPlaySuccessful: 'Number of completed passes over 32 metres where the ball´s lateral displacement is greater than its displacement towards the opposition goal',
      SwitchPlayTotal: 'Total number of attempted passes over 32 metres where the ball´s lateral displacement is greater than its displacement towards the opposition goal',
      PassesInsideOppHalf: 'Total number of passes that both start and end in the opposition half',
      PassesInsideOppHalfSuccessful: 'Number of completed passes that both start and end in the opposition half',
      TacklesAttemptedFirstThird: 'Total number of tackles attempted in the first third of the pitch',
      TacklesAttemptedSecondThird: 'Total number of tackles attempted in the second third of the pitch',
      TacklesFirstThird: 'Number of successful tackles made in the first third of the pitch',
      TacklesSecondThird: 'Number of successful tackles made in the second third of the pitch',
      FoulsOwnHalf: 'Number of fouls committed in the player´s own half',
      TouchesOppHalf: 'Number of ball touches in the opposition half',
      TacklesAttemptedNotAdjusted: 'Total number of tackles attempted, without possession adjustment',
      TacklesSuccessfulNotAdjusted: 'Total number of successful tackles, without possession adjustment',
      // Physical Stats
      TotalDistance:
        'Total distance that the Player has covered during the match, in meters',
      WalkingDistance:
        'Total distance that the Player has travelled during a match at a speed lower than 2 m/s (7.2 km/h)',
      JoggingDistance:
        'Total distance that the Player has travelled during a match at a speed between 2 m/s (7.2 km/h) and 4 m/s (14.4 km/h)',
      RunningDistance:
        'Total distance that the Player has travelled during a match at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)',
      ExtremeAccelerations:
        'Number of times that the Player accelerates more than 3 m/s<sup>2</sup>',
      NumberOfRuns:
        'Number of runs completed at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)',
      DistanceTIP:
        'Distance (Team In Possession) that the Player has travelled during a match with possession',
      DistanceOTIP:
        'Distance OTIP (Opponent Team In Possession) that the Player has travelled during a match without possession',
      HsrNumber:
        'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second',
      HsrDistance:
        'Total distance that the Player has travelled during a match at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h)',
      HsrDistancePct:
        'Percentage of HSR (High Speed Run) Distance with respect to total distance travelled',
      SprintsNumber:
        'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second',
      SprintsDistance:
        'Total distance that the Player has travelled during a match at a speed that is greater than or equal to 7 m/s (25.2 km/h)',
      SprintNumberDeclinePct:
        'Percentage decrease in the number of sprints performed compared to the second half of the match',
      SprintDistanceDeclinePct:
        'Percentage decrease in the distance run by while sprinting compared to the second half of the match',
      SprintNumberDecline:
        'Decrease in the number of sprints performed compared to the second half of the match',
      SprintDistanceDecline:
        'Decrease in the distance run by while sprinting compared to the second half of the match',
      SprintDistancePct:
        'Percentage of Sprint Distance with respect to total distance travelled',
      Accelerations:
        'Number of times that the Player accelerates between 1.5 m/s<sup>2</sup> and 3 m/s<sup>2</sup>',
      ExplosiveDistance: 'Explosive Distance',
      MaxSpeed: 'Maximum speed achieved by the player',
      AvgMaxSpeed: 'Average of maximum speed achieved by the player',
      MaxAccelerations:
        'Maximum meters/second<sup>2</sup> achieved by the player',
      // Arrigo
      BypassedPlayersByPasses:
        'Total number of opponents (defenders and midfielders) bypassed via passes',
      BypassedDefendersByPasses:
        'Total number of opponents (defenders) bypassed via passes',
      PassesBypassingPlayers: 'Number of passes that bypassed players',
      PassesBypassingDefenders: 'Number of passes that bypassed defenders',
      BypassedPlayersPerPass: 'Total number of players bypassed per passes',
      BypassedDefendersPerPass: 'Total number of defenders bypassed per passes',
      LineBreakingPasses:
        'Number of completed passes that successfully penetrate one or more defensive lines',
      LineBreakingPassesMD:
        'Number of completed passes that successfully penetrate midfielder and defender lines',
      LineBreakingPassesM:
        'Number of completed passes that successfully penetrate midfielder line',
      LineBreakingThroughBalls:
        'Number of completed passes that successfully penetrate defensive line',
      LineBreakingPassesPerPass: 'Percentage of line breaking passes per pass',
      TotalPassesUnderStrongPressure:
        'Total number of passes made under strong pressure (within 0-2 meters of the nearest opponent)',
      TotalPassesUnderLightPressure:
        'Total number of passes made under pressure (within 2-4 meters of the nearest opponent)',
      SuccessfulPassesUnderStrongPressure:
        'Number of successful passes made under strong pressure (within 0-2 meters of the nearest opponent)',
      SuccessfulPassesUnderLightPressure:
        'Number of successful passes made under pressure (within 2-4 meters of the nearest opponent)',
      PassingUnderStrongPressure:
        'Percentage of successful passes and total passes both under strong pressure (within 0-2 meters of the nearest opponent)',
      PassingUnderLightPressure:
        'Percentage of successful passes and total passes both under pressure (within 2-4 meters of the nearest opponent)',
      PassReceiptsInSpaceCompleted:
        'Passes made where the receiver is in the attacking half and has no defender in a 5 meter radius towards the direction of the goal',
      PassReceiptsInSpace:
        'Passes received in the attacking half and there is no defender in a 5 meter radius towards the direction of the goal',
      PassReceiptsInSpaceCompletedFirstThird:
        'Passes made where the receiver is in the first third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedSecondThird:
        'Passes made where the receiver is in the second third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedFinalThird:
        'Passes made where the receiver is in the final third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedOppHalfRight:
        "Passes made where the receiver is in the opponent's half (right side) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceCompletedOppHalfCenter:
        "Passes made where the receiver is in the opponent's half (central channel) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceCompletedOppHalfLeft:
        "Passes made where the receiver is in the opponent's half (left side) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceFirstThird:
        'Passes received in the first third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceSecondThird:
        'Passes received in the second third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceFinalThird:
        'Passes received in the final third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceOppHalfRight:
        "Passes received in the opponent's half (right side) where there is no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceOppHalfCenter:
        "Passes received in the opponent's half (central channel) where there is no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceOppHalfLeft:
        "Passes received in the opponent's half (left side) where there is no defender within a 5-meter radius in the direction of the goal",
      TotalStrongOnBallPressures:
        'Number of strong on-ball pressures (within 0-2 meters of the ball carrier)',
      TotalLightOnBallPressures:
        'Number of on-ball pressures (within 2-4 meters of the ball carrier)',
      SuccessfulStrongOnBallPressures:
        'Number of successful strong on-ball pressures (within 0-2 meters)',
      SuccessfulLightOnBallPressures:
        'Number of successful on-ball pressures (within 2-4 meters)',
      StrongOnBallPressuresPct:
        'Percentage of successful and total strong on-ball pressures (within 0-2 meters of the nearest opponent)',
      LightOnBallPressuresPct:
        'Percentage of successful and total on-ball pressures (within 2-4 meters of the nearest opponent)',
      TimesBypassedByPasses: 'Total number of times bypassed by pass',
      TimesBypassedByCarries: 'Total number of times bypassed by carry',
      TimesBypassedByActions:
        'Total number of times bypassed by pass and carry combined',
      BypassedPlayersByCarries:
        'Total number of opponents (defenders and midfielders) bypassed via carries',
      BypassedDefendersByCarries:
        'Total number of opponents (defenders) bypassed via carries',
      BypassedPlayersByActions:
        'Total number of opponents (defenders and midfielders) bypassed via passes and carries combined',
      BypassedDefendersByActions:
        'Total number of opponents (defenders) bypassed via passes and carries combined',
      CarriesBypassingPlayers: 'Number of carries that bypassed players',
      CarriesBypassingDefenders: 'Number of carries that bypassed defenders',
      BypassedPlayersPerCarry: 'Average number of opponents bypassed per carry',
      BypassedDefendersPerCarry:
        'Average number of defenders bypassed per carry',
      LineBreakingCarries:
        'Number of carries that successfully penetrate one or more defensive lines',
      LineBreakingCarriesMD:
        'Number of carries that successfully penetrate midfielder and defender lines',
      LineBreakingCarriesM:
        'Number of carries that successfully penetrate midfielder line',
      LineBreakingCarriesD:
        'Number of carries that successfully penetrate defensive line',
      LineBreakingCarriesPerCarry:
        'Percentage of line breaking carries per carry',
      LineBreakingActions:
        'Number of passes and carries combined that successfully penetrate one or more defensive lines',
      LineBreakingActionsMD:
        'Number of passes and carries combined that successfully penetrate midfielder and defender lines',
      LineBreakingActionsM:
        'Number of passes and carries combined that successfully penetrate midfielder line',
      LineBreakingActionsD:
        'Number of passes and carries combined that successfully penetrate defensive line',
      PassesPerLineBreakingPass:
        'Ratio between total number of passes per line breaking pass',
      CarriesPerLineBreakingCarry:
        'Ratio between total number of carries per line breaking carry',
      LinesBrokenByPasses: 'Total number of lines broken via passes',
      LinesBrokenByCarries: 'Total number of lines broken via carries',
      LinesBrokenByActions:
        'Total number of lines broken via passes and carries combined',
      LinesBrokenPerPass: 'Ratio between total number of lines broken per pass',
      LinesBrokenPerCarry:
        'Ratio between total number of lines broken per carry',
      AvgLastDefenderDistanceIP:
        'Distance between the last defender (closest to own goal) and the goal line in possession',
      AvgLastDefenderDistanceOOP:
        'Distance between the last defender (closest to own goal) and the goal line out of possession',
      AvgDefensiveLineDistanceIP:
        'Distance between the position of the deepest defensive line and the goal in possession',
      AvgDefensiveLineDistanceOOP:
        'Distance between the position of the deepest defensive line and the goal out of possession',
      AvgRBDistanceIP:
        'Distance from right-back to their own goal in possession',
      AvgRBDistanceOOP:
        'Distance from right-back to their own goal out of possession',
      AvgLBDistanceIP:
        'Distance from left-back to their own goal in possession',
      AvgLBDistanceOOP:
        'Distance from left-back to their own goal of possession',
      AvgBlockDistanceIP:
        'Distance between the deepest and most advanced outfield player in possession',
      AvgBlockDistanceOOP:
        'Distance between the deepest and most advanced outfield player out of possession',
      AvgBlockAreaIP:
        'The area of the bounding box surrounding all outfield players (a measure of how much space the team occupies) in possession',
      AvgBlockAreaOOP:
        'The area of the bounding box surrounding all outfield players (a measure of how much space the team occupies) out of possession',
      AvgDefensiveLineWidthOOP:
        'The width of the backmost line of players (furthest from their own goal) out of possession',
      AvgOffensiveLineLastThirdWidthIP:
        'The horizontal width of the offensive line in the last third in possession',
      AvgLByIP: 'Position of the left-back in possession',
      AvgRByIP: 'Position of the right-back in possession',
      AvgOffensiveLineDistanceIP:
        'Distance between the own goal and the offensive line in possession',
      AvgOffensiveLineLastThirdDistanceIP:
        'Distance between the own goal and the offensive line in the last third in possession',
      AvgOffensiveLineWidthIP:
        'The horizontal width of the offensive line in possession',
      OffBallRuns:
        'Intentional off-ball movements (runs) to support the attacking phase',
      OffBallRunsOverlap:
        'Runs where the player moves around the outside of a teammate (closer to the sideline) while that teammate has the ball',
      OffBallRunsUnderlap:
        'Runs where the player moves inside a teammate, taking an inner route (closer to the center of the pitch)',
      OffBallRunsRunAhead:
        'Forward run that goes beyond the ball carrier but stays ahead of the last defender',
      OffBallRunsRunBehind:
        'Forward run that breaks into the last defensive line, getting between defenders and goalkeeper',
      OffBallRunsCrossReceiver:
        'A player runs into the box and positions to receive a cross from a teammate',
      OffBallRunsSupport:
        'The player runs to align with the ball carrier, offering a nearby passing option in attack',
      OffBallRunsComingShort:
        'The player moves toward the ball carrier to offer close support or a pass option away from goal',
      AvgTop5MaxSpeed: 'Average of the player´s five highest maximum speeds',
      LBPReceived: 'Number of line-breaking passes received. These are completed passes that move the ball at least 10% closer to the opposition goal and intersect a pair of defenders in close proximity or travel beyond the defensive line',
      LBPMReceived: 'Number of passes received that break through the opposition midfield line',
      LBPMDReceived: 'Number of passes received that break through both the opposition midfield and defensive lines',
      ThroughBallReceived: 'Number of passes received that break through the opposition´s last defensive line',
      HsrDistanceIP: 'Sprint distance >21 km/h in possession',
      HsrDistanceOOP: 'Sprint distance >21 km/h out of possession',
      JoggingDistanceIP: 'Jogging distance in possession',
      JoggingDistanceOOP: 'Jogging distance out of possession',
      RunningDistanceIP: 'Running distance in possession',
      RunningDistanceOOP: 'Running distance out of possession',
      SprintsDistanceIP: 'Sprint distance >24 km/h in possession',
      SprintsDistanceOOP: 'Sprint distance >24 km/h out of possession',
      WalkingDistanceIP: 'Walking distance in possession',
      WalkingDistanceOOP: 'Walking distance out of possession'
    },
    subtitles: {
      Possession: 'Percentage of ball possession of the team',
      TimePossession: 'Time of ball possession of the team',
      PassesPerShots: 'Average number of passes given per shot',
      PPDA:
        'Pressure that the team puts on the opposition players when they are in possession',
      Directness:
        'Higher quantity of forward passes with respect to sideways passes',
      ExpectedPoints:
        'Number of points expected by a team, calculated based on the Expected Goals',
      PassesPerLongBall:
        'Percentage of successful long passes out of the total number of completed passes',
      CrossingPerXG: 'Percentage of Expected Goals coming from crosses',
      PenaltySavedPenaltyFaced:
        'Percentage of penalty shots saved out of all penalty shots faced',
      Goals: 'Number of goals scored',
      PenaltyShots: 'Total number of shots taken from penalty kicks',
      PenaltyGoals: 'Total number of goals taken from penalty kicks',
      NonPenaltyGoals: 'Goals (excluding penalties)',
      AerialWins: 'Aerial duel wins',
      AerialEfficiency:
        'Metric that combines aerial duel wins with aerial duels total',
      AerialWinsPct: 'Percentage of aerial duel wins',
      Assists: 'Assists',
      Catching: 'Percentage of saves in which the GK catches the ball',
      Caught: 'Saves where the goalkeeper catches and holds the ball, preventing any second play',
      ChancesCreated: 'Number of passes leading to a shot',
      ClaimAccuracy: 'Balls claimed above average',
      CompletedCrosses: 'Crosses successfully completed',
      Crossing: 'Percentage of successful crosses',
      Dispossessed: 'Turnovers',
      Finishing: 'Percentage of shots ending in a goal',
      xGEfficiency:
        'Quantity of expected goals needed for a player to score a goal',
      Fouls: 'Fouls commited',
      DeepProgression:
        'Number of times the last fifth of the pitch is reached by carrying the ball, plus the number of times the possession of the ball is in the last fifth',
      DeepProgressionFinalThird:
        'Number of times the final third of the pitch is reached by carrying the ball, plus the number of times the possession of the ball is in the final third',
      FoulsTaken: 'Fouls received',
      IndividualPressure:
        'Successful efforts (possessions recovered)',
      Interceptions: 'Ball Interceptions',
      LongBallPct: 'Percentage of Completed Passes of at least 32 meters',
      LongBallTotal: 'Total number of passes over 32 meters',
      LongBallSuccessful: 'Completed Passes of at least 32 meters',
      NPGOpenPlay:
        'Goals (excluding penalties) by open play actions',
      NPGSetPiece:
        'Goals (excluding penalties) by set piece actions',
      OpenPlayKeyPasses:
        'Passes ending in a Shot (excluding assists) in Open Play',
      OpenPlayKeyPassesInTeam:
        'Percentage of passes ending in a shot (excluding assists) in open play in Team',
      PassingFinalThird:
        'Successful passes, excluding crosses, set pieces, corners and throw-ins, that end in the final third',
      PassesFinalThirdTotal:
        'Total passes attempted, excluding crosses, set pieces, corners and throw-ins, that end in the final third',
      PassingFinalThirdPct:
        'Percentage of passes that end in the final third completed out of all passes given by the player',
      PassingOppHalfPct:
        'Percentage of Successful Passes into the Opponent Half',
      PassingOwnHalfPct: 'Percentage of Successful Passes into the Own Half',
      PassingPct: 'Percentage of Successful Passes',
      Recoveries: 'Ball Recoveries (via Tackles or Interceptions)',
      SavesInBoxPct: 'Percentage of Saves from Shots in Box',
      SavesOutOfBoxPct: 'Percentage of Saves from Shots out of Box',
      SavesPct: 'Percentage of Saves',
      ScoringContribution: 'Number of assists and goals',
      xAssistsOpenPlay:
        'Number of expected assists generated by open play',
      xAssistsSetPiece:
        'Number of expected assists generated by set piece',
      xAssistsOpenPlayInTeam:
        'Number of expected assists generated by open play in team',
      xAssistsSetPieceInTeam:
        'Number of expected assists generated by set piece in team',
      xGChainFinalThird:
        'Quantity of xG a player has taken part in the final third',
      xGBuildupFinalThird:
        'Quantity of xG a player has taken part in the final third (excluding shots and passes leading to a shot)',
      BallProgressionPassing:
        'Number of times the player progresses the ball 10 meters or more by passing the ball',
      BallProgressionDribbling:
        'Number of times the player progresses the ball 10 meters or more by carrying the ball',
      Shooting: 'Percentage of Shots (excluding penalties) on Target',
      Shots: 'Number of Shots made',
      ShotsPerGoal: 'Average Number of Shots made to score a Goal',
      SuccessfulDribbles: 'Successful Dribbles',
      TacklesSuccessful: 'Total Number of Tackles',
      TacklesWasDribbled: 'Percentage of Duels Won via Tackling',
      ThroughBalls:
        'Number of Passes that break the defensive line',
      TouchesInOpponentBox:
        'Number of controls of the ball in the opponent box',
      xAssists: 'Expected Assists generated',
      xG: 'Expected Goals generated',
      xGDiff: 'Difference between xG and Goals',
      xGOpenPlay: 'Expected goals generated by open play',
      xGSetPiece: 'Expected goals generated by set piece',
      xGBuildup: 'Involvement in xG Built',
      xGBuildupInTeam: 'Involvement in xG Built in team',
      BallProgression:
        'Progressions by passing or carrying the ball at least 10 meters',
      xGChain: 'Involvement in xG Chained',
      xGPerNPG: 'Expected goals needed to score a non-penalty goal',
      xGPerShot: 'Average xG per Shot',
      xGSavedPerShot: 'Average xG Saved per Shot faced',
      xGSavedPerXGFacedOnTarget: 'Average xG saved per xG faced on target',
      xGFacedOnTargetPerGoalReceived:
        'Expected Goals are needed to score a goal to a certain Goalkeeper',
      xGFacedOnTargetEfficiency:
        'Number of Non-Penalty Goals prevented by the Goalkeeper',
      xGFacedOnTarget:
        'Total xG (saved and scored) faced by the goalkeeper',
      HighTurnovers: 'Turnovers closer than 40 meters from the own goal',
      OpenPlayPassesIntoOpponentBox:
        'Total open play passes into the opponent box',
      OpenPlayPassesIntoOpponentBoxSuccessful:
        'Open play completed passes into the opponent box',
      ChancesCreatedOP:
        'Number of passes leading to a shot during open play',
      PenaltiesTaken:
        'Number of times the player was fouled in the opponent box',
      BlockedCrosses: 'Crosses blocked',
      BlockedShots: 'Shots blocked',
      NonPenaltyGoalsAgainst:
        'Number of non-penalty goals conceded',
      GoalsConceded: 'Number of goals conceded',
      Headers: 'Number of Shots made with the Head',
      HeadedGoals: 'Number of goals scored with the head',
      SavesInBox: 'Number of saves from shots inside the box',
      SavesOutBox: 'Number of saves from shots outside the box',
      ShotsOnTargetInBoxAgainst: 'Number of shots on target from inside the box conceded',
      ShotsOnTargetOutBoxAgainst: 'Number of shots on target from outside the box conceded',
      AveragePassDistance: 'Average distance of passes in meters',
      ProgressiveRuns:
        'Successful carries that bring the possession a 20% closer to the opponent goal',
      xT: 'Threat generated by moving the ball to dangerous areas',
      xTOpenPlay:
        'Expected Threat generated during open play',
      xTSetPiece:
        'Expected Threat generated by set piece',
      xGOT: 'Number of expected goals faced by the goalkeeper',
      BadActions: 'Sum of all bad actions committed',
      BadActionsOwnHalf: 'Sum of all bad actions committed in the own half',
      AerialsWonOwnBox: 'Aerial Duel Wins Own Box',
      AerialsWonOppBox: 'Aerials Duel Wins Opp Box',
      AerialsTotalOppBox: 'Aerials Duels Total Opp Box',
      AerialsTotalOwnBox: 'Aerials Duels Total Own Box',
      FoulsOwnHalfPct: 'Percentage of Fouls commited in the Own Half',
      RecoveriesOppHalf:
        'Number of balls recovered by a player in the opponent half',
      DuelsPct: 'Percentage of Successful Duels',
      TacklesUnsuccessful:
        'Number of times a player fails to win the ball as an opponent successfully dribbles past them',
      TacklesWasDribbledFirstThird:
        'Percentage of times the player recovers the ball when faced in the final third',
      TacklesWasDribbledSecondThird: '1vs1 Defensive Win %⅔',
      TacklesWasDribbledFinalThird: '1vs1 Defensive Win % Final ⅓',
      BallProgressionFinalThird:
        'Number of times a player advances 10 or more meters in the final third',
      DuelsTotal:
        'Total number of tackles, aerials, ball touches, dribbles and fouls committed',
      QuickRecoveries:
        'Recoveries 40 meters or more from the own goal made 8 seconds after losing the possession',
      ShotsPerNPG: 'Average number of shots to score a Non-Penalty Goal',
      ShotsOutBox: 'Number of Shots from outside the box',
      GoalsOutBox: 'Number of Goals from outside the box',
      ShootingOutBox: 'Percentage of shots on target from outside of Box',
      HandPassing: 'Passing Accuracy with Hands',
      ShotEndingHighTurnovers:
        'High Turnovers (turnovers closer than 40 meters from the own goal) ending in a shot of the opponent team',
      GoalEndingHighTurnovers:
        'High Turnovers (turnovers closer than 40 meters from the own goal) ending in a goal of the opponent team',
      AverageCarriesProgress:
        'Average distance that a player moves the ball vertically per carry (meters)',
      ChanceEndingCarries:
        'Carries of at least 7 meters ending in a pass that is followed by a shot',
      AssistEndingCarries:
        'Carries of at least 7 meters ending in a pass that is followed by a goal',
      ShotEndingCarries: 'Carries of at least 7 meters ending in a shot',
      GoalEndingCarries: 'Carries of at least 7 meters ending in a goal',
      ShotEndingSequence:
        'Number of Sequences ending in a Shot where the player was involved',
      GoalEndingSequence:
        'Number of Sequences ending in a Goal where the player was involved',
      AerialWonOffensive: 'Offensive aerial duel wins',
      AerialWonDefensive: 'Defensive aerial duel wins',
      xGAgainst: 'Expected goals conceded',
      xGDiffAgainst:
        'Difference between Expected Goals Conceded and Goals Conceded',
      xGPerNPGAgainst: 'Expected goals received per non-penalty goal conceded',
      xGOpenPlayAgainst: 'Expected goals generated by open play conceded',
      xGSetPieceAgainst: 'Expected goals generated by set piece conceded',
      xGPerShotAgainst: 'Expected goals received per shot conceded',
      ShotsAgainst: 'Shots conceded',
      ShotsOnTargetAgainst: 'Shots on target conceded',
      RivalPossession: 'Possession of opponent',
      AerialDefensivePct: 'Percentage of aerial wins without ball possession',
      HighRecoveries: 'Recoveries made 40 meters close to the opponent goal',
      HighDefensiveActions:
        'Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline',
      HighDefensiveActionPct:
        'Percentage of Defensive Actions (Tackles, Interceptions, Blocks, Fouls y 1vs1) made 40 meters over the own baseline',
      HighDefensiveDistance:
        'Average distance from own goal of all Defensive Actions',
      PassesPerPossession: 'Number of passes per possession',
      LengthPerPossession: 'Distance per possession',
      xTNet: 'Net xT',
      AvgCarriesDistance: 'Average Carries Distance',
      PassesForwardPct: '% Forward Passes',
      PassesForwardSuccessful: 'Successful Forward Passes',
      PassesForwardTotal: 'Total Forward Passes',
      TacklesAttempted: 'Tackles Attempted',
      DuelsLost: 'Duels Lost',
      Carries: 'Carries',
      CarriesPct: '% Carries',
      Aerials: 'Total number of aerial duels',
      ProgressivePassesReceivedIntoBox: 'Progressive Passes Receive into Box',
      PassesOppHalf: 'Successful passes ending into the opponent half',
      LongBallReceived: 'Number of Long Passes (>32 meters) Received',
      ShotsOnTarget: 'Shots made on target',
      AggressiveActions:
        'Number of Tackles attempted in the next two seconds after losing the possession',
      Crosses: 'Total Number or Crosses',
      xGBuildup5pass:
        'Quantity of xG a player has taken part in, only last 5 passes (excluding shots and passes leading to a shot)',
      SpeedSequence:
        'Average Speed (meters covered by time spent) of all possessions of a team',
      Touches:
        'Number of times a player has possession of the ball',
      AerialsTotalOppHalf:
        'Aerial duels total into opponent half',
      AerialsWonOppHalf:
        'Aerial duels successful into opponent half',
      AerialsWonOppHalfPct: 'Percentage of aerial duel wins into opponent half',
      AerialsPctOppBox: 'Percentage of aerials duel wins into opponent box',
      AerialsPctOwnBox: 'Percentage of aerials duel wins into own box',
      AerialDefensive: 'Total number of aerials when opponent team has possession',
      AerialOffensive:
        'Total number of aerials when own team has possession',
      AerialOffensivePct:
        'Percentage of aerial wins when own team has possession',
      IndividualPressureOppHalf:
        'Possessions recovered by a player when pressing the opponent in the opponent half',
      TouchesPerShot: 'Number of times players touch the ball per shot',
      PassesFinalThirdTotalPct:
        'Percentage of passes (successful and unsuccessful) into final third',
      xACrosses:
        'Expected assists generated from crosses',
      Passes: 'Total number of passes',
      PassesSuccessful: 'Number of Completed Passes',
      TacklesWasDribbledFouls:
        'Percentage of tackles won with respect to total tackles and fouls committed',
      OffsidesCaught: 'Offsides Caught',
      ProgressivePassesReceivedFinalThird:
        'Progressive Passes Received Final ⅓',
      ProgressivePassesReceived: 'Progressive Passes Received',
      Breadth:
        'Sum of tackles, challenges, interceptions and fouls committed, on the sides of the field',
      DuelsDefTotal:
        'Sum of total tackles, defensive aerial duels and fouls committed',
      DefensiveActions:
        'Defensive Actions when an opponent tries to dribble (Tackles, Challenges, Interceptions and Fouls)',
      ProgressivePassesReceivedOppHalf: 'Progressive Passes Received Opp. Half',
      CompletedCrossesOP: 'Successful number of crosses during open play',
      CrossingOP:
        'Percentage of crosses completed out of all crosses attempted open play',
      CrossesOP: 'Total number of crosses during open play',
      PassingContribution:
        'Percentage that measures threat of passes taking into account the position of the receiver',
      BallProgressionOppHalfInTeam:
        '% Ball progression in opponent half in team',
      PassesOPIntoBoxInTeam: '% Passes open play into box in team',
      TouchesOppBoxInTeam: '% Touches opponent box in team',
      xGOPInTeam: '% xG open play in team',
      DeepPasses:
        'Successful passes from outside a 20-metre radius of the opponent goal that end inside that area',
      DeepPassesTotal: 'Total of passes attempted from outside a 20-metre radius of the opponent goal that end inside that area',
      DefensiveDuelsPct:
        'Percentage of defensive duels won out of total defensive duels',
      DefensiveDistance:
        'Average distance to own goal of defensive duels performed',
      QuickRecoveriesPct:
        'Percentage of quick recoveries to interceptions and attempted tackles',
      DiffDefensiveDistanceTeam:
        "Difference between the player's defensive distance and his team's defensive distance",
      xTPassing: 'Expected threat generated only from passes',
      xTPassing100Passes:
        'Expected threat generated only from passes and per 100 passes',
      ProgressivePassesAccurate:
        'Completed passes of 10 meters or more in the X-axis',
      PassAbility: 'Ratio of completed passes to expected passes (xP)',
      OPPassesIntoOppBoxPct:
        'Percentage of open play completed passes into the opponent box and open play attempted passes into the opponent box',
      EntriesOppBox: 'Number of passes and carries into the opponent box',
      Crosses6yardBox: 'Total number of crosses ending in the six-yard box',
      Cutbacks: 'Passing from baseline to back and inside the opponent box',
      xTDribbling: 'Expected threat generated only from dribbles',
      AvgShotDistance: 'Average distance of the total number of shots taken',
      xGOnTarget: 'Expected goals from shots made on target',
      FinishingxGOT:
        'Percentage of shots on target ending in a goal above average',
      DribblesWonOwnHalf: 'Successful dribbles made in own half',
      DribblesOwnHalf: 'Number of attempted dribbles made in own half',
      DribblesOwnHalfPct:
        'Percentage of successful dribbles and attempted dribbles made in own half',
      DribblesWonOppHalf: 'Successful dribbles made in opponent half',
      DribblesOppHalf: 'Number of attempted dribbles made in opponent half',
      DribblesOppHalfPct:
        'Percentage of successful dribbles and attempted dribbles made in opponent half',
      DribblesWonFinalThird: 'Successful dribbles made in the final third',
      DribblesFinalThird:
        'Number of attempted dribbles made in the final third',
      DribblesFinalThirdPct:
        'Percentage of successful dribbles and attempted dribbles made in the final third',
      ShotEndingHighRecoveries:
        "High recoveries (recoveries made 40 meters or closer to the opponent's goal) ending in a shot",
      PassingFinalThirdAgainst:
        'Successful passes from the opponent to the final third',
      OpenPlayPassesIntoOpponentBoxAgainst:
        'Total number of passes attempted from the opponent into the own box during open play',
      EntriesOppBoxAgainst:
        'Number of passes and carries from the opponent into the own box',
      DeepProgressionAgainst:
        'Number of times the opponent reaches the last fifth of the pitch by carrying the ball, plus the number of times the possession of the ball is in the first fifth',
      TouchesInOpponentBoxAgainst:
        'Number of times the opponent has possession of the ball in our box',
      Score: 'Player performance based on different metrics',
      PDScore:
        'Player physical performance based on different physical metrics',
      SpeedScore: 'Player physical performance based on different speed metrics',
      EnduranceScore: 'Player endurance physical performance based on different metrics',
      OrlegiScore: 'Player performance based on different metrics',
      SirScore: 'Player performance based on different metrics',
      ExcScore: 'Player performance based on different metrics',
      xTOPInTeam: 'Expected threat generated during open play in team',
      YellowCards: 'Yellow cards received',
      RedCards: 'Red cards received',
      xTOpenPlayAgainst:
        'Expected Threat conceded during open play',
      xTSetPieceAgainst:
        'Expected Threat conceded by set piece',
      NPGOpenPlayAgainst:
        'Number of non penalty goals conceded by open play actions',
      NPGSetPieceAgainst:
        'Number of non penalty goals conceded by set piece actions',
      PassesOppHalfPerPossession: 'Passes Opp. Half per Possession',
      AverageTimeRecovery: 'Avg Time Recovery',
      ExpectedPassing: 'Percentage of Passes that should have been completed',
      NumPossession10Passes: 'Possessions generated by 10 or more passes',
      PassesReceived: 'Passes Received',
      PassesReceivedFinalThird: 'Passes Received Final ⅓',
      ProgressivePassesTotalPct:
        'Percentage of progressive passes completed out of the total progressive passes attempted',
      ShortPassesPct: 'Percentage of Short Passes',
      TouchesOppBoxOppTeam:
        'Number of opponent actions conceded inside own box while the player is on the pitch',
      ShotsOnTargetOppTeam:
        'Shots on target conceded while the player is on the pitch',
      NPGOppTeam: 'Non-penalty goals conceded while the player is on the pitch',
      xGSetPiecePerxG:
        'Expected Goals generated by set piece needed to generate one expected goal',
      ShotsOpenPlay: 'Number of shots generated by open play',
      ShotsOpenPlayAgainst: 'Number of shots received by open play',
      ShotsFromDribble: 'Shots made after dribble an opponent',
      GoalsFromDribble: 'Goals made after dribble an opponent',
      PassesIntoFinalThird:
        'Successful passes that start outside and end inside the final third',
      PassesIntoFinalThirdTotal:
        'Total passes attempted that start outside and end inside the final third',
      PassesInsideFinalThird:
        'Successful passes within the final third (start and end in the final third)',
      PassesInsideFinalThirdTotal: 'Total of passes attempted within the final third (start and end in the final third)',
      PassesFinalThirdNoArea: 'Passes Final Third (W/O Box)',
      PassesIntoOppBox: 'Successful passes ending in the opponent box',
      CarriesFinalThird:
        'Carries of at least 7 meters ending in the final third',
      CarriesInsideFinalThird:
        'Carries of at least 7 meters within the final third (start and end in the final third)',
      CarriesFinalThirdNoBox: 'Carries Final Third (W/O Box)',
      CarriesIntoOppBox:
        'Carries of at least 7 meters ending in the opponent box',
      TimePossessionAgainst: 'Time of ball possession of the opponent team',
      TimePossessionTotal: 'Time of ball possession of the both teams',
      PassesInBox: 'Successful passes that start inside of the opponent box',
      LongThrowInSuccessful:
        'Successful long-distance throw from the touchline, designed to launch the ball over 20+ meters',
      LongThrowInTotal:
        'Total long-distance throw from the touchline, designed to launch the ball over 20+ meters',
      LongThrowInPct:
        'Percentage of long throw-ins (20+ meters) that are successful',
      Games: 'Games Played',
      PointsPerGame: 'Points Per Game',
      ExpectedPointsDiff: 'Expected Points Difference',
      PassesTotalOwnHalf: 'Total number of passes ending in own half',
      PassesOwnHalf: 'Number of successful passes ending in own half',
      PassesTotalOppHalf: 'Total number of passes ending into the opponent half',
      ProgressivePassesTotal: 'Total number of passes of 10 meters or more in the X-axis',
      DuelsWon: 'Successful duels (Tackles, Aerials, Ball Touches, Dribbles and Fouls committed)',
      NonPenaltySaves: 'Saves excluding penalty shots',
      BadActionsOppHalf: 'Sum of all bad actions committed in the opponent half',
      CarriesSuccessful: 'Number of carries of at least 7 meters ending with a successful event',
      ShotsOnTargetOutBox: 'Shots made on target from outside of box',
      SwitchPlaySuccessful: 'Number of completed passes over 32 metres where the ball´s lateral displacement is greater than its displacement towards the opposition goal',
      SwitchPlayTotal: 'Total number of attempted passes over 32 metres where the ball´s lateral displacement is greater than its displacement towards the opposition goal',
      PassesInsideOppHalf: 'Total number of passes that both start and end in the opposition half',
      PassesInsideOppHalfSuccessful: 'Number of completed passes that both start and end in the opposition half',
      TacklesAttemptedFirstThird: 'Total number of tackles attempted in the first third of the pitch',
      TacklesAttemptedSecondThird: 'Total number of tackles attempted in the second third of the pitch',
      TacklesFirstThird: 'Number of successful tackles made in the first third of the pitch',
      TacklesSecondThird: 'Number of successful tackles made in the second third of the pitch',
      FoulsOwnHalf: 'Number of fouls committed in the player´s own half',
      TouchesOppHalf: 'Number of ball touches in the opposition half',
      TacklesAttemptedNotAdjusted: 'Total number of tackles attempted, without possession adjustment',
      TacklesSuccessfulNotAdjusted: 'Total number of successful tackles, without possession adjustment',
      // Physical Stats
      TotalDistance:
        'Total distance that the Player has covered during the match, in meters',
      WalkingDistance:
        'Total distance that the Player has travelled during a match at a speed lower than 2 m/s (7.2 km/h)',
      JoggingDistance:
        'Total distance that the Player has travelled during a match at a speed between 2 m/s (7.2 km/h) and 4 m/s (14.4 km/h)',
      RunningDistance:
        'Total distance that the Player has travelled during a match at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h)',
      ExtremeAccelerations:
        'Number of times that the Player accelerates more than 3 m/s<sup>2</sup>',
      NumberOfRuns:
        'Number of runs completed at a speed between 14.4 km/h and 19.8 km/h',
      HsrDistance: 'High Speed Running Distance > 19.8 km/h',
      HsrNumber: 'High Speed Running Quantity > 19.8 km/h',
      HsrDistancePct: '% HSR Distance',
      SprintsNumber: 'Sprints Quantity > 25.2 km/h',
      SprintsDistance: 'Sprints Distance > 25.2 km/h',
      SprintNumberDeclinePct: '% Sprint Quantity Decline',
      SprintDistanceDeclinePct: '% Sprint Distance Decline',
      SprintNumberDecline:
        'Decrease number of sprints compared to the second half',
      SprintDistanceDecline:
        'Decrease distance run by while sprinting compared to the second half',
      SprintDistancePct: '% Sprint Distance',
      Accelerations: 'Accelerations Quantity',
      MaxSpeed: 'Max. Speed',
      AvgMaxSpeed: 'Average of maximum speed achieved by the player',
      MaxAccelerations:
        'Maximum meters/second<sup>2</sup> achieved by the player',
      // Arrigo
      BypassedPlayersByPasses:
        'Total number of opponents (defenders and midfielders) bypassed via passes',
      BypassedDefendersByPasses:
        'Total number of opponents (defenders) bypassed via passes',
      PassesBypassingPlayers: 'Number of passes that bypassed players',
      PassesBypassingDefenders: 'Number of passes that bypassed defenders',
      BypassedPlayersPerPass: 'Total number of players bypassed per passes',
      BypassedDefendersPerPass: 'Total number of defenders bypassed per passes',
      LineBreakingPasses:
        'Number of passes that successfully penetrate one or more defensive lines',
      LineBreakingPassesMD:
        'Number of passes that successfully penetrate midfielder and defender lines',
      LineBreakingPassesM:
        'Number of passes that successfully penetrate midfielder line',
      LineBreakingThroughBalls:
        'Number of passes that successfully penetrate defensive line',
      LineBreakingPassesPerPass: 'Percentage of line breaking passes per pass',
      TotalPassesUnderStrongPressure:
        'Total number of passes made under strong pressure (within 0-2 meters of the nearest opponent)',
      TotalPassesUnderLightPressure:
        'Total number of passes made under pressure (within 2-4 meters of the nearest opponent)',
      SuccessfulPassesUnderStrongPressure:
        'Number of successful passes made under strong pressure (within 0-2 meters of the nearest opponent)',
      SuccessfulPassesUnderLightPressure:
        'Number of successful passes made under pressure (within 2-4 meters of the nearest opponent)',
      PassingUnderStrongPressure:
        'Percentage of successful passes and total passes both under strong pressure (within 0-2 meters of the nearest opponent)',
      PassingUnderLightPressure:
        'Percentage of successful passes and total passes both under pressure (within 2-4 meters of the nearest opponent)',
      PassReceiptsInSpaceCompleted:
        'Passes made where the receiver is in the attacking half and has no defender in a 5 meter radius towards the direction of the goal',
      PassReceiptsInSpace:
        'Passes received in the attacking half and there is no defender in a 5 meter radius towards the direction of the goal',
      PassReceiptsInSpaceCompletedFirstThird:
        'Passes made where the receiver is in the first third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedSecondThird:
        'Passes made where the receiver is in the second third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedFinalThird:
        'Passes made where the receiver is in the final third and has no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceCompletedOppHalfRight:
        "Passes made where the receiver is in the opponent's half (right side) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceCompletedOppHalfCenter:
        "Passes made where the receiver is in the opponent's half (central channel) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceCompletedOppHalfLeft:
        "Passes made where the receiver is in the opponent's half (left side) and has no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceFirstThird:
        'Passes received in the first third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceSecondThird:
        'Passes received in the second third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceFinalThird:
        'Passes received in the final third where there is no defender within a 5-meter radius in the direction of the goal',
      PassReceiptsInSpaceOppHalfRight:
        "Passes received in the opponent's half (right side) where there is no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceOppHalfCenter:
        "Passes received in the opponent's half (central channel) where there is no defender within a 5-meter radius in the direction of the goal",
      PassReceiptsInSpaceOppHalfLeft:
        "Passes received in the opponent's half (left side) where there is no defender within a 5-meter radius in the direction of the goal",
      TotalStrongOnBallPressures:
        'Number of strong on-ball pressures (within 0-2 meters of the ball carrier)',
      TotalLightOnBallPressures:
        'Number of on-ball pressures (within 2-4 meters of the ball carrier)',
      SuccessfulStrongOnBallPressures:
        'Number of successful strong on-ball pressures (within 0-2 meters)',
      SuccessfulLightOnBallPressures:
        'Number of successful on-ball pressures (within 2-4 meters)',
      StrongOnBallPressuresPct:
        'Percentage of successful and total strong on-ball pressures (within 0-2 meters of the nearest opponent)',
      LightOnBallPressuresPct:
        'Percentage of successful and total on-ball pressures (within 2-4 meters of the nearest opponent)',
      TimesBypassedByPasses: 'Total number of times bypassed by pass',
      TimesBypassedByCarries: 'Total number of times bypassed by carry',
      TimesBypassedByActions:
        'Total number of times bypassed by pass and carry combined',
      BypassedPlayersByCarries:
        'Total number of opponents (defenders and midfielders) bypassed via carries',
      BypassedDefendersByCarries:
        'Total number of opponents (defenders) bypassed via carries',
      BypassedPlayersByActions:
        'Total number of opponents (defenders and midfielders) bypassed via passes and carries combined',
      BypassedDefendersByActions:
        'Total number of opponents (defenders) bypassed via passes and carries combined',
      CarriesBypassingPlayers: 'Number of carries that bypassed players',
      CarriesBypassingDefenders: 'Number of carries that bypassed defenders',
      BypassedPlayersPerCarry:
        'Average number of opponents bypassed per carry (at least 7 meters)',
      BypassedDefendersPerCarry:
        'Average number of defenders bypassed per carry (at least 7 meters)',
      LineBreakingCarries:
        'Number of carries that successfully penetrate one or more defensive lines',
      LineBreakingCarriesMD:
        'Number of carries that successfully penetrate midfielder and defender lines',
      LineBreakingCarriesM:
        'Number of carries that successfully penetrate midfielder line',
      LineBreakingCarriesD:
        'Number of carries that successfully penetrate defensive line',
      LineBreakingCarriesPerCarry:
        'Percentage of line breaking carries per carry',
      LineBreakingActions:
        'Number of passes and carries combined that successfully penetrate one or more defensive lines',
      LineBreakingActionsMD:
        'Number of passes and carries combined that successfully penetrate midfielder and defender lines',
      LineBreakingActionsM:
        'Number of passes and carries combined that successfully penetrate midfielder line',
      LineBreakingActionsD:
        'Number of passes and carries combined that successfully penetrate defensive line',
      PassesPerLineBreakingPass:
        'Ratio between total number of passes per line breaking pass',
      CarriesPerLineBreakingCarry:
        'Ratio between total number of carries per line breaking carry',
      LinesBrokenByPasses: 'Total number of lines broken via passes',
      LinesBrokenByCarries: 'Total number of lines broken via carries',
      LinesBrokenByActions:
        'Total number of lines broken via passes and carries combined',
      LinesBrokenPerPass: 'Ratio between total number of lines broken per pass',
      LinesBrokenPerCarry:
        'Ratio between total number of lines broken per carry',
      AvgLastDefenderDistanceIP:
        'Distance between the last defender (closest to own goal) and the goal line in possession',
      AvgLastDefenderDistanceOOP:
        'Distance between the last defender (closest to own goal) and the goal line out of possession',
      AvgDefensiveLineDistanceIP:
        'Distance between the position of the deepest defensive line and the goal in possession',
      AvgDefensiveLineDistanceOOP:
        'Distance between the position of the deepest defensive line and the goal out of possession',
      AvgRBDistanceIP:
        'Distance from right-back to their own goal in possession',
      AvgRBDistanceOOP:
        'Distance from right-back to their own goal out of possession',
      AvgLBDistanceIP:
        'Distance from left-back to their own goal in possession',
      AvgLBDistanceOOP:
        'Distance from left-back to their own goal of possession',
      AvgBlockDistanceIP:
        'Distance between the deepest and most advanced outfield player in possession',
      AvgBlockDistanceOOP:
        'Distance between the deepest and most advanced outfield player out of possession',
      AvgBlockAreaIP:
        'The area of the bounding box surrounding all outfield players (a measure of how much space the team occupies) in possession',
      AvgBlockAreaOOP:
        'The area of the bounding box surrounding all outfield players (a measure of how much space the team occupies) out of possession',
      AvgDefensiveLineWidthOOP:
        'The width of the backmost line of players (furthest from their own goal) out of possession',
      AvgOffensiveLineLastThirdWidthIP:
        'The horizontal width of the offensive line in the last third in possession',
      AvgLByIP: 'Position of the left-back in possession',
      AvgRByIP: 'Position of the right-back in possession',
      AvgOffensiveLineDistanceIP:
        'Distance between the own goal and the offensive line in possession',
      AvgOffensiveLineLastThirdDistanceIP:
        'Distance between the own goal and the offensive line in the last third in possession',
      AvgOffensiveLineWidthIP:
        'The horizontal width of the offensive line in possession',
      OffBallRuns:
        'Intentional off-ball movements (runs) to support the attacking phase',
      OffBallRunsOverlap:
        'Runs where the player moves around the outside of a teammate (closer to the sideline) while that teammate has the ball',
      OffBallRunsUnderlap:
        'Runs where the player moves inside a teammate, taking an inner route (closer to the center of the pitch)',
      OffBallRunsRunAhead:
        'Forward run that goes beyond the ball carrier but stays ahead of the last defender',
      OffBallRunsRunBehind:
        'Forward run that breaks into the last defensive line, getting between defenders and goalkeeper',
      OffBallRunsCrossReceiver:
        'A player runs into the box and positions to receive a cross from a teammate',
      OffBallRunsSupport:
        'The player runs to align with the ball carrier, offering a nearby passing option in attack',
      OffBallRunsComingShort:
        'The player moves toward the ball carrier to offer close support or a pass option away from goal',
      AvgTop5MaxSpeed: 'Average of the player´s five highest maximum speeds',
      LBPReceived: 'Number of line-breaking passes received',
      LBPMReceived: 'Number of passes received that break through the opposition midfield line',
      LBPMDReceived: 'Number of passes received that break through both the opposition midfield and defensive lines',
      ThroughBallReceived: 'Number of passes received that break through the opposition´s last defensive line',
      HsrDistanceIP: 'Sprint distance >21 km/h in possession',
      HsrDistanceOOP: 'Sprint distance >21 km/h out of possession',
      JoggingDistanceIP: 'Jogging distance in possession',
      JoggingDistanceOOP: 'Jogging distance out of possession',
      RunningDistanceIP: 'Running distance in possession',
      RunningDistanceOOP: 'Running distance out of possession',
      SprintsDistanceIP: 'Sprint distance >24 km/h in possession',
      SprintsDistanceOOP: 'Sprint distance >24 km/h out of possession',
      WalkingDistanceIP: 'Walking distance in possession',
      WalkingDistanceOOP: 'Walking distance out of possession'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'xP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPIT',
      xAssistsSetPieceInTeam: 'xASPIT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PFT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPIT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPIT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SOB',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'FP%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOPPH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFTT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP%',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHIT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPIT',
      DeepPasses: 'DPC',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPIT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      CarriesIntoFinalThird: 'CIF⅓',
      ShotsOnTargetOutBox: 'SOTOB',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      // Physical Stats
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      HeadedShots: 'HS',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SOB',
      // Arrigo
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
    },
  },
  team: {
    title: 'Team Sheet',
    subtitle: "Go deeper into the team's characteristics and statistics",
    averageAge: 'Avg. age',
    transferBalance: 'Transfer Balance',
    roster: 'Roster',
    stadium: 'Stadium',
    coach: 'Coach',
    homeCoach: 'Home Coach',
    awayCoach: 'Away Coach',
    transfers: 'Transfers',
    trends: 'Trends',
    loans: 'Loans',
    loanFrom: 'Loan from',
    loanTo: 'Loan to',
    latestGames: 'Latest Games',
    latestXGames: 'Latest {0} Games',
    playingFor: 'Playing for',
    overview: 'Overview',
    visualization: 'Visualization',
    location: 'Location',
    outcome: 'Outcome',
    beeswarm: 'Ranking',
    parentTeam: 'Top Team',
    childTeam: 'Youth Team',
    preferredFormation: 'Preferred Formation',
    mostFrecuentFormations: 'Most frecuent formations',
    viewType: 'View Type',
    overviewTab: {
      axisXTotal: 'Total',
      axisXper90: "Per 90'",
      dataPerGameText: 'Data per game',
      season: 'Season',
      last: 'Last',
      current: 'Current',
      TeamStyle: 'Style',
      TeamDefensive: 'Defensive',
      TeamOffensive: 'Offensive',
      TeamCustom1: 'Custom 1',
      TeamCustom2: 'Custom 2',
      TeamCustom3: 'Custom 3',
      TeamCustom4: 'Custom 4',
      coach: 'Coach',
      groups: {
        Goals: {
          name: 'Goals',
          desc:
            'Shows Penalty Goals and Non-Penalty Goals (Open Play and Set Piece).',
        },
        Assists: {
          name: 'Assists',
          desc:
            'Players with more Assists (Open Play and Set Piece) this season.',
        },
        xG: {
          name: 'Expected Goals',
          desc: 'Expected Goals from Open Play and Set Piece',
        },
        xA: {
          name: 'Expected Assists',
          desc: 'Expected Assists from Open Play and Set Piece.',
        },
        Finishing: {
          name: 'Finishing',
          desc: 'Percentage of shots ending in a goal.',
        },
        ScoringContribution: {
          name: 'Scoring Contribution',
          desc: 'Number of Assists and Goals of the team.',
        },
        xT: {
          name: 'Expected Threat',
          desc:
            'Expected Threat generated from Open Play, Set Piece and negative xT.',
        },
      },
      stats: {
        openPlay: 'Open Play',
        setPiece: 'Set Piece',
        negative: 'Negative',
        npg: 'Non-Penalty Goals',
        goalsPenalty: 'Penalty Goals',
        npgOpenPlay: 'NPG Open Play',
        npgSetPiece: 'NPG Set Piece',
        assists: 'Assists',
        assistsConceded: 'Assists Conceded',
        assistsOpenPlay: 'Assists Open Play',
        assistsSetPiece: 'Assists Set Piece',
        xGOpenPlay: 'xG Open Play',
        xGSetPiece: 'xG Set Piece',
        xAOpenPlay: 'xA Open Play',
        xASetPiece: 'xA Set Piece',
        xAConceded: 'xA Conceded',
        nonPenaltyShots: 'Non-Penalty Shots',
        penaltyShots: 'Penalty Shots',
        xT: 'Expected Threat',
        xTOpenPlay: 'xT Open Play',
        xTSetPiece: 'xT Set Piece',
        xTNeg: 'Negative xT',
        totalFinishing: 'Finishing',
        nonPenaltyFinishing: 'Non Penalty Finishing',
        goalsPenaltyFinishing: 'Penalty Finishing',
        goal: 'Goal',
        notGoal: 'Not Goal',
        chance: 'Chance',
        finished: 'Finished',
        notFinished: 'Not Finished',
        walkingDistance: 'Walking',
        joggingDistance: 'Jogging ',
        runningDistance: 'Running ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprinting',
        runningNumber: 'Runs',
        hsrNumber: 'HSR Sprints',
        sprintsNumber: 'Sprints',
        maxSpeed: 'Max. Speed',
        accelerations: 'Accelerations',
        extremeAccelerations: 'Extreme accelerations',
        maxAcceleration: 'Maximum acceleration',
      },
    },
    teamAnalysis: 'Team Analysis',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: 'Left FB',
        centralDefender: 'Central Def.',
        rightFullback: 'Right FB',
        midfielder: 'Midfielder',
        attackingMidfielder: 'Attacking Mid.',
        leftWinger: 'Left Winger',
        rightWinger: 'Right Winger',
        fw: 'FW',
      },
      groups: {
        contractEnd: 'Months',
        age: 'Years Old',
        availability: 'Availabity',
      },
      placer: {
        legend: 'Strength based on age, contract, availability and performance',
      },
    },
    transfersTab: {
      valueMovements: 'Movements Value',
      valueTransfers: 'Transfers Value',
      valueLoans: 'Loans Value',
      avgAgeMovements: 'Movements Avg. Age',
      avgAgeTransfers: 'Transfers Avg. Age',
      avgAgeLoans: 'Loans Avg. Age',
      operations: {
        buys: {
          buy: 'Buy',
          loan: 'Loan',
          'end of loan': 'End of Loan',
          'free transfer': 'Free',
          free: 'Free',
          'loan transfer': 'Loan',
          other: 'Other',
        },
        sells: {
          buy: 'Sell',
          loan: 'Loan',
          'end of loan': 'End of Loan',
          'free transfer': 'Free',
          free: 'Free',
          'loan transfer': 'Loan',
          other: 'Other',
          retired: 'Retired',
        },
      },
    },
    trendsTab: {
      streaks: 'Streaks',
      wins: 'Wins',
      losses: 'Losses',
      results: 'Results',
      cleanSheets: 'Cleansheets',
      goalPeriods: 'Scored Goal Periods',
      concededGoalPeriods: 'Conceded Goal Periods',
      comebacks: 'Comeback',
      avgTime: 'Average Time',
      kindOfGoals: 'Goal Types',
      kindOfConcededGoals: 'Conceded Goal Types',
      percentWinning: '% Winning',
      percentDrawing: '% Drawing',
      percentLosing: '% Losing',
      totalOf: 'Total of',
      minutes: 'minutes',
      before: 'Before',
      after: 'After',
      playedOn: 'Played on',
      scored: 'Scored',
      conceded: 'Conceded',
      ownGoals: 'Own Goals',
      phasesOfGame: 'Phases of Game',
      showMinutes: 'Show Minutes',
      intensityLabel: 'Zone intensity',
      intensityByTeam: 'By Team %',
      intensityByLeagueAvg: 'By League Avg %',
      buildup: 'Buildup',
      midfieldProgression: 'Midfield Progression',
      attackOpposition: 'Attack Opposition',
      attackingTransition: 'Attacking Transition',
      highPress: 'High Press',
      midBlock: 'Mid Block',
      lowBlock: 'Low Block',
      defensiveTransition: 'Defensive Transition',
      draws: 'Draws',
      losts: 'Losses',
      chokes: 'Choke',
      zoneTooltip: "Determines the criteria used for each block's color gradient:",
      teamPctTooltip: 'Based on the percentage of total time played by the team in each zone.',
      leagueAvgPctTooltip: "Compares the team's percentage against the league average for each zone.",
      leagueAvgMinsTooltip: "Applies the same comparison criteria against the league, but evaluates total time in minutes instead of percentages."
    },
    onOff: "On/Off",
    dragUpToXPlayers: "Drag up to {x} players",
    selectUpToXPlayers: "Select up to {x} players",
    onOffTab: {
      G90: 'Goals 90',
      GA90: 'Goals Against 90',
      diffG90: 'Goals Difference 90',
      XG90: 'xG 90',
      XGA90: 'xG Against 90',
      diffXG90: 'xG Difference 90',
      playersOn: 'Combo ON',
      playersOff: 'Combo OFF',
      ground: 'Ground',
      playersOnThePitch: 'Players on the pitch',
      playersOffThePitch: 'Players out of the pitch',
      attackTitle: 'Attack',
      attackSubTitle: 'Offensive Stats',
      defenseTitle: 'Defense',
      defenseSubTitle: 'Defensive Stats',
      associationTitle: 'Association',
      associationSubTitle: 'Associative Stats',
      comboOn: 'Active Combo',
      comboOff: 'Any other',
      diffGoals90: 'G Diff 90',
      goals90: 'Non-Penalty Goals 90',
      goalsAgainst90: 'Non-Penalty Goals Against 90',
      xgAgainstPer90: 'xG Against 90',
      xgDiffPer90: 'xG Diff 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Shots On Target 90',
      touchesOppBox90: 'Touches Opp Box 90',
      shotsOnTargetAgainst90: 'Shots On Target Against 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Directness 90',
      possession: 'Possession %',
      pctPasses: 'Passes %',
      pctPassesFinalThird: 'Passes Final Third %',
      placeholder: 'Start by selecting a team',
      subtitle:
        "Optimize the team's metrics by adding or removing players from the lineup",
    },
    terms: {
      short: 'Short Term',
      mid: 'Mid Term',
      long: 'Long Term',
    },
    report: {
      title: 'Team Report',
      selectedPeriod: 'Selected Period',
      stackedCharts: 'Stacked Charts',
      radars: 'Radars',
      generalData: 'General Data',
      scoringChances: 'Scoring Chances',
      areasReport: 'Areas Report',
      setPieceReport: 'Set Piece Report',
      corners: 'Corners',
      cornersAgainst: 'Corners Against',
      indirectFreeKicks: 'Indirect Free Kicks',
      indirectFreeKicksAgainst: 'Indirect Free Kicks Against',
      freeKicks: 'Free Kicks',
      freeKicksAgainst: 'Free Kicks Against',
      penaltys: 'Penaltys',
      freeKicksContribution: 'Free Kicks Contribution',
      shotsContribution: 'Shots Contribution',
      topXPlayersByStats: 'Top {x} Players by Stats',
      lastShotZone: 'Last Zone Shot',
      throwSide: 'Throw Side',
      kindOfThrow: 'Kind of Throw',
      scored: 'Scored',
      against: 'Against',
      perGame: 'per Game',
      total: 'Total',
      efficiency: 'Efficiency',
      organizedAttack: 'Organized Attack',
      offTransition: 'Offensive Transition',
      chances: 'Chances',
      chancesScored: 'Chances Scored',
      chancesAgainst: 'Chances Against',
      goalsScored: 'Goals Scored',
      goalsAgainst: 'Goals Against',
      goalsOrganizedAttack: 'Goals Organized Attack',
      goalsOffTransition: 'Goals Offensive Transition',
      goalsSetPiece: 'Goals Set Piece',
      goalsOrganizedAttackScored: 'Goals Org. Att. Scored',
      goalsOrganizedAttackAgainst: 'Goals Org. Att. Against',
      goalsOffTransitionScored: 'Goals Off. Tran. Scored',
      goalsOffTransitionAgainst: 'Goals Off. Tran. Against',
      goalsSetPieceScored: 'Goals Set Piece Scored',
      goalsSetPieceAgainst: 'Goals Set Piece Against',
      crossSide: 'Cross Side',
      externalShot: 'External Shot',
      innerPlay: 'Inner Play',
      throwIn: 'Throw In',
      box: 'Box',
      zone2: 'Zone 2',
      goalsPerPhases: 'Goals per Phases',
    },
    minutesAlert: '*Showing only players with 450 or more minutes played',
    teamMinutesAlert: '*Showing only teams with 450 or more minutes played',
    minutesException:
      'There are not players with 450 or more minutes played. Showing all players',
    analysis: 'Analysis',
    substitutions: 'Substitutions',
    attackZones: 'Attack Zones',
    formations: 'Formations',
    shotZones: 'Shot Zones',
    crossings: 'Crossings',
    byTime: 'By Time',
    byPosition: 'By Position',
    byPlayer: 'By Player',
    W: 'Winning',
    D: 'Drawing',
    L: 'Losing',
    substitutionsByGame: 'Substitutions by game',
    substitutionsShort: 'Subs.',
    avgSeasonShort: 'Avg. Season',
    startingAt: 'Starting at',
    endingAt: 'Ending at',
    startingAtInfo:
      'Shows share of possessions based on the location of the first event',
    endingAtInfo:
      'Shows share of possessions based on the location of the last event',
    endingWithShot: 'Ending with shot',
    endingInBox: 'Ending in box',
    pfX: 'PF {x}',
    bySide: 'By Side',
    cornerKicks: 'Corner Kicks',
    included: 'Included',
    excluded: 'Excluded',
    onlyCorner: 'Only Corner',
    sizeByMarketValue: 'Size by Market Value',
    timeInTeam: 'Seasons in Team',
    newSignings: 'New Signings',
    sizeBy: 'Size by',
    connections: 'Connections',
    assistant: 'Passer',
    finisher: 'Finisher',
    playersMinutesAlert: 'Showing only players with minutes played in the selected season',
    sideFilterTooltip: 'Display only the set pieces that start on the selected side (left or right)',
    strategyFilterTooltip: 'Display the events that happened during set pieces or during an open play'
  },
  leagueTable: {
    subtitle: 'Check how the leagues go',
  },
  leagueMatchdays: {
    byRound: 'By Round',
    byDate: 'By Date',
    byTeam: 'By Team',
  },
  teamStats: {
    subtitle: 'Compare how teams are performing',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Difference between Expected Goals and Goals',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Difference between Expected Points and Points',
    games: 'GAM',
    gamesExplicit: 'Games played',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Points per Game',
  },
  roles: {
    ROLE_USER: 'User',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_RAW_EVENTING: 'Raw Eventing',
    ROLE_API_description:
      'Extract player, team, game and league info effortlessly in JSON format.',
    ROLE_EVENTING_DATA_description:
      'Dive deep into statistics with Radar Charts, Player Rankings, maps and more based on +100 performance metrics.',
    ROLE_PHYSICAL_DATA_description:
      'Access fitness data and filter players by various performance metrics (distance, speed, sprints, acceleration…).',
    ROLE_VIDEO_description:
      'Provide videos and lineups and get games tagged with events and statistics for in-depth analysis.',
    ROLE_DRIBLAB_HUB_description:
      'Efficiently track and manage scouting tasks with calendars, notes, alerts and document sharing.',
    ROLE_TRACKING_description:
      'Receive positional data of all players in a game through our API for comprehensive analysis.',
    ROLE_ARRIGO_description:
      'Combine eventing and tracking data into innovative metrics that go beyond the traditional and add value to every action.',
    ROLE_REPORTS_description:
      'Request detailed scouting reports from our team of analysts to find the perfect team or player.',
  },
  administration: {
    pageSubtitle: "Manage the application's operation",
    newClient: 'New Client',
    clientDuplicateName:
      'A client with this name already exists. Select that client in the list and use "New user" to add users there.',
    newUser: 'New User',
    editClient: 'Edit Client',
    editUser: 'Edit User',
    clientName: 'Name',
    permissions: 'Permissions',
    releaseUser: 'Release User',
    connectAsUser: 'Connect as User',
    releaseModalTitle: 'Release User Confirmation',
    releaseModalMessage:
      'The user will recieve an email about his new account. Are you sure you want to notify him?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Team',
      Brand: 'Brand',
      Federation: 'Federation',
      Media: 'Media',
      Agency: 'Agency',
      Individual: 'Individual',
    },
    userType: {
      Ownership: 'Ownership',
      SportingDirector: 'Sporting Director',
      Brand: 'Brand',
      Federation: 'Federation',
      Media: 'Media',
      Agency: 'Agency',
      Individual: 'Individual',
      Scout: 'Scout',
      Coach: 'Coach',
      supervision: {
        title: "Supervision hierarchy",
        subtitle: "Supervision flows downward only. Same-level supervision is not allowed.",
        supervisesLowerLevels: "Supervises all roles below",
        ruleNoSameLevel: "Roles at the same level cannot supervise each other.",
        ruleOnlyDownwards: "Supervision is only allowed from higher to lower roles.",
        ruleLevel3NoSupervision: "The lowest level has no supervision permissions.",
        currentUserType: "Your current user type",
      }
    },
    visibleYears: 'Visible Years',
    areaModalTitle: 'Activate/Deactivate Leagues Confirmation',
    areaModalMessage:
      'Are you sure to activate/deactivate all leagues from selected area?',
    countStats: 'Count Stats',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Contract',
    contracts: 'Contracts',
    invoiceName: 'Invoice Name',
    contractFee: 'Contract Fee',
    renewal: 'Renewal',
    consultancy: 'Consultancy',
    deleteContract: 'Delete Client Contract',
    deleteContractMessage:
      'The contract will be removed permanently. Are you sure?',
    activeVsHired: 'Active vs Hired',
    requestedVsHired: 'Requested vs Hired',
    activeVsHiredWithPlaceholder: '{0} Active vs {1} Hired',
    requestedVsHiredWithPlaceholder: '{0} Requested vs {1} Hired',
    salesRepresentative: 'Sales Representative',
    periodicities: {
      periodicity: 'Periodicity',
      annual: 'Annual',
      biannual: 'Biannual',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
      bimonthly: 'Bimonthly',
      onePayment: 'One payment',
      fourmonthly: 'Every four months',
    },
    paymentMethods: {
      payment: 'Payment',
      method: 'Method',
      transfer: 'Transfer',
      mandate: 'Mandate',
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Social Media Ad',
      videoWithFeedback: 'Video with Feedback',
    },
    status: {
      status: 'Status',
      pending: 'Pending',
      active: 'Active',
      expiringSoon: 'Expiring soon',
      expired: 'Expired',
      expiringSoonWithDays: "Contract is expiring soon: {0} days left"
    },
    updates: {
      roleAdded: '<b>{0}</b> added role <b>{1}</b> to <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> removed role <b>{1}</b> from <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> added <b>{1}</b> to league <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> removed <b>{1}</b> from league <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> added <b>{1}</b> to season <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> removed <b>{1}</b> from season <b>{2}</b>.',
      updateNotesPlaceholder:
        'Please include some context for the change or add any relevant notes here...',
      updates: 'Updates',
      products: 'Products',
    },
    clients: "Clients",
    trials: "Trials",
    activeClients: "Active Clients",
    activeTrials: "Active Trials",
    activeTrialUsers: "Active Trial Users",
    activeContracts: "Active Contracts",
    expiration: "Expiration",
    clientWarnings: {
      activeContractInactiveClient: "Clients with active contracts but no enabled users",
      activeContractTrialUsers: "Clients with trial users while a contract is active",
      activeUsersWithoutContract: "Clients with active non-trial users but no active contract",
      upcomingExpirations: "Upcoming expirations",
      renewedContracts: "Clients under renewed contracts",
      clientsWithWarnings: "Clients requiring attention",
      enabledUsersWithoutContract: "'Enabled non-trial users without an active contract'",
      trialUsersWithContract: "Users in trial mode despite an active contract",
      activeContractInactiveUsers: "Client has an active contract with all users inactive",
      activeContract: "This client has an active contract",
      noEnabledUsers: "This client has no enabled users",
      ongoingTrialInactiveUsers: "Clients with an ongoing trial but no enabled users",
      neverLoggedIn: "Clients that have never logged in",
    },
    daysLeft: "Days left",
    expiringSoon: "Expiring soon",
    loggedThisWeek: "Logged in this week",
    withWarnings: "With warnings",
    ofActiveClients: "of active clients",
    endingIn30Days: "ending in 30 days",
    neverLogged: "never logged in",
    ofActiveTrials: "of active trials",
    activeClientsWithoutTrial: "active clients (excl. trial)",
    renewals: "Renewals",
    ofActiveContracts: "of active contracts",
  },
  dashboards: {
    lastGame: 'Last game analysis',
    lastGameSimple: 'Last game',
    seeAllGameInfo: 'See all game info',
    nextGame: 'Next Game Preview',
    myTeam: 'My Team',
    lastMatchdayGames: 'Last Matchday',
    lastAdded: 'Last Added',
    myFavorites: 'My Favorites',
    seeAllFavorites: 'See all favorites',
    placeholderFavorites: 'You can add favorites from player detail',
    placeholderTeamFavorites: 'You can add favorites from team detail',
    placeholderLeagueFavorites: 'You can add favorites from league detail',
    myCollections: 'My Collections',
    placeholderCollections: 'You don´t have any collections yet',
    lastCreated: 'Last Created',
    seeAllCollections: 'See all collections',
    seeRival: 'See Opponent',
    seeMyTeam: 'See My Team',
    title: 'Dashboard Overview',
    subtitle: 'Welcome back',
    recentPlayers: 'Recent players',
    lastScouted: 'Last scouted',
    scout: 'Scout',
    reportsRequested: 'Reports',
    lastRequested: 'Last requested',
    goInbox: 'Go Inbox',
    placeholderLastScouted:
      'You can search for players in the left bar or in the scout tool',
    placeholderReports: 'You can request reports from players detail',
    nationalPlayers: 'Most valuable national players in others countries',
    lastGames: 'Last Games',
    nationalPlayersShort: 'National players in others countries',
    nextMatchdayGames: 'Next Matchday',
    injuredPlayers: 'Injured Players',
    atPresent: 'Nowadays',
    seeAllPlayers: 'See all players',
    suspendedPlayers: 'Suspended Players',
    placeholderInjured: 'There are no injured players',
    teamValueImpacted: 'Team Value Impacted',
    placeholderSuspended: 'There are no suspended players',
    placeholderNextGame: 'There is no available game',
    placeholderNoGames: 'There are no games available yet',
    placeholderLastMatchDayNotFound: 'Last matchday not available',
    placeholderNextMatchDayNotFound: 'Next matchday not available',
    usersMostSearch: 'Users with most searches',
    lastTwoDays: 'Last two days',
    searchesHistory: 'Searches History',
    dayByDay: 'Daily',
    activeUsersTitle: 'Active Users',
    activeUsersSubtitle: 'Logged at least one in last month',
    onlineUsersTitle: 'Online Users',
    onlineUsersSubtitle: 'Search something in last hour',
    searchesPerformed: 'Searches Made',
    onlyClients: 'Only clients',
    activeClientsTitle: 'Active Clients',
    activeClientsSubtitle: 'Have at least one active user',
    last24Hours: 'Last 24 Hours',
    activityHistory: 'Activity History',
    loginHistory: 'Access History',
    failLogins: 'Fail Access',
    successLogins: 'Success Access',
    clientStats: 'Client Stats',
    playersMostSearch: 'Players with most searches',
    toolsMoreUsed: 'More used tools',
    hotPlayers: 'Hot Players',
    last_month: 'Last Month',
    last_week: 'Last Week',
    last_day: 'Last Day',
    nClients: 'Nº of Clients',
    userDashboard: 'User Dashboard',
    userDashboardSubtitle: 'Account activity summary',
    offlineDaysOfClient: 'Offline days for each client',
    hideNoConnected: 'Hide no connected',
    onlyTrial: 'Only trial clients',
    daysWithoutLogin: 'Days without logging in',
    trialDays: 'Trial days',
  },
  faq: {
    subtitle: 'Learn more about what Driblab PRO is',
    categories: {
      playerMetrics: 'Player Metrics',
      teamMetrics: 'Team Metrics',
      positions: 'Team Positions',
      tools: 'Tools',
      api: 'API',
      videos: 'Tutorials',
      playerPositions: 'Player Positions',
      userTypes: 'User Types'
    },
    positions: {
      GK: 'Goal Keeper',
      DR: 'Defender Right / Right Fullback (RB)',
      DC: 'Defender Center / Center Back (CB)',
      DL: 'Defender Left / Left Fullback (LB)',
      DMR: 'Right Wingback (RWB)',
      DMC: 'Centre Defensive Midfielder (CDM)',
      DML: 'Left Wingback (LWB)',
      MR: 'Right Midfielder (RM)',
      MC: 'Center Midfielder (CM)',
      ML: 'Left Midfielder (LM)',
      AMR: 'Attacking Midfielder Right / Right Winger (RW)',
      AMC: 'Attacking Midfielder Center / Advanced Midfielder',
      AML: 'Attacking Midfielder Left / Left Winger (LW)',
      FWR: 'Forward Right / Right Striker (RS)',
      FW: 'Forward / Striker (ST)',
      FWL: 'Forward Left / Left Striker (LS)',
    },
    metrics: {
      categories: {
        Association: 'Association',
        Saving: 'Saving',
        Shooting: 'Shooting',
        Defending: 'Defending',
        Passing: 'Passing',
        BallHandling: 'Ball Handling',
        Aerial: 'Aerial',
        Physical: 'Physical',
        Predictive: 'Predictive',
        Arrigo: 'Arrigo',
        Score: 'Score',
        Turnovers: 'Turnovers',
        Carries: 'Carries',
        SequenceInvolvement: 'Sequence Involvement',
        Crosses: 'Crosses',
        Distance: 'Distance',
        Sprint: 'Sprint',
        Acceleration: 'Acceleration',
        MaxAcceleration: 'Max Acceleration',
        Speed: 'Speed',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Line Breaking Passes',
        LineBreakingCarries: 'Line Breaking Carries',
        LineBreakingActions: 'Line Breaking Actions',
        PassUnderPressure: 'Pass Under Pressure',
        BallReceived: 'Ball Receipts',
        PassesUnderPressure: 'Passes Under Pressure',
        OnBallPressureReceived: 'On-Ball Pressure Received',
        OnBallPressure: 'On-Ball Pressure',
        BallReceiptsInSpace: 'Ball Receipts in Space',
        SpatialCoverage: 'Spatial Coverage',
        OffBallPressure: 'Off-Ball Pressure',
        OffBallRuns: 'Off-Ball Runs',
        NoCategory: 'Others',
        subcategories: {
          Quality: 'Quality',
          Quantity: 'Quantity',
          TeamComparison: 'Team Comparison',
          Receptions: 'Receptions',
          LongBalls: 'Long Balls',
          Efficiency: 'Efficiency',
          Ratio: 'Ratio',
          Defensive: 'Defensive',
          Offensive: 'Offensive',
          Foot: 'Foot',
          Progression: 'Progression',
          TopValue: 'Top Value',
          Predictive: 'Predictive',
          Distance: 'Distance',
          Aerial: 'Aerial',
          Crosses: 'Crosses',
          NoCategory: 'Others',
        },
        desc: {
          Association: 'Association',
          Saving: 'Saving',
          Shooting: 'Shooting',
          Defending: 'Defending',
          Passing: 'Passing',
          BallHandling: 'Ball Handling',
          Aerial: 'Aerial',
          Physical: 'Physical',
          Predictive: 'Predictive',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Turnovers',
          Carries: 'Carries',
          SequenceInvolvement: 'Sequence Involvement',
          Crosses: 'Crosses',
          Distance: 'Distance covered at different speeds',
          Sprint: 'Sprint at different speeds',
          Acceleration: 'Acceleration',
          Speed: 'Speed achieved by players at some point during the match',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Line Breaking Passes',
          LineBreakingCarries: 'Line Breaking Carries',
          LineBreakingActions: 'Line Breaking Actions',
          PassUnderPressure: 'Pass Under Pressure',
          BallReceived: 'Ball Receipts',
          OnBallPressureReceived: 'On-Ball Pressure Received',
          OnBallPressure: 'On-Ball Pressure',
          BallReceiptsInSpace: 'Ball Receipts in Space',
          SpatialCoverage: 'Spatial Coverage',
          OffBallPressure: 'Off-Ball Pressure',
          OffBallRuns: 'Off-Ball Runs',
        },
        abbr: {
          Association: 'Association',
          Saving: 'Saving',
          Shooting: 'Shooting',
          Defending: 'Defending',
          Passing: 'Passing',
          BallHandling: 'Ball H.',
          Aerial: 'Aerial',
          Physical: 'Physical',
          Predictive: 'Predictive',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'TOV',
          Carries: 'Carries',
          SequenceInvolvement: 'Seq. Involv.',
          Crosses: 'Crosses',
          Distance: 'Distance',
          Sprint: 'Sprint',
          Acceleration: 'Acceleration',
          MaxAcceleration: 'Max. Acceleration',
          Speed: 'Speed',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Line Breaking Passes',
          LineBreakingCarries: 'Line Breaking Carries',
          LineBreakingActions: 'Line Breaking Actions',
          PassUnderPressure: 'Pass Under Pressure',
          BallReceived: 'Ball Receipts',
          OnBallPressureReceived: 'On-Ball Pressure Received',
          OnBallPressure: 'On-Ball Pressure',
          BallReceiptsInSpace: 'Ball Receipts in Space',
          SpatialCoverage: 'Spatial Coverage',
          OffBallPressure: 'Off-Ball Pressure',
          OffBallRuns: 'Off-Ball Runs',
        },
      },
      types: {
        1: 'Per 90',
        2: 'Percentage',
        3: 'Rate',
        4: 'Efficiency',
        5: 'Average',
        6: 'Per Game',
        7: 'Difference',
        8: 'Max',
      },
      moreInfo: 'You can read more here',
    },
    api: {
      subtitle: 'Get data from different requests',
      resourcesTitle: 'Resources',
      authentication: 'Authentication',
      authText:
        'In order to call the API you have to include in every request the header `Authorization` with value `Bearer {API_TOKEN}`',
      generate: 'Generate',
      tokenPlaceholder:
        "If you do not have a token or it has expired, click on 'Generate'",
      pathParameters: 'Path Parameters',
      queryParameters: 'Query Parameters',
      responseModel: 'Response Model',
      tokenWarning: '* Generate a token in order to use the API',
      pathParamsWarning: '* There are unfilled Path Parameters',
      genericDescription:
        'An API (Application Programming Interface) allows developers to access and integrate data or functionality into their own applications. Our football statistics API provides comprehensive access to a variety of data points about countries, competitions, teams, players, games, and more. By using this API, you can build applications that leverage our rich soccer data for analytics, visualizations, or other innovative solutions.',
      methods: {
        getAllCountries:
          "This method retrieves a complete list of all countries available in the API, providing key details such as each country's unique identifier and name. This endpoint is ideal for applications that require geographic soccer data, enabling features like country selection, filtering, and analytics. It also serves as a foundational resource for interacting with other endpoints that depend on a `countryId` parameter, ensuring smooth navigation and integration with the API's broader dataset.",
        getCountryDetail:
          "This method provides detailed information about a specific country available in the API. By using this endpoint, you can retrieve data such as the country's name, code, and any relevant metadata associated with it. This method is particularly useful for applications requiring country-specific details to enhance user experience, such as displaying contextual information or creating tailored insights based on geographic data. It complements other endpoints by allowing deeper exploration of a selected country.",
        getCountryCompetitions:
          'This method retrieves a list of all competitions available within a specific country. It is a valuable resource for building features that allow users to explore competitions by region, providing a seamless way to connect country data with its associated tournaments. This endpoint is essential for applications focusing on localized soccer content or regional analytics.',
        getAllCompetitionTypes:
          'This method returns a list of all competition types available in the API, such as leagues, cups, and international tournaments. This endpoint is ideal for categorizing competitions and providing users with an organized view of the different types of events covered. It is especially useful for building features like filters or dropdowns that allow users to explore soccer data based on the nature of the competition.',
        getAllCompetitions:
          'This method retrieves a comprehensive list of all competitions available in the API, regardless of type or location. This endpoint is useful for applications that need to display or analyze a wide range of soccer competitions, allowing users to explore and select events of interest.',
        getCompetitionAvailable:
          'This method retrieves a list of competitions currently marked as available in the API. This ensures that the returned data is up-to-date and ready for use in applications. It is particularly useful for developers building features that rely on active or accessible competitions, enabling users to explore relevant events without encountering outdated or incomplete data.',
        getCompetitionDetail:
          'This method provides detailed information about a specific competition available in the API. It is particularly useful for applications that require in-depth information about a competition, enabling features like detailed views, contextual insights, or filtering options based on competition characteristics.',
        getCompetitionSeasons:
          "This method retrieves a list of all seasons associated with a specific competition. This endpoint is essential for applications that aim to provide comprehensive coverage of a competition's history or current state, allowing users to explore data season by season.",
        getSeasonAvailable:
          'This method provides a list of seasons currently marked as available in the API. It is particularly useful for applications that focus on live or ongoing soccer events, allowing users to interact with relevant and current season data.',
        getSeasonDetail:
          'This method retrieves detailed information about a specific season, including its timeline, associated competition, and key metadata. This endpoint is essential for applications that require in-depth insights into a particular season, enabling features like season overviews, filtering by competition, or displaying detailed timelines for user interaction.',
        getSeasonTeams:
          'This method provides a list of all teams participating in a specific season. It is ideal for features like roster management, team performance analysis, or creating season-specific filters for users.',
        getSeasonPlayer:
          'This method retrieves a list of all players registered in a specific season. It is ideal for building features such as player rosters, performance tracking, or filtering players based on the selected season.',
        getSeasonPlayerStats:
          'This method provides detailed statistics for all players in a specific season. It is particularly useful for applications focused on analytics, player comparisons, or creating dynamic visualizations of season-long player achievements.',
        getSeasonArrigoMetrics:
          'This method provides combined statistics for all players in a specific season. It is particularly useful for applications focused on analytics, player comparisons, or creating dynamic visualizations of season-long player achievements.',
        getSeasonTeamStats:
          'This method provides comprehensive statistics for all teams participating in a specific season. It is particularly useful for applications focused on team analysis, season summaries, or comparisons of team performance throughout the season.',
        getSeasonCoaches:
          'This method retrieves a list of all coaches who managed teams during a specific season. It is particularly useful for applications that focus on season insights, coaching analysis, or tracking changes in team management over the course of a season.',
        getSeasonGames:
          'This method provides a list of all games played in a specific season. It is ideal for applications that need to display full season schedules, analyze game outcomes, or provide users with access to comprehensive season game data.',
        getSeasonGamesMatchday:
          'This method retrieves all games for a specific matchday within a given season. It is particularly useful for applications that aim to display matchday schedules, analyze specific rounds, or provide focused insights into a particular set of games during the season.',
        getSeasonLeagueTable:
          'This method provides the league table for a specific season, including rankings, points, wins, draws, losses, and other relevant statistics for each team. This endpoint is essential for applications focused on tracking team standings, analyzing league progression, or presenting users with up-to-date rankings throughout the season.',
        getTeamDetail:
          'This method provides detailed information about a specific team, including its name, foundation year, stadium, and other metadata. This endpoint is ideal for applications that require team-specific insights, enabling features like detailed team profiles, historical context, or enhanced user experiences with rich team-related data.',
        getTeamLoans:
          'This method retrieves information about loan transactions involving a specific team. This endpoint is particularly useful for applications focusing on transfer analysis, team roster management, or tracking player movements during a season.',
        getTeamRoster:
          "This method provides a complete list of players in a specific team's roster. It is ideal for applications that need to display team lineups, analyze player roles, or manage roster-related functionalities for a team.",
        getTeamGames:
          "This method retrieves a list of all games played by a specific team. It is particularly useful for applications that focus on team performance, schedule tracking, or providing users with access to a team's complete match history.",
        getTeamGameStats:
          "This method provides detailed statistics for a specific team in a given game. It is particularly useful for applications focusing on game analytics, performance evaluations, or in-depth breakdowns of a team's performance in individual matches.",
        getTeamTransfers:
          'This method retrieves information about transfer transactions involving a specific team. It is particularly useful for applications that focus on transfer market analysis, team roster changes, or tracking player movements over time.',
        getGameStatus:
          'This method provides a list of all possible game statuses available in the API, such as scheduled, in progress, completed, postponed, or canceled. This endpoint is particularly useful for applications that require real-time game tracking, filtering games by status, or providing users with clear updates on the progress or state of a match.',
        getPlayerPositions:
          'This method returns a list of all possible player positions, such as goalkeeper, defender, midfielder, and forward. This endpoint is particularly useful for applications that categorize players, analyze positional data, or allow users to filter players based on their roles on the field.',
        getGameDetail:
          'This method provides comprehensive information about a specific game, including details such as participating teams, date and time, venue, score, and other key metadata. This endpoint is ideal for applications that require in-depth game insights, enabling features like detailed match previews, reports, or analytics.',
        getGameStats:
          'This method provides detailed statistics for a specific game, including metrics such as goals, shots, possession percentages, passes, and defensive actions. This endpoint is particularly useful for applications focused on match analysis, post-game reports, or visualizations of team performance during a game.',
        getGamePlayerStats:
          'This method retrieves detailed performance statistics for all players who participated in a specific game. It is particularly useful for applications that analyze individual player performances, generate match reports, or compare players within a single game context.',
        getGamePlayerPhysicalStats:
          'This method provides detailed physical performance metrics for players in a specific game. It is particularly useful for applications focusing on player fitness analysis, physical performance tracking, or generating detailed game insights for individual players.',
        getGameTeamPhysicalStats:
          'This method provides detailed physical performance metrics for teams in a specific game. This includes data such as total distance covered, number of sprints, high-intensity runs, and other physical attributes. It is particularly useful for applications focused on team fitness analysis, comparing physical efforts between teams, or evaluating overall performance in a match.',
        getGamePlayerArrigoMetrics:
          'This method provides detailed arrigo metrics for players in a specific match. It is particularly useful for applications focused on analyzing and generating detailed insights into players in a match.',
        getGameTeamArrigoMetrics:
          'This method provides detailed arrigo metrics for teams in a specific match. This includes data such as players overtaken and other attributes. It is particularly useful for applications focused on analyzing and evaluating overall performance in a match.',
        getGameLineup:
          'This method retrieves the lineup for a specific game, including starting players, substitutes, and their respective positions. This endpoint is particularly useful for applications that display pre-match information, analyze team formations, or provide insights into tactical decisions made by teams for a given match.',
        getGameTimeline:
          'This method provides a chronological list of events that occurred during a specific game. It is particularly useful for applications that offer live match updates, post-match summaries, or detailed analyses of game events.',
        getGameTracking:
          'This method provides a link to download the tracking data file for a specific game. This file contains detailed movement and positional data for players and the ball throughout the match. It is particularly useful for applications focused on advanced analytics, tactical analysis, or creating visualizations of player and ball movements during the game.',
        getGameEventing:
          'This method provides all events',
        getGameTs:
          'This method provides the last timestamp in a specific match',
        getGameFileTypes:
          'This method provides the file types for match',
        getTrackingStatus:
          "This method returns a complete list of all states available in the tracking, providing key details such as the unique identifier and name of each state. This endpoint is ideal for applications that require match tracking, enabling features such as state selection, filtering and analysis. It also serves as a critical resource for interacting with other endpoints that depend on a `statusId` parameter, ensuring seamless navigation and integration with the API's broader data set.",
        getPlayerTransfersTypes:
          'This method retrieves a list of possible player transfer types, such as permanent transfer, loan, free transfer, or exchange. This endpoint is particularly useful for applications that analyze transfer market trends, categorize player movements, or provide users with detailed insights into the types of transactions involving players.',
        getPlayerDetail:
          'This method provides detailed information about a specific player, including personal details, career statistics, and current team affiliation. This endpoint is ideal for applications that offer player profiles, historical insights, or analytics on individual player performances and career trajectories.',
        getPlayerGames:
          'This method retrieves a list of all games a specific player has participated in. It is particularly useful for applications focused on player performance tracking, match history analysis, or providing users with comprehensive game logs for individual players.',
        getPlayerInjuries:
          'This method provides a detailed record of injuries sustained by a specific player. It is particularly useful for applications focused on player health analysis, career impact assessments, or tracking recovery timelines.',
        getPlayerNationalTeam:
          "This method retrieves detailed information about a player's participation in national team matches. It is particularly useful for applications focusing on player performance at the national level, tracking international careers, or providing insights into contributions during tournaments and friendlies.",
        getPlayerSeasons:
          "This method provides a list of all seasons in which a specific player has participated. It is particularly useful for applications that track a player's career progression, analyze performance across seasons, or provide historical context for their achievements.",
        getPlayerTransfers:
          'This method retrieves a detailed history of transfer transactions involving a specific player. It is particularly useful for applications focused on player career analysis, transfer market insights, or tracking the movement of players between teams over time.',
        getPlayerSeasonTeamStats:
          'This method provides detailed performance statistics for a specific player during a particular season with a team. It is particularly useful for applications focused on season-long player analysis, comparisons across teams or seasons, and tracking individual contributions to team success.',
        getPlayerSeasonPhysicalStats:
          "This method provides detailed physical performance metrics for a specific player throughout a season. It is particularly useful for applications focusing on player fitness tracking, physical performance analysis, or assessing a player's workload during a season.",
        getPlayerSeasonGamePhysicalStats:
          'This method provides detailed physical performance metrics for a specific player on a game-by-game basis within a season. It is particularly useful for applications focusing on game-specific fitness analysis, tracking player workload, or comparing physical performance across different matches.',
        getPlayerSeasonGameStats:
          'This method retrieves detailed performance statistics for a specific player on a game-by-game basis within a season. It is particularly useful for applications focusing on match-specific player analysis, performance trends, or detailed comparisons across games within a season.',
        getCoachDetail:
          'This method provides detailed information about a specific coach, including their name, career history, teams managed, and notable achievements. This endpoint is particularly useful for applications that highlight coaching profiles, track managerial careers, or analyze the impact of coaches on team performance.',
        getCoachHistory:
          "This method retrieves a comprehensive history of a specific coach's career, including the teams they have managed, competitions participated in, and their tenure durations. This endpoint is particularly useful for applications that focus on analyzing coaching careers, tracking managerial changes, or providing insights into a coach's professional journey and achievements.",
        getLinkStream:
          "This method retrieves the link to watch game video",
        getLinkDownload:
          "This method retrieves the linkt to download game video",
        deletePlayer: 
          "This method delete a player"
      },
      responseCodes: 'Response Codes',
      furtherInformation:
        'For further information, please read our API documentation',
      clipboard: 'Copied to clipboard!',
      limit50: 'Only showing the first 50 results'
    },
  },
  globalSearch: {
    subtitle: 'Deep Filtering',
  },
  global: {
    teamElos: {
      title: "Team ELO's",
      subtitle: 'Global team rankings and insights',
      team: 'Team',
      teams: 'Teams',
      dates: 'Dates',
      excludeInternational: 'Exclude International Teams',
      elo: 'ELO',
      selectButton: 'Select Top',
      selectTeamFromTable: 'Select a team from the table to view the ELO trend.',
      showingTeamAveragesLastSeason: 'Showing team averages for last season',
      showingTeamStatsLastSeason: 'Showing only team average stats for their last active season',
      searchToolTip: 'Tip: Press Ctrl + B to a direct access to the search bar',
      selectTopTooltip: 'Display additional teams in the chart for comparison',
      loadingPage: 'Preparing the Data...'
    },
    leagueElos: {
      title: "League ELO's",
      subtitle: 'Global league rankings and insights',
      rankings: 'RANKINGS',
      insights: 'INSIGHTS',
      filters: 'FILTERS',
      leagues: 'Leagues',
      from: 'From',
      to: 'To',
      elo: 'ELO',
      change: 'Change',
      league: 'League',
      excludeContinental: 'Exclude International Competitions',
      eloTrend: 'ELO Trend',
      eloRanking: 'ELO Ranking',
      currentELOLabel: '(Current ELO)',
      allTime: 'All Time',
      average: 'Average',
      noChartData: 'No chart data available for the selected filters.',
      selectLeagueFromTable: 'Select a league from the table to view the ELO trend.',
      noInsightsData: 'No insights data available for the selected leagues. Please ensure the leagues have available seasons and team insights data.',
      showingLeagueAveragesLastSeason: 'Showing only league averages for their last active season',
      selectTopTooltip: 'Display additional leagues in the chart for comparison',
      confederations: {
        world: 'World',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Number of leagues'
    },
    players: {
      title: "Player's GPI",
      subtitle: "Global player rankings and insights",
      gpiRanking: "GPI Ranking",
      rankTooltip: 'Hover to display the global ranking',
      globalRanking: 'Global Ranking',
      player: "Player",
      players: "Players",
      gpiTrend: "GPI Trend",
      currentGPILabel: "(Current GPI)",
      nationality: "Country of Birth",
      position: 'Position',
      marketValue: 'Market Value',
      apply: 'Apply',
      marketValueAndAgeTooltip: 'Enter a range and press Enter.',
      searchPlaceholder: 'Search a Player...',
      selectTopTooltip: 'Display additional players in the chart for comparison',
      gpi: 'GPI',
      numberOfPlayers: 'Number of players',
      showingPlayerStatsLastSeason: 'Showing only player average stats for their last active season',
      date: 'DATE',
      showChartLabels: 'Show Labels',
      freeAgents: 'Free Agents',
      selectPlayerFromTable: 'Select a player from the table to view the GPI trend.',
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: "Cote d'Ivoire",
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'Japón',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europe',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten',
  },
  loadingMessages: {
    players: 'Preparing Players',
    teams: 'Ordering Teams',
    games: 'Fetching Games',
    stats: 'Calculating Metrics',
    graphs: 'Drawing Graphs',
    gettingReady: 'Warming Up',
    placeholder: 'Get Ready',
  },
  requestReport: {
    subtitle: 'Get a deep report with all you need',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle:
          'Who are the best players of a certain league? And from several leagues combined? Request a tailor-made report with any filter you want (age, height, contract end, etc..) and find out what players fit best',
      },
      coaches: {
        title: 'Coaches',
        subtitle:
          'How would a coach fit into the system of your team? Get detailed infomation or, given a certain profile, get to know which coaches fit best',
      },
      'team analysis': {
        title: 'Team',
        subtitle:
          'Specify a team and obtain the season summary with valuable insights about style, defensive and offensive performance, weak points, best players, etc...',
      },
      'game analysis': {
        title: 'Game Analysis',
        subtitle:
          'Given a match, get a deep pre-game and post-game analysis with detailed information',
      },
      'special projects': {
        title: 'Special Projects',
        subtitle:
          'How does a player perform in away games? How do players change from league to league? Which players are available for loan? Ask anything you can think of',
      },
      conversation: {
        title: 'Conversation',
        subtitle: 'Start a conversation with our team',
      },
    },
    notesPlaceholder:
      'Let us know the league, profile, stats, coach, team or game you want to know more about',
    chooseType: 'Select a report type',
    requestSummary: 'Request Summary',
    reportType: 'Report Type',
    reportLanguage: 'Report Language',
    detailTitle: 'Follow-up of report',
    detailSubtitle: 'All the info on the report you requested',
  },
  bugReport: {
    modalSubtitle: 'Help us to improve',
    about: 'About',
    sendSuccess: 'Successfully notified. Check updates in the Inbox',
    bugs: 'Bugs',
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Continental Competition',
    points: 'Points',
    titleWinner: 'Title Winner',
    qualifiedGroupsBandX:
      'Qualified for group stage of a Band {0} Continental Competition',
    qualifiedQualifiersBandX:
      'Qualified for qualifiers of a Band {0} Continental Competition',
    midTable: 'Mid-Table',
    relegation: 'Relegation',
    promotion: 'Promotion',
    final: 'Final',
    semifinal: 'Semi-Finals',
    quarterfinal: 'Quarterfinals',
    round16: 'Round of 16',
    round32: 'Round of 32',
    groupstage: 'Group Stage',
    firstRound: '1st Round',
    secondRound: '2nd Round',
    thirdRound: '3rd Round',
    fourthRound: '4th Round',
    preliminaryRound: 'Preliminary Round',
    other: 'Other',
    score: 'Score',
    totalSummary: 'Total Summary',
    currentlyPlayingInUK:
      'The player is a citizen of the United Kingdom or Ireland, or the player is a permanent resident in the United Kingdom',
    bandsAlert:
      'There are minutes played in more than one band, total is the max value',
    bandsAlertMax:
      'There are minutes played in more than one band, total is the max value',
    bandsAlertAvg:
      'There are minutes played in more than one band, total is the average value',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: "Player's International Appearances",
      title1:
        'Aggregated FIFA World Ranking of the Player’s National Association',
      title2: "Player's International Appearances",
    },
    table2: {
      name: 'Player’s Domestic Minutes',
      title1: 'Player’s Domestic Minutes',
    },
    table3: {
      name: 'Player’s Continental Minutes',
      title1: 'Player’s Continental Minutes',
    },
    table4: {
      name: 'Final League Position of Player´s Last Club',
      title1: 'Last Club’s Final League Position',
    },
    table5: {
      name: 'Continental Progression of Player´s Last Club',
      title1: 'Continental Progression',
    },
    table6: {
      name: 'League Quality of Player´s Current Club',
      title1: 'Band of Player’s Current Club',
    },
    table7: {
      name: 'Youth - Debut',
      title1: 'Band',
    },
    table8: {
      name: 'Youth - Final League Position',
      title1: 'Last Club’s Final League Position',
    },
    table9: {
      name: 'Youth - Continental Progression',
      title1: 'Continental Progression',
    },
    table10: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club',
    },
    table11: {
      name: 'Youth - League Quality of Player´s Current',
      title1: 'Band of Player’s Current Club',
    },
    table12: {
      name: 'Youth - International Appearances',
      title1: "Player's International Appearances",
    },
  },
  mediaMode: {
    borderColor: 'Border Color',
    fillColor: 'Fill Color',
    bgColor: 'Background Color',
    upperText: 'Upper Text',
    lowerText: 'Lower Text',
    socialMedia: 'Social Media',
    textColor: 'Text Color',
    axisColor: 'Axis Color',
    logo: 'Logo',
    comparisonBorderColor: 'Comparison Border Color',
    comparisonFillColor: 'Comparison Fill Color',
    comparisonUpperText: 'Comparison Upper Text',
    comparisonLowerText: 'Comparison Lower Text',
    homeFillColor: 'Home Fill Color',
    homeBorderColor: 'Home Border Color',
    awayFillColor: 'Away Fill Color',
    awayBorderColor: 'Away Border Color',
    face: 'Face',
    nationalTeam: 'National Team',
    comparisonFace: 'Comparison Face',
    upperTextX: 'Upper Text {0}',
    lowerTextX: 'Lower Text {0}',
    borderColorX: 'Border Color {0}',
    fillColorX: 'Fill Color {0}',
    homeFillColorX: 'Fill Color (Home) {0}',
    homeBorderColorX: 'Border Color (Home) {0}',
    awayFillColorX: 'Fill Color (Away) {0}',
    awayBorderColorX: 'Border Color (Away) {0}',
    faceX: 'Face {0}',
    selectField: 'Select a property',
    orientationX: 'Orientation {0}',
    searchBarPlaceholder: 'Search Players and/or Games...',
    title: 'Media Dashboard',
    pageSubtitle: 'Explore and download maps and graphics',
    chooseChart: 'Choose chart...',
    headerTextX: 'Header Text {0}',
    avatarLineLength: 'Avatar Line Length',
    avatarLineWeight: 'Avatar Line Weight',
    avatarSize: 'Avatar Size',
    chartX: 'Chart {0}',
    chartHeaderFontSize: 'Charts Header Font Size',
    chartHeaderFontWeight: 'Charts Header Font Weight',
    upperTextFontSize: 'Upper Text Font Size',
    upperTextFontWeight: 'Upper Text Font Weight',
    lowerTextFontSize: 'Lower Text Font Size',
    lowerTextFontWeight: 'Lower Text Font Weight',
    socialMediaFontSize: 'Social Media Font Size',
    socialMediaFontWeight: 'Social Media Font Weight',
    subtitle: 'Subtitle',
    subtitleFontSize: 'Subtitle Font Size',
    subtitleFontWeight: 'Subtitle Font Weight',
    subtitleX: 'Subtitle {0}',
    subtitleFontSizeX: 'Subtitle ${0} Font Size',
    subtitleFontWeightX: 'Subtitle ${0} Font Weight',
    titleX: 'Title {0}',
    titleFontSize: 'Title Font Size',
    titleFontWeight: 'Title Font Weight',
    sponsor: 'Sponsor',
    fontFamily: 'Font family',
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Scouting Reports',
      GAME_REPORT: 'Game Reports',
      MEDICAL_REPORT: 'Medical Reports',
      PHYSICAL_REPORT: 'Physical Reports',
      PSYCHOLOGICAL_REPORT: 'Psychological Reports',
      OTHER: 'Others',
      QUICK_NOTES: 'Quick Notes',
      PLAYER_REPORT: 'Player Reports',
      GENERAL_COMMENTS: 'General Comments',
      PLAYER_ANALYSIS: 'Player Analysis',
    },
    uploadDocument: 'Upload Document',
    notesPlaceholder:
      'Type descriptive notes or comments related to the document',
    notesPlaceholderAlt:
      'Type descriptive notes or comments related to the player',
    uploadedBy: 'Uploaded by',
    updatedBy: 'Updated by',
    seeNotes: 'See Notes',
    addNote: 'Add Note',
    rating: 'Rating',
    position: 'Best position',
    physical: 'Physical',
    onBall: 'On Ball',
    offBall: 'Off Ball',
    mental: 'Mental',
    potential: 'Potential',
    conclusion: 'Conclusion',
    recommendation: {
      label: 'Recommendation',
      1: 'Sign',
      2: 'Monitor',
      3: 'Discard',
      4: 'Interesting',
    },
    match: 'Match',
    deleteQuickNote: 'Delete Note',
    deleteQuickNoteMessage:
      'The note will be removed permanently. Are you sure?',
    noQuickNotes: 'No data. Start by adding some quick notes!',
    deleteDocument: 'Delete Document',
    deleteDocumentMessage:
      'The document will be removed permanently. Are you sure?',
    noDocuments: 'No data. Start by adding some documents!',
  },
  notifications: {
    newReportMessage: 'There is new message in a report',
  },
  blog: {
    subtitle: 'Latest articles, updates and news',
    newEntry: 'New Entry',
    title: 'Title',
    text: 'Text',
    link: 'Link',
    image: 'Image',
    author: 'Author',
    date: 'Release date',
    deleteEntry: 'Delete Entry',
    deleteEntryMessage: 'Are you sure you want to delete this entry?',
    readMore: 'Read more',
  },
  positionsOrlegi: {
    GK: 'Goalkeeper',
    DC: 'Defender',
    DR: 'Fullback',
    MC: 'Midfielder',
    AMC: 'Attacking Midfielder',
    FW: 'Forward',
    FWR: 'Winger',
  },
  library: {
    subtitle: 'View and share updloaded documents',
    mediaSubtitle: 'View and share exported charts',
    charts: 'Charts',
    goToLibrary: 'Go to library',
  },
  scatterPlot: {
    bubbleSize: 'Bubble Size',
    byMinutes: 'By Minutes',
    byAge: 'By Age',
    byMarketValue: 'By Market Value',
  },
  eventChart: {
    successfulEvent: 'Successful',
    unsuccessfulEvent: 'Unsuccessful',
    possessionLost: 'Successful not recovered',
    successfulPass: 'Successful Pass',
    unsuccessfulPass: 'Unsuccessful Pass',
    successfulCarry: 'Successful Carry',
    unsuccessfulCarry: 'Unsuccessful Carry',
    carryAndKeyPass: 'Carry & Key Pass',
    carryAndAssist: 'Carry & Assist',
    carryAndShot: 'Carry & Shot',
    ballProgressionAndPass: 'Ball Prog. & Pass',
    ballProgression: 'Ball Progression',
    ballProgressionAndKeyPass: 'Ball Prog. & Key Pass',
    ballProgressionAndAssist: 'Ball Prog. & Assist',
    ballProgressionAndShot: 'Ball Prog. & Shot',
    ballProgressionAndGoal: 'Ball Prog. & Goal',
    pass: 'Pass',
    carryAndPass: 'Carry & Pass',
    carryAndGoal: 'Carry & Goal',
    totalTouches: 'Total Touches',
    totalPasses: 'Total Passes',
    totalEvents: 'Total Events',
    successful: 'Successful',
    unsuccessful: 'Unsuccessful',
    tacklePossessionLost: 'Successful - Possession Lost',
    gamesSelected: '{count} games selected',
    allGamesOfSeason: 'All games of season',
    allGamesOfSeasons: 'All games of seasons',
    allEvents: 'All events',
    eventTypesCount: '{count} event types',
  },
  event: {
    Pass: 'Pass',
    TakeOn: 'Dribble',
    Takeon: 'Dribble',
    Foul: 'Foul',
    'Foul taken': 'Foul Received',
    Error: 'Error',
    Tackle: 'Tackle',
    Interception: 'Interception',
    Clearance: 'Clearance',
    MissedShot: 'Missed Shot',
    ShotOnPost: 'Shot on Post',
    SavedShot: 'Saved Shot',
    Goal: 'Goal',
    Aerial: 'Aerial',
    BallRecovery: 'Ball Recovery',
    Dispossessed: 'Dispossessed',
    ChanceMissed: 'Chance Missed',
    BallTouch: 'Ball Touch',
    BlockedPass: 'Blocked Pass',
    Challenge: 'Challenge',
    lossPossession: 'Loss of Possession',
    OffsidePass: 'Offside Pass',
    groundDuelsLost: 'Ground Duels Lost',
    'Ball touch': 'Ball Touch',
    Smother: 'Smother',
    'Keeper pickup': 'Keeper Pickup',
    'Good skill': 'Good Skill',
    Punch: 'Punch',
    'Saved shot': 'Saved Shot',
    'Shot on post': 'Shot on Post',
    'Missed shot': 'Missed Shot',
    Save: 'Save',
    'Take on': 'Take On',
    'Offside pass': 'Offside Pass',
    Claim: 'Claim',
    'Blocked pass': 'Blocked Pass',
    KeeperPickup: 'Keeper Pickup',
    'Ball recovery': 'Ball Recovery',
    'Ball Recovery': 'Ball Recovery',
    'Chance missed': 'Chance Missed',
    'Loss possession': 'Loss of Possession',
    Carries: 'Carry',
    BallProgression: 'Ball Progression',
    MissedChance: 'Missed Chance',
    Event: 'Event',
    Shot: 'Shot',
    Assist: 'Assist',
    KeyPass: 'Key Pass',
  },
  leagueTab: {
    leagueTable: 'League Table',
    matchdays: 'Matchdays',
    playerInsights: 'Player Insights',
    onlyLocalPlayers: 'Only Local Players',
    teamInsights: 'Team Insights',
    head2head: 'Head To Head',
    addNewChart: 'Add new chart',
    rounds: {
      W: 'Winner',
      F: 'Final',
      SF: 'Semi-Finals',
      QF: 'Quarter-Finals',
      16: 'Round of 16',
      32: 'Round of 32',
      GR: 'Group Stage',
      '4R': 'Fourth Round',
      '3R': 'Third Round',
      '2R': 'Second Round',
      '1R': 'First Round',
      PR: 'Preliminary Round',
      QPO1: 'Make Round of 32 Tier Below',
      QPO2: 'Qualifier Round of 16',
      QPO3: 'Qualifier Round of 32',
    },
    positions: "Positions",
    prediction: "Predictions",
    predicted: "Prediction",
    groups: "Groups",
    ranking: "Ranking",
    numberOfTeams: "Number of teams",
    statsWithMinimum: {
      message:
        'Showing only players with more than {0} {1} in the selected season',
      dribblesTotal90: 'dribbles per 90 minutes',
      crosses90: 'crosses per 90 minutes',
      tacklesAttempted90: 'tackles attempted per 90 minutes',
      aerialsTotal90: 'aerial duels per 90 minutes',
    },
    numberOfLeagues: 'Number of leagues',
    position: {
      titleWinner: 'Title winner',
      championsLeague: 'Champions League',
      qualifierChampionsLeague: 'Qualifier Champions League',
      europeLeague: 'Europe League',
      qualifierEuropeLeague: 'Qualifier Europe League',
      conferenceLeague: 'Conference League',
      qualifierConferenceLeague: 'Qualifier Conference League',
      midTable: 'Mid-table',
      relegation: 'Relegation',
      promotion: 'Promotion',
      relegationPlayoff: 'Relegation Play-off',
      promotionPlayoff: 'Promotion Play-off',
      championshipGroup: 'Championship Group',
      relegationGroup: 'Relegation Group',
      championshipPlayoffs: 'Championship Playoffs',
      preChampionshipPlayoffs2: 'Pre Championship Playoffs 2',
      preChampionshipPlayoffs3: 'Pre Championship Playoffs 3',
      playoffsQualifierBand3: 'Playoffs Qualifier Band 3',
      continentalGroup: 'Continental Group',
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'I',
      10: 'J',
      11: 'K',
      12: 'L',
    },
  },
  similarity: {
    subtitle: 'Find similar players',
    searchBarPlaceholder: 'Search and select a player to find similar',
    radarFilters: 'Radar filters',
    similarityFilters: 'Similarity filters',
    playersFilters: 'Players filters',
    similarPlayers: 'Similar Players',
    seasonWarning:
      'Only seasons are available on the Similarity tool in which the player has played more than 450 minutes',
  },
  squadBuilder: {
    subtitle: 'Sketch your unique elevens',
    playerSelector: 'Player selector',
    loadSquad: 'Load squad',
    yearsOld: 'yo.',
    playersPerPosition: 'Players per position',
    custom: 'Custom',
    removeSquad: 'Delete squad',
    removeSquadMessage: 'Are you sure you want to delete the squad?',
    deleteSquadSuccess: 'Squad has been deleted successfully',
    playerDetails: 'Player details visibility',
    ageFormat: 'Age format',
    mainPlayer: 'Main player',
    showDetails: 'Show details',
    all: 'All',
    squadPosition: 'Squad position',
    noData: 'No data. Start by adding some players in the pitch!',
  },
  tours: {
    buttons: {
      dontShowAgain: "Don't Show Again",
      skipTour: 'Skip Guided Tour',
      previous: 'Previous',
      next: 'Next',
      finish: 'Finish',
    },
    playerRadar: {
      step1: {
        title: 'PERSONAL FILE',
        message: 'Check basic player data: age, height or contract date',
      },
      step2: {
        title: 'GBE FILTER',
        message:
          'Functionality that allows to know if a player has enough GBE points to play in the UK',
      },
      step3: {
        title: 'AVAILABILITY',
        message:
          'Percentage of minutes available and percentage of minutes played',
      },
      step4: {
        title: 'POSITIONS',
        message:
          'Find out in which positions the player has played and how many minutes he has played in each position',
      },
      step5: {
        title: 'DISPLAY FORMATS',
        message:
          'Measure the performance with 4 different visualizations, Radar, Polar, Lollipop and Text, to compare it with the players in his position',
      },
      step6: {
        title: 'PERFORMANCE RADAR',
        message:
          'Here the performance is reflected visually. The panel is interactive, you can hover over each metric and get its definition',
      },
      step7: {
        title: 'SEASON SELECTION',
        message: 'Select or add seasons to measure your performance',
      },
      step8: {
        title: 'CUSTOM TEMPLATE SELECTION',
        message:
          'Use the custom templates you have created to measure the player with different metrics than the standard radar',
      },
      step9: {
        title: 'SELECTION OF POSITIONS PLAYED',
        message:
          'Check and uncheck the different positions to measure him in the position you want to measure him in',
      },
      step10: {
        title: 'SELECTION OF MINIMA AND MAXIMA',
        message:
          'Measure the player with highs and lows of his season, of the top five leagues or of the own and default season of the user account',
      },
      step11: {
        title: 'COMPARISONS',
        message:
          'Compares the player with his previous performance, with other players of his position, with the average of the position',
      },
      step12: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
    },
    playerRanking: {
      step1: {
        title: 'SEASON, SQUAD AND POSITION',
        message:
          'Select the season, squad and position to compare the player with',
      },
      step2: {
        title: 'BASIC FILTERS',
        message: 'Filter players by age, minutes played or height',
      },
      step3: {
        title: 'HIGHLIGHT AND EXCLUDE',
        message:
          'Highlight the players you want and exclude teams in the display',
      },
      step4: {
        title: 'FILTER BY CATEGORY',
        message:
          'Filter statistics by category: Association, Defending, Passing, Ball Handling, etc',
      },
      step5: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
    },
    playerFinishing: {
      step1: {
        title: 'SELECT DISPLAY',
        message:
          'You can see the finishing map in main view, goal view and in a distribution table',
      },
      step2: {
        title: 'SELECT SEASONS',
        message: 'Add seasons to measure your shooting efficiency',
      },
      step3: {
        title: 'SHOOTING LOCATION',
        message:
          'Select the possibility to see the exact location of the shot (circles) or by areas of the box and the pitch (areas)',
      },
      step4: {
        title: 'xG ON TARGET',
        message:
          'Check the boxes for xG to Goal and xG Completion to see what added value the player added after the shot',
      },
      step5: {
        title: 'SHOT TYPE',
        message: 'Filter by shot type, strategy, area or body part',
      },
      step6: {
        title: 'FILTER MINUTES',
        message:
          'Minutes bar to select shots and goals scored by specific game periods',
      },
      step7: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step8: {
        title: 'SHOOTING MAP',
        message:
          'The map is interactive. Check each circle with the mouse to find out xG for each shot',
      },
    },
    playerKeyPass: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure your shooting efficiency',
      },
      step2: {
        title: 'KEY PASS LOCATION',
        message:
          'Select the possibility to view the exact location of the key pass (circle) or by areas of the area and the field (areas)',
      },
      step3: {
        title: 'TYPE OF FINISH AFTER KEY PASS',
        message:
          'Filter by type of shot, strategy, area or body part made after key pass',
      },
      step4: {
        title: 'FILTER MINUTES',
        message:
          'Minutes bar to select shots and goals scored by specific game periods',
      },
      step5: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step6: {
        title: 'KEY PASS MAP',
        message:
          'The map is interactive. Consult each circle with the mouse to know xA of each pass',
      },
    },
    playerThreat: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure your shooting efficiency',
      },
      step2: {
        title: 'THREAT LOCATION',
        message:
          'Select the possibility to view exact location of the key pass (circle) or by area and field zones (areas)',
      },
      step3: {
        title: 'ACTION AND COMPLETION',
        message:
          'Check and uncheck according to the type of action and completion you want to display on the map',
      },
      step4: {
        title: 'MINUTES AND THREAT',
        message:
          'Filter by period, by minutes and by threat value of the actions',
      },
      step5: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step6: {
        title: 'THREAT MAP',
        message:
          'The map is interactive. Consult each circle with the mouse to find out the threat generated in each xT play of each pass',
      },
    },
    playerTouches: {
      step1: {
        title: 'GAME AND EVENT SELECTION',
        message: 'Select the game and events you want to display on the map',
      },
      step2: {
        title: 'EVENT TYPE',
        message:
          "Check and uncheck according to the defensive or offensive nature of the player's event throughout the game",
      },
      step3: {
        title: 'DISPLAY FILTER',
        message: 'Filter map by basic actions, heat map, circles or boxes',
      },
      step4: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step5: {
        title: 'TOUCHES MAP',
        message:
          'The map is interactive. You can view each event by clicking on each event',
      },
    },
    playerAllGames: {
      step1: {
        title: 'AVAILABILITY',
        message: 'Check availability and minutes played on a game by game basis',
      },
      step2: {
        title: 'POSITIONS',
        message: 'Consult the positions in which he has played in each game',
      },
    },
    playerInjuries: {
      step1: {
        title: 'HISTORY AND DAYS LOST',
        message:
          'Consult injuries of the last year or the whole history and range of injuries according to their duration in days',
      },
      step2: {
        title: 'INJURIES BY CLUB',
        message:
          'Consult the injuries separated by season and/or club of his trajectory',
      },
    },
    playerInfo: {
      step1: {
        title: 'CAREER AND TRANSFERS',
        message:
          "You can consult minutes, position or availability history with his club, with his national team and the player's transfers throughout his career",
      },
    },
    teamOverview: {
      step1: {
        title: 'TEAM SHEET',
        message:
          'Consult basic data of the team: average age, base formation, ELO or balance of transfers',
      },
      step2: {
        title: 'BASIC STATISTICS',
        message: 'Consult possession, xG, Shots, PPDA or Verticality',
      },
      step3: {
        title: 'RADAR AND SEASON',
        message:
          "Select radar, season and home or away games to measure the team's performance",
      },
      step4: {
        title: 'FILTER BY COACH AND MATCHES',
        message: 'Select performance by stage for each coach',
      },
      step5: {
        title: 'PERFOMANCE RADAR',
        message:
          'The panel is interactive, you can hover over each metric and get its definition',
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Two download formats are available: png and svg',
      },
      step7: {
        title: 'CALENDAR',
        message: "View the team's match schedule",
      },
      step8: {
        title: 'BEST PLAYERS BY METRICS',
        message:
          'In this panel you can select different metrics and see which players are the most important ones',
      },
      step9: {
        title: 'NEXT MATCH AND INJURIES',
        message:
          "Check the next opponent and the team's injured and suspended players",
      },
      step10: {
        title: 'GRAPHS AND TRENDS',
        message: 'View different graphs for the last 10 or 20 games',
      },
    },
    teamRoster: {
      step1: {
        title: 'VIEW TYPE',
        message:
          'View the squad from 6 different categories: by position, end of contract, age, availability, age profile and pitch',
      },
    },
    teamLoans: {
      step1: {
        title: 'LOAN PLAYERS',
        message:
          'Consult the players loaned to other teams and what position they play in',
      },
    },
    teamBeeswarm: {
      step1: {
        title: 'SEASON AND SQUAD',
        message:
          'Filter by season, radar squad and compare with leagues of your choice',
      },
      step2: {
        title: 'PERFORMANCE BY METRICS',
        message:
          'See where the team is in each metric compared to all the teams in the leagues previously selected',
      },
      step3: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
    },
    teamFinishingMap: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure shooting efficiency',
      },
      step2: {
        title: "OWN OR OPPONENT'S FINISHING",
        message:
          "Choose whether you want to see the team's or all its opponents' completion map",
      },
      step3: {
        title: 'SHOT PLACEMENT',
        message:
          "Select how you want to see the team's shots, by circles or by zones (boxes)",
      },
      step4: {
        title: 'SHOT TYPE',
        message: 'Filter by type of shot, strategy, area or body part',
      },
      step5: {
        title: 'FILTER MINUTES',
        message:
          'Minutes bar to select shots and goals scored by specific match periods',
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step7: {
        title: 'SHOTS MAP',
        message:
          'The map is interactive. Check each circle with the mouse to find out xG of each shot',
      },
    },
    teamKeyPassMap: {
      step1: {
        title: 'SEASON SELECTION',
        message: 'Add seasons to measure shooting efficiency',
      },
      step2: {
        title: 'OWN OR RIVAL KEY PASSES',
        message:
          'Choose if you want to see a map of key passes of the team or all its rivals',
      },
      step3: {
        title: 'KEY PASS LOCATION',
        message:
          'Select whether you want to see the exact location of the key pass (circle) or by area and field (boxes)',
      },
      step4: {
        title: 'TYPE OF FINISH AFTER PASS',
        message:
          'Filter by type of shot, strategy, area or body part made after key pass',
      },
      step5: {
        title: 'FILTER MINUTES',
        message:
          'Minutes bar to select shots and goals scored by specific match periods',
      },
      step6: {
        title: 'IMAGE DOWNLOAD FORMATS',
        message: 'Three download formats are available: png, svg and embed',
      },
      step7: {
        title: 'SHOTS MAP',
        message:
          'The map is interactive. Consult each circle with the mouse to know the xA of each pass',
      },
    },
    teamLatestGames: {
      step1: {
        title: 'LATEST GAMES',
        message:
          "Consult results, possession, xG and win % of all the team's matches",
      },
    },
    teamTransfers: {
      step1: {
        title: 'ARRIVALS',
        message:
          'Consult all arrivals (purchases + transfers) per calendar year',
      },
      step2: {
        title: 'DEPARTURES',
        message: 'Consult all departures (sales + transfers) by calendar year',
      },
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDS',
        message:
          'Query team form through streaks, wins, clean sheets, comebacks, periods with goals or types of goals',
      },
      step2: {
        title: 'SET PIECE',
        message:
          'Compare Performance of the Team beetween Set Pieces Plays and Open Plays and get a detailed overview of Set Pieces',
      },
      step3: {
        title: 'SUBSTITUTIONS',
        message:
          'See when the team makes substitutions and which players are substituted the most',
      },
      step4: {
        title: 'CONNECTIONS',
        message:
          'Consult the most common connections between players. Filter by season and type of play',
      },
      step5: {
        title: 'ATTACK ZONES',
        message:
          'Discover attacking zones of the team and filter by season or type of attack',
      },
      step6: {
        title: 'FORMATIONS',
        message:
          'Check the most used formations and their % of wins, draws and defeats with each of them',
      },
      step7: {
        title: 'SHOT ZONES',
        message:
          'Filter by season, team or opponent, way of visualizing the map, shot types or minutes',
      },
      step8: {
        title: 'CROSSES',
        message:
          'Query and filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks',
      },
      step9: {
        title: 'PLAYERS',
        message:
          'Filter by season, type of display, successful or unsuccessful, from where they start and finish or including corner kicks',
      },
    },
    teamOnOff: {
      step1: {
        title: 'SEASONS AND MATCHES',
        message: 'Filter by season, matches or by home or away games',
      },
      step2: {
        title: 'PLAYERS',
        message:
          'View the performance of all players in the squad through countless metrics',
      },
    },
  },
  alerts: {
    numPlayers: 'Number of players',
    newPlayersLastWeek: 'New players last week',
    subtitle: 'Get alerts when new players meet your search criteria',
    generalSubtitle:
      'Receive alerts on new players based on your criteria and news on your favourite players',
    subtitlePlayer: 'Get alerts when we have news about your favorite players',
    subtitleSearch: 'Get alerts when new players meet your search criteria',
    favorite: 'Favorite',
    newEventCalendar: 'New Event',
    updatedEventCalendar: 'Updated Event',
    newShareFrom: 'New share from',
    injuryAlert: 'Injury Alert',
    contractAlert: 'Contract Alert',
    teamAlert: 'Signing Alert',
    marketValueAlert: 'Market Value Alert',
    gameAlert: 'Game Played Alert',
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Full game',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Search player, game or team...',
    subtitle: 'Analyze events through video',
    successful: 'Success',
    unsuccessful: 'Fail',
    playing: 'Playing',
    games: 'Games',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Download Videos',
    zippedModalMessage:
      "We're now creating your video list and will send it to your email shortly",
    clickToSeeVideo: 'Click to see video',
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: 'You have uploaded {0} games with {1}. Your limit is {2}',
    requestedGames: 'Requested games',
    limitClose: 'Only {0} games left to request',
    limitReached:
      "You've reached your video upload limit. Uploading additional games may result in extra charges.",
    seasonFinishedWarning:
      'This will create a match in a season that has already ended. Please check that this is correct.',
    teamCountryWarning:
      'This team is from a different country to the one chosen league. Please check that this is correct.',
    uploading: 'Uploading',
    doNotNavigateAway: 'Please do not close this tab, refresh the page or navigate away while the upload is in progress.',
    severalMinutes: 'This process may take several minutes.'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: 'See all playlists',
  },
  videoHighlights: {
    recap: 'Recap',
    homeCondensed: 'Home Condensed Game',
    awayCondensed: 'Away Condensed Game',
    selectedActions: 'Selected actions',
    noActions: 'No actions matching the specified filter criteria',
    noGames: 'No games uploaded yet',
    attackingActions: 'Attacking Actions',
    defensiveActions: 'Defensive Actions',
    groundDuels: 'Ground Duels',
    penaltiesProvoked: 'Penalties Provoked',
    goalkeeperActions: 'Goalkeeper Actions',
    addSomeGames: 'Start by adding some games!',
    goToVideoUploadTool: 'Go to Video Upload Tool',
    ballInPlay: 'Ball in play',
    filterSeasons: 'Filter Seasons',
    streaming: 'Streaming',
    clips: 'Clips',
    homePlayerHighlights: 'Home player highlights',
    awayPlayerHighlights: 'Away player highlights',
    qualifiers: {
      Pass: 'Pass',
      Save: 'Save',
      'Saved Shot': 'Saved Shot',
      Shot: 'Shot',
      Goal: 'Goal',
      'Missed Shot': 'Missed Shot',
      'Shot on Post': 'Shot on Post',
      Error: 'Error',
      Clearance: 'Clearance',
      Aerial: 'Aerial',
      Challenge: 'Ground Duel Lost',
      Dispossessed: 'Dispossessed',
      Foul: 'Foul',
      Card: 'Card',
      'Offside Pass': 'Offside Pass',
      Claim: 'Cross Claimed',
      'Keeper Pickup': 'Keeper Pickup',
      'Ball Touch': 'Ball Touch',
      Dribble: 'Dribble',
      Interception: 'Interception',
      Tackle: 'Tackle',
      'Ball Recovery': 'Ball Recovery',
      Takeon: 'Dribble',
    },
    qualifierIds: {
      1: 'Long ball',
      2: 'Cross',
      5: 'Free kick taken',
      6: 'Corner taken',
      9: 'Penalty',
      15: 'Head',
      20: 'Right footed',
      21: 'Other body part',
      22: 'Regular play',
      23: 'Fast break',
      24: 'Set piece',
      25: 'From corner',
      26: 'Free kick',
      28: 'Own goal',
      29: 'Assisted',
      31: 'Yellow card',
      32: 'Second yellow card',
      33: 'Red card',
      72: 'Left footed',
      73: 'Left',
      82: 'Saved shot (no GK)',
      94: 'Def block',
      123: 'Keeper throw',
      124: 'Goal kick',
      160: 'Throw-in set piece',
      170: 'Leading to goal',
      173: 'Parried safe',
      174: 'Parried danger',
      177: 'Collected',
      178: 'Standing',
      179: 'Diving',
      182: 'Hands',
      183: 'Feet',
      185: 'Blocked cross',
      210: 'Assist',
      215: 'Individual play',
      279: 'Kick off',
      285: 'Defensive',
      286: 'Offensive',
    },
    areas: {
      goalArea: 'Goal Area',
      boxLeft: 'Box Left',
      boxCenter: 'Box Center',
      boxRight: 'Box Right',
      outBoxDeepLeft: 'Out of Box Deep Left',
      outBoxDeepRight: 'Out of Box Deep Right',
      outBoxLeft: 'Out of Box Left',
      outBoxCentreLeft: 'Out of Box Centre Left',
      outBoxCentre: 'Out of Box Centre',
      outBoxCentreRight: 'Out of Box Centre Right',
      outBoxRight: 'Out of Box Right',
      midfieldLeft35: 'Midfield Left',
      midfieldCentreLeft35: 'Midfield Centre Left',
      midfieldCentre35: 'Midfield Centre',
      midfieldCentreRight35: 'Midfield Centre Right',
      midfieldRight35: 'Midfield Right',
      ownGoalArea: 'Own Goal Area',
      ownBoxLeft: 'Own Box Left',
      ownBoxCenter: 'Own Box Center',
      ownBoxRight: 'Own Box Right',
      ownFieldOutOfBoxDeepLeft: 'Own Field Out of Box Deep Left',
      ownFieldOutOfBoxDeepRight: 'Own Field Out of Box Deep Right',
      ownFieldOutOfBoxLeft: 'Own Field Out of Box Left',
      ownFieldOutOfBoxCentreLeft: 'Own Field Out of Box Centre Left',
      ownFieldOutOfBoxCentre: 'Own Field Out of Box Centre',
      ownFieldOutOfBoxCentreRight: 'Own Field Out of Box Centre Right',
      ownFieldOutOfBoxRight: 'Own Field Out of Box Right',
      "6 YARD BOX": "Goal area",
      "BOX RIGHT": "Box right",
      "BOX CENTER": "Box center",
      "BOX LEFT": "Box left",
      "OUT BOX DEEP RIGHT": "Out box deep right",
      "OUT BOX DEEP LEFT": "Out box deep left",
      "OUT BOX RIGHT": "Out box right",
      "OUT BOX LEFT": "Out box left",
      "FINAL THIRD RIGHT": "Final third right",
      "FINAL THIRD LEFT": "Final third left",
      "FULL BOX": "Full box",
      "OUT BOX DEEP RIGHT LARGE": "Out box deep right large",
      "OUT BOX DEEP LEFT LARGE": "Out box deep left large",
      "FINAL THIRD RIGHT LARGE": "Final third right large",
      "FINAL THIRD LEFT LARGE": "Final third left large",
      "OUT BOX CENTER RIGHT": "Out box center right",
      "OUT BOX CENTER": "Out box center",
      "OUT BOX CENTER LEFT": "Out box center left",
      "FINAL THIRD CENTER RIGHT": "Final third center right",
      "FINAL THIRD CENTER": "Final third center",
      "FINAL THIRD CENTER LEFT": "Final third center left",
      "OUT BOX CENTER RIGHT SMALL": "Out box center right small",
      "OUT BOX CENTER SMALL": "Out box center small",
      "OUT BOX CENTER LEFT SMALL": "Out box center left small",
      "FINAL THIRD CENTER RIGHT LARGE": "Final third center right large",
      "FINAL THIRD CENTER LARGE": "Final third center large",
      "FINAL THIRD CENTER LEFT LARGE": "Final third center left large",
      "OWN 6 YARD BOX": "Own Goal area",
      "OWN BOX RIGHT": "Own Box right",
      "OWN BOX CENTER": "Own Box center",
      "OWN BOX LEFT": "Own Box left",
      "OWN OUT BOX DEEP RIGHT": "Own Out box deep right",
      "OWN OUT BOX DEEP LEFT": "Own Out box deep left",
      "OWN OUT BOX RIGHT": "Own Out box right",
      "OWN OUT BOX LEFT": "Own Out box left",
      "OWN FINAL THIRD RIGHT": "Own Final third right",
      "OWN FINAL THIRD LEFT": "Own Final third left",
      "OWN FULL BOX": "Own Full box",
      "OWN OUT BOX DEEP RIGHT LARGE": "Own Out box deep right large",
      "OWN OUT BOX DEEP LEFT LARGE": "Own Out box deep left large",
      "OWN FINAL THIRD RIGHT LARGE": "Own Final third right large",
      "OWN FINAL THIRD LEFT LARGE": "Own Final third left large",
      "OWN OUT BOX CENTER RIGHT": "Own Out box center right",
      "OWN OUT BOX CENTER": "Own Out box center",
      "OWN OUT BOX CENTER LEFT": "Own Out box center left",
      "OWN FINAL THIRD CENTER RIGHT": "Own Final third center right",
      "OWN FINAL THIRD CENTER": "Own Final third center",
      "OWN FINAL THIRD CENTER LEFT": "Own Final third center left",
      "OWN OUT BOX CENTER RIGHT SMALL": "Own Out box center right small",
      "OWN OUT BOX CENTER SMALL": "Own Out box center small",
      "OWN OUT BOX CENTER LEFT SMALL": "Own Out box center left small",
      "OWN FINAL THIRD CENTER RIGHT LARGE": "Own Final third center right large",
      "OWN FINAL THIRD CENTER LARGE": "Own Final third center large",
      "OWN FINAL THIRD CENTER LEFT LARGE": "Own Final third center left large"
    },
    outcomes: {
      success: 'Success',
      fail: 'Fail',
      possessionWon: 'Possession Won',
      possessionNotWon: 'Possession Not Won',
      received: 'Received',
      provoked: 'Provoked',
    },
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: 'Received',
    fromMe: 'Sent',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: 'Shared',
    subtitle: 'Overview of the items in your share list and your shares',
    selectUser: 'Select user',
    expired: 'Expired',
    limitReached: 'Link reached the uses limit',
  },
  homeStats: {
    data: 'Available Data',
    players: 'players',
    totalPlayers: 'total players',
    teams: 'teams',
    totalTeams: 'total teams',
    leagues: 'leagues',
    totalLeagues: 'total leagues',
    seasons: 'seasons',
    totalSeasons: 'total seasons',
    games: 'games',
    totalGames: 'total games',
  },
  scoutingCalendar: {
    subtitle: 'Create and organise your scouting tasks',
    myCalendars: 'Private calendar',
    publicCalendars: 'Public calendars',
    otherCalendars: 'Other calendars',
    calendarSettings: 'Calendar settings',
    moreInfo: 'More info',
    individualScouting: 'Individual Scouting',
    matchScouting: 'Match Scouting',
    calendarView: {
      type: 'Calendar type',
      month: 'Month',
      week: 'Week',
      day: 'Day',
    },
    weekView: {
      type: 'Week Type',
      monSun: 'Monday - Sunday',
      sunSat: 'Sunday - Saturday',
      monFri: 'Monday - Friday',
    },
    tasks: {
      addNew: 'Add new task',
      myTasks: 'My tasks',
      filterTasks: 'Filter tasks',
      sharedWithMe: 'Shared with me',
      createTask: 'Create task',
      newTask: 'New task',
      taskName: 'Task name',
      allDay: 'All day',
      startDate: 'Start date',
      endDate: 'End date',
      startHour: 'Start hour',
      endHour: 'End hour',
      assignedTo: 'Assignee',
      assignedToMe: 'Assigned to me',
      color: 'Color',
      scoutingType: 'Scouting type',
      taskLocation: 'Task location',
      selectLeague: 'Select league',
      selectMatch: 'Select match',
      useMatchdate: 'Use matchdate as date',
      stadium: 'Stadium',
      travel: 'Travel',
      hotel: 'Hotel',
      tickets: 'Tickets',
      taskNotes: 'Type descriptive notes or comments related to the task',
      states: {
        toDo: 'To do',
        inProgress: 'In progress',
        done: 'Done',
      },
      type: {
        player: 'Player Assessment',
        team: 'Team Assessment',
        other: 'Other',
      },
      location: {
        stadium: 'In stadium',
        video: 'Video',
      },
      accommodation: {
        accommodationDetails: 'Accommodation Details',
        ownArrangement: 'Own Arrangement',
        required: 'Required',
        notRequired: 'Not required',
        booked: 'Booked',
      },
      assignToMe: 'Assign to me',
      addOther: 'Add other',
      deleteTask: 'Delete task',
      deleteTaskMessage: 'Task will be removed, are you sure?',
      cancelUpdate: 'Cancel update',
      cancelUpdateMessage: 'Changes will not be saved, are you sure?',
      selectGame: 'Please, select a match to add files',
      noData: 'No data. Start by adding some tasks!',
      widgetSubtitle: 'Check out your next tasks',
      scoutingDetails: 'Scouting details',
      taskDetails: 'Task details',
      playerDocuments: 'Player documents',
      teamDocuments: 'Team documents',
      gameDocuments: 'Game documents',
      taskDocuments: 'Task documents',
      task: 'Task',
    },
    nextGames: 'Next games',
  },
  scoutingTasksBoard: {
    period: {
      week: 'This week',
      month: 'This month',
      year: 'This year',
    },
    noTasks: 'Create new tasks or drag one here!',
    goToBoard: 'Go to board',
  },
  profile: {
    title: 'Profile',
    subtitle: 'Customize your account and subscription details',
  },
  hub: {
    onlyHub: 'Only available in Driblab Hub',
    blue: 'blue',
    purple: 'purple',
    orange: 'orange',
    grey: 'grey',
    indigo: 'indigo',
    teal: 'teal',
    lightBlue: 'light blue',
    brown: 'brown'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: 'Go To Uploaded Games',
    sla: 'Server Level Agreement',
    matchDate: 'Match Date',
    rejectedGame: 'Rejected',
    reviewed: 'Reviewed',
    requested: 'Requested',
    koraStatus: 'Kora Status',
    aws: 'AWS',
    fullVideo: 'Full Video',
    offset: 'Offset',
    updateFullVideo: 'Update Full Video?'
  },
  gameMap: {
    title: 'Map of Games',
    subtitle: 'Explore the matches for the next days',
    warning:
      'The time and place may not be correct. Please confirm this information.',
    taskAdded: 'Task successfully created. Check the Scouting Calendar.',
  },
  leagueRequestAccess: {
    sendSuccess: 'Successfully notified',
    notPermissions: 'You do not have permissions to see',
    notPermissionsLeague: 'You do not have permissions to see this league',
    notPermissionsGame: 'You do not have permissions to see this game',
    requestAccessTo: 'Request access to',
    sendRequest: 'Send Request',
  },
  videoTeams: {
    subtitle: 'Find the latest matches tagged by team',
    noGamesUploaded: 'No games uploaded yet',
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting Analysis',
    scoutingAnalyses: 'Scouting Analyses',
    playerScoutingAnalyses: 'Player Scouting Analyses',
    gameScoutingAnalyses: 'Game Scouting Analyses',
    analyses: 'Analyses',
    addReport: 'Add analysis',
    technical: 'Technical',
    tactical: 'Tactical',
    physical: 'Physical',
    mental: 'Mental',
    technicalNotes: 'Technical notes',
    tacticalNotes: 'Tactical notes',
    physicalNotes: 'Physical notes',
    mentalNotes: 'Mental notes',
    conclusion: 'Conclusion',
    charactersMax: 'Max 1000 characters',
    globalRating: 'Global rating',
    noData: 'No data. Start by adding some scouting analyses!',
    deleteAnalysis: 'Delete Scouting Analysis',
    deleteAnalysisMessage:
      'The analysis will be removed permanently. Are you sure?',
    avgTooltip: 'Average based on final ratings of analyses visible to you',
    avgPotentialTooltip: 'Average based on potential of analyses visible to you',
    avgOverallScoreTooltip:
      "Average based on player's overall scores visible to you",
    scouter: 'Scout',
    lastEdited: 'Last edited',
    analysisFilters: 'Analysis Filters',
    generalFilters: 'General Filters',
    widgetSubtitle: 'Latest analyses added',
    addPlayerReport: 'Add Player Scouting Analysis',
    seeReports: 'See reports',
    addGameReport: 'Add Game Scouting Analysis',
    keyPlayers: 'Key players',
    formation: 'Formation',
    inPossession: 'In Possession',
    notesIP: 'In Possession notes',
    outOfPossession: 'Out of Possession',
    notesOP: 'Out of Possession notes',
    transitions: 'Transitions',
    notesTransitions: 'Transitions notes',
    notesSP: 'Set Piece notes',
    finalRating: 'Final rating',
    gameNotesPlaceholder:
      'Type descriptive notes or comments related to the match',
    potential: 'Potential',
    tags: 'Tags',
    tagsPlaceholder: 'Add some tags',
    tagsHint: 'Type and press Enter to add a tag',
    exampleTags: {
      leadership: 'Leadership',
      resilience: 'Resilience',
      competitiveMindset: 'Competitive mindset',
      calmUnderPressure: 'Calm under pressure',
      focus: 'Focus',
      discipline: 'Discipline',
      coachability: 'Coachability',
      poorBodyLanguage: 'Poor body language',
      lowConfidence: 'Low confidence',
      easilyFrustrated: 'Easily frustrated',
    }
  },
  addPlayerForm: {
    noLeague:
      'Creating a team without league can have a negative effect on its indexing and subsequent search within the application.',
  },
  expenses: {
    expense: 'Expense',
    expenses: 'Expenses',
    addExpense: 'Add expense',
    transportation: 'Transportation',
    accommodation: 'Accommodation',
    dietary: 'Dietary',
    eventTicket: 'Event ticket',
    expenseType: 'Expense type',
    amount: 'Amount',
    expenseDate: 'Expense date',
    expenseFilters: 'Expense filters',
    noData: 'No data. Start by adding some expenses!',
    deleteExpense: 'Delete Expense',
    deleteExpenseMessage:
      'The expense will be removed permanently. Are you sure?',
  },
  disabledTooltips: {
    general: 'This feature is currently disabled',
    youth: 'It must be youth to set an age',
    unit: 'Stat must be Runs, HSR or SPR',
    seasonsWithout60MinsGames:
      "Player hasn't played more than 60 minutes in a single match in the selected season(s)",
    notEditable: 'This cannot be edited',
    noMatchdate: 'Matchdate unavailable',
    selectGame: 'Select a game first',
    selectPlayer: 'Select a player first',
    selectTeam: 'Select a team first',
    selectBoxes: 'Boxes visualization must be selected',
    selectYear: 'Select a year first',
    pdScoreNotAvailable:
      'Score unavailable for players who have not reached 60 minutes of play within a match',
    pdSeasonNotAvailable: 'Physical data is not available for this season',
    pdGameNotAvailable: 'Physical data is not available for this game',
  },
  leagueTypes: {
    regular: 'Regular',
    continental: 'Continental',
    nationalTeam: 'National Team',
    countryCup: 'Country Cup',
    qualifier: 'Qualifier',
    playOff: 'Play-Off',
    regionalLeague: 'Regional League',
    friendly: 'Friendly',
    nationalFriendly: 'National Friendly',
    nationaQualifier: 'National Qualifier',
  },
  playerSides: {
    'Left/Right': 'Left/Right',
    'Left/Centre/Right': 'Left/Centre/Right',
    Right: 'Right',
    Centre: 'Centre',
    'Centre/Right': 'Centre/Right',
    Left: 'Left',
    'Left/Centre': 'Left/Centre',
  },
  areaSelector: {
    selectAreas: 'Select areas',
    filterAreas: 'Filter areas',
  },
  spatialCoverage: {
    lastDefenderDist: 'Last defender distance',
    defensiveLineDist: 'Defensive line distance',
    fullBackAvgDist: 'Fullback average distance',
    offensiveLineDist: 'Offensive line distance',
    distanceToGoal: 'Distance to goal',
    avgLineWidth: 'Avg. line width',
    leagueAvgDistanceToGoal: 'Avg. league distance to goal',
    leagueAvgLineWidth: 'Avg. league line width',
    avgShort: 'Avg.',
    meters: 'meters',
    leagueAvgDist: 'Avg. league distance',
    distance: 'Distance',
    avgPositionYAxis: 'Avg. distance on pitch (Y)',
    leagueAvgPositionYAxis: 'Avg. league distance on pitch (Y)',
    lbRbDistanceSeparation: 'LB–RB distance',
    leagueAvgLbRbDistanceSeparation: 'Avg. league LB–RB distance',
    legendTeam: 'Team',
    legendLeagueAvg: 'League Avg.',
    maxLength: 'Max Length',
    maxWidth: 'Max Width',
    avgBlockDistance: 'Avg. block distance'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Intelligent Data',
    passesUnderPressureSubtitle: 'Analyze the success rate of passes made under defensive pressure',
    onBallPressureSubtitle: 'Analyze defensive pressure events and their success rate',
    ballReceiptsInSpaceSubtitle: 'Analyze passes received in space by field zone',
    ballReceipts: 'receipts',
    totalBallReceipts: 'Total Ball Receipts',
    totalBallReceiptsCompleted: 'Total Ball Receipts Completed',
    completed: 'Completed',
    lineBreakingPassesSubtitle: 'Analyze the passes that break lines and create advantages',
    offBallRunSubtitle: 'Analyze off ball runs',
    bypassed: 'Outplay',
    oppsBypassed: 'Opponents Outplayed',
    passer: 'Passer',
    passedTo: 'Pass to',
    receivedFrom: 'Received from',
    distanceToNearestDefender: 'Distance to nearest defender',
    lineBreaking: 'Line Breaking {0}',
    keyPass: 'Key Pass',
    receiver: 'Receiver',
    dynamicTracking: 'Dynamic Tracking',
    eventLockTooltip: 'Some players were not visible during the play',
    bypassedPlayers: "{0} outplayed players",
    playersCount: '{0} players',
    bothTeams: 'Both teams',
    matchesCount: '{0} matches',
    passType: {
      P: 'Pass',
      A: 'Assist',
      KP: 'Key Pass',
      PiOB: 'Pass into Opp. Box',
      PiFT: 'Pass into Final Third',
      SoPP: 'Switch of Play Pass',
    },
    lbpType: {
      F: 'Front line',
      M: 'Middle line',
      B: 'Back line',
      MF: 'Middle & Front lines',
      BM: 'Back & Middle lines',
      BF: 'Back & Front lines',
      BMF: 'Back, Middle & Front lines',
    },
    lbpCategory: {
      'G-IN-T': 'Ground Inside (breaking defensive line)',
      'G-IN-NT': 'Ground Inside (not breaking defensive line)',
      'G-OUT-T': 'Ground Outside (breaking defensive line)',
      'G-OUT-NT': 'Ground Outside (not breaking defensive line)',
      'O-IN-T': 'Over Inside (breaking defensive line)',
      'O-IN-NT': 'Over Inside (not breaking defensive line)',
      'O-OUT-T': 'Over Outside (breaking defensive line)',
      'O-OUT-NT': 'Over Outside (not breaking defensive line)',
      ground: 'Ground',
      over: 'Over',
      inside: 'Inside',
      outside: 'Outside',
      through: 'Breaking defensive line',
      notThrough: 'Not breaking defensive line',
      throughAbbr: 'Breaking def. line',
      notThroughAbbr: 'Not breaking def. line'
    },
    lbpCategorySplit: {
      G: 'Ground: The pass was ground',
      O: 'Over: The ball was chipped into the air',
      OUT: 'Outside: The pass went outside',
      IN: 'Inside: The pass went inside',
      T: 'Breaking defensive line: The pass breaks the defensive line from inside',
      NT: 'Not breaking defensive line: The pass does not break the defensive line from inside; it goes around from the outside instead',
    },
    obrType: {
      OL: 'Overlap',
      UL: 'Underlap',
      RA: 'Run Ahead',
      RB: 'Run Behind',
      CR: 'Cross Receiver',
      SP: 'Support',
      CS: 'Coming Short',
    },
    visualization: 'Visualization',
    points: 'Circles',
    zones: 'Heat Map',
    pressureIntensity: 'Pressure Intensity',
    pressureOutcome: 'Pressure Outcome',
    passesOutcome: 'Passes Outcome',
    strong: 'Strong',
    light: 'Light',
    normal: 'Normal',
    successful: 'Successful',
    unsuccessful: 'Unsuccessful',
    passer: 'Passer',
    presses: 'presses',
    passes: 'Passes',
    passUnder: 'Pass Under',
    successRate: 'Success Rate',
    pressureOn: 'Pressure on',
    pressureOf: 'Pressure of',
    pressure: 'Pressure',
    totalLabel: 'Total',
    totalPasses: 'Total Passes',
    unknown: 'Unknown',
    selectGameToViewMap: 'Select a game to view pressure map',
    noEventsFoundForGame: 'No pressure events found for this game',
    noEventsFoundForTeamAndSeason: 'No pressure events found for this team and season',
    noEventsFoundForPlayerAndSeason: 'No pressure events found for this player and season',
    noEventsMatchFilters: 'No events match the current filters',
    totalEventsAvailable: 'total events available',
    minFrom: 'Min From',
    minTo: 'Min To',
    secondFrom: 'Seg From',
    secondTo: 'Seg To',
    positionPlayed: 'Position Played',
    highlight: 'Highlight',
    passTypeLabel: 'Pass Type',
    pressurePassTypeLabel: 'Pressure On Pass Type',
    insights: 'Insights',
    insightsSubtitle: 'Ranking the Best with Advanced Arrigo Analytics'
  },
  driblabAI: {
    chatText: 'How can I help you today?',
    chatSubtext: 'Ask anything about football data!',
    thinking: 'Thinking...',
    giveFeedback: 'Give Feedback',
    disclaimer: 'DriblabAI can make mistakes. Please, make sure to verify the information.',
    recent: 'Recent',
    noConversations: 'Here you will see your recent conversations!',
    rename: 'Rename',
    deleteConversation: 'Delete conversation',
    confirmDelete: 'Are you sure you want to delete this conversation?',
    feedback: 'Feedback',
    feedbackQuestion: 'Was this response helpful?',
    feedbackComments: 'Additional comments',
    feedbackPlaceholder: 'Tell us what was helpful or what could be improved...',
    errorMessage: 'The message could not be processed. Please try again.',
    newConversation: 'New Chat',
    write: 'Write a message...',
  },
  periodId:{
    '-1': "Other",
    1: "First Half",
    2: "Second Half",
    3: "Extra Time - 1º",
    4: "Extra Time - 2º",
    5: "Penalty Shootout",
    6: "Full Time",
    8: "Abandoned",
    9: "Live",
    7: "Pre Match",
    10: "0-15",
    11: "16-30",
    12: "31+",
    13: "45-60",
    14: "61-75",
    15: "76+"
  }
};


// WEBPACK FOOTER //
// ./src/utils/translations/en.js